import n, {
  useState as e,
  useRef as t,
  useEffect as r,
  createContext as o,
  useContext as a,
  useLayoutEffect as i,
  useCallback as d,
  useMemo as l,
} from 'react';
import u, { keyframes as s, css as c, withTheme as f } from 'styled-components';
import m from 'react-dom';
function p(n, e) {
  void 0 === e && (e = {});
  var t = e.insertAt;
  if (n && 'undefined' != typeof document) {
    var r = document.head || document.getElementsByTagName('head')[0],
      o = document.createElement('style');
    (o.type = 'text/css'),
      'top' === t && r.firstChild
        ? r.insertBefore(o, r.firstChild)
        : r.appendChild(o),
      o.styleSheet
        ? (o.styleSheet.cssText = n)
        : o.appendChild(document.createTextNode(n));
  }
}
p(
  "@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700&family=Poppins:wght@300;400;500;700;900&display=swap');",
);
p(
  "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n     ========================================================================== */\n\n/**\n   * Remove the margin in all browsers.\n   */\n\nbody {\n  margin: 0;\n}\n\n/**\n   * Render the `main` element consistently in IE.\n   */\n\nmain {\n  display: block;\n}\n\n/**\n   * Correct the font size and margin on `h1` elements within `section` and\n   * `article` contexts in Chrome, Firefox, and Safari.\n   */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n     ========================================================================== */\n\n/**\n   * 1. Add the correct box sizing in Firefox.\n   * 2. Show the overflow in Edge and IE.\n   */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n     ========================================================================== */\n\n/**\n   * Remove the gray background on active links in IE 10.\n   */\n\na {\n  background-color: transparent;\n}\n\n/**\n   * 1. Remove the bottom border in Chrome 57-\n   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n   */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n   * Add the correct font weight in Chrome, Edge, and Safari.\n   */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n   * Add the correct font size in all browsers.\n   */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n   * Prevent `sub` and `sup` elements from affecting the line height in\n   * all browsers.\n   */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n     ========================================================================== */\n\n/**\n   * Remove the border on images inside links in IE 10.\n   */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n     ========================================================================== */\n\n/**\n   * 1. Change the font styles in all browsers.\n   * 2. Remove the margin in Firefox and Safari.\n   */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n   * Show the overflow in IE.\n   * 1. Show the overflow in Edge.\n   */\n\nbutton,\ninput {\n  /* 1 */\n  overflow: visible;\n}\n\n/**\n   * Remove the inheritance of text transform in Edge, Firefox, and IE.\n   * 1. Remove the inheritance of text transform in Firefox.\n   */\n\nbutton,\nselect {\n  /* 1 */\n  text-transform: none;\n}\n\n/**\n   * Correct the inability to style clickable types in iOS and Safari.\n   */\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button;\n}\n\n/**\n   * Remove the inner border and padding in Firefox.\n   */\n\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n   * Restore the focus styles unset by the previous rule.\n   */\n\nbutton:-moz-focusring,\n[type='button']:-moz-focusring,\n[type='reset']:-moz-focusring,\n[type='submit']:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n   * Correct the padding in Firefox.\n   */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n   * 1. Correct the text wrapping in Edge and IE.\n   * 2. Correct the color inheritance from `fieldset` elements in IE.\n   * 3. Remove the padding so developers are not caught out when they zero out\n   *    `fieldset` elements in all browsers.\n   */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n   * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n   */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n   * Remove the default vertical scrollbar in IE 10+.\n   */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n   * 1. Add the correct box sizing in IE 10.\n   * 2. Remove the padding in IE 10.\n   */\n\n[type='checkbox'],\n[type='radio'] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n   * Correct the cursor style of increment and decrement buttons in Chrome.\n   */\n\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n   * 1. Correct the odd appearance in Chrome and Safari.\n   * 2. Correct the outline style in Safari.\n   */\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n   * Remove the inner padding in Chrome and Safari on macOS.\n   */\n\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * 1. Correct the inability to style clickable types in iOS and Safari.\n   * 2. Change font properties to `inherit` in Safari.\n   */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n     ========================================================================== */\n\n/*\n   * Add the correct display in Edge, IE 10+, and Firefox.\n   */\n\ndetails {\n  display: block;\n}\n\n/*\n   * Add the correct display in all browsers.\n   */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n     ========================================================================== */\n\n/**\n   * Add the correct display in IE 10+.\n   */\n\ntemplate {\n  display: none;\n}\n\n/**\n   * Add the correct display in IE 10.\n   */\n\n[hidden] {\n  display: none;\n}\n",
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var $ = function (n, e) {
  return ($ =
    Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array &&
      function (n, e) {
        n.__proto__ = e;
      }) ||
    function (n, e) {
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
    })(n, e);
};
function h(n, e) {
  if ('function' != typeof e && null !== e)
    throw new TypeError(
      'Class extends value ' + String(e) + ' is not a constructor or null',
    );
  function t() {
    this.constructor = n;
  }
  $(n, e),
    (n.prototype =
      null === e ? Object.create(e) : ((t.prototype = e.prototype), new t()));
}
var g = function () {
  return (g =
    Object.assign ||
    function (n) {
      for (var e, t = 1, r = arguments.length; t < r; t++)
        for (var o in (e = arguments[t]))
          Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
      return n;
    }).apply(this, arguments);
};
function y(n, e) {
  var t = {};
  for (var r in n)
    Object.prototype.hasOwnProperty.call(n, r) &&
      e.indexOf(r) < 0 &&
      (t[r] = n[r]);
  if (null != n && 'function' == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(n); o < r.length; o++)
      e.indexOf(r[o]) < 0 &&
        Object.prototype.propertyIsEnumerable.call(n, r[o]) &&
        (t[r[o]] = n[r[o]]);
  }
  return t;
}
function b(n, e, t, r) {
  return new (t || (t = Promise))(function (o, a) {
    function i(n) {
      try {
        l(r.next(n));
      } catch (n) {
        a(n);
      }
    }
    function d(n) {
      try {
        l(r.throw(n));
      } catch (n) {
        a(n);
      }
    }
    function l(n) {
      var e;
      n.done
        ? o(n.value)
        : ((e = n.value),
          e instanceof t
            ? e
            : new t(function (n) {
                n(e);
              })).then(i, d);
    }
    l((r = r.apply(n, e || [])).next());
  });
}
function v(n, e) {
  var t,
    r,
    o,
    a,
    i = {
      label: 0,
      sent: function () {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: [],
    };
  return (
    (a = { next: d(0), throw: d(1), return: d(2) }),
    'function' == typeof Symbol &&
      (a[Symbol.iterator] = function () {
        return this;
      }),
    a
  );
  function d(a) {
    return function (d) {
      return (function (a) {
        if (t) throw new TypeError('Generator is already executing.');
        for (; i; )
          try {
            if (
              ((t = 1),
              r &&
                (o =
                  2 & a[0]
                    ? r.return
                    : a[0]
                    ? r.throw || ((o = r.return) && o.call(r), 0)
                    : r.next) &&
                !(o = o.call(r, a[1])).done)
            )
              return o;
            switch (((r = 0), o && (a = [2 & a[0], o.value]), a[0])) {
              case 0:
              case 1:
                o = a;
                break;
              case 4:
                return i.label++, { value: a[1], done: !1 };
              case 5:
                i.label++, (r = a[1]), (a = [0]);
                continue;
              case 7:
                (a = i.ops.pop()), i.trys.pop();
                continue;
              default:
                if (
                  !((o = i.trys),
                  (o = o.length > 0 && o[o.length - 1]) ||
                    (6 !== a[0] && 2 !== a[0]))
                ) {
                  i = 0;
                  continue;
                }
                if (3 === a[0] && (!o || (a[1] > o[0] && a[1] < o[3]))) {
                  i.label = a[1];
                  break;
                }
                if (6 === a[0] && i.label < o[1]) {
                  (i.label = o[1]), (o = a);
                  break;
                }
                if (o && i.label < o[2]) {
                  (i.label = o[2]), i.ops.push(a);
                  break;
                }
                o[2] && i.ops.pop(), i.trys.pop();
                continue;
            }
            a = e.call(n, i);
          } catch (n) {
            (a = [6, n]), (r = 0);
          } finally {
            t = o = 0;
          }
        if (5 & a[0]) throw a[1];
        return { value: a[0] ? a[1] : void 0, done: !0 };
      })([a, d]);
    };
  }
}
function x(n, e) {
  return (
    Object.defineProperty
      ? Object.defineProperty(n, 'raw', { value: e })
      : (n.raw = e),
    n
  );
}
var C = {
    color: void 0,
    size: void 0,
    className: void 0,
    style: void 0,
    attr: void 0,
  },
  w = n.createContext && n.createContext(C),
  E = function () {
    return (E =
      Object.assign ||
      function (n) {
        for (var e, t = 1, r = arguments.length; t < r; t++)
          for (var o in (e = arguments[t]))
            Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
        return n;
      }).apply(this, arguments);
  },
  N = function (n, e) {
    var t = {};
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) &&
        e.indexOf(r) < 0 &&
        (t[r] = n[r]);
    if (null != n && 'function' == typeof Object.getOwnPropertySymbols) {
      var o = 0;
      for (r = Object.getOwnPropertySymbols(n); o < r.length; o++)
        e.indexOf(r[o]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(n, r[o]) &&
          (t[r[o]] = n[r[o]]);
    }
    return t;
  };
function P(e) {
  return (
    e &&
    e.map(function (e, t) {
      return n.createElement(e.tag, E({ key: t }, e.attr), P(e.child));
    })
  );
}
function S(e) {
  return function (t) {
    return n.createElement(O, E({ attr: E({}, e.attr) }, t), P(e.child));
  };
}
function O(e) {
  var t = function (t) {
    var r,
      o = e.attr,
      a = e.size,
      i = e.title,
      d = N(e, ['attr', 'size', 'title']),
      l = a || t.size || '1em';
    return (
      t.className && (r = t.className),
      e.className && (r = (r ? r + ' ' : '') + e.className),
      n.createElement(
        'svg',
        E(
          { stroke: 'currentColor', fill: 'currentColor', strokeWidth: '0' },
          t.attr,
          o,
          d,
          {
            className: r,
            style: E(E({ color: e.color || t.color }, t.style), e.style),
            height: l,
            width: l,
            xmlns: 'http://www.w3.org/2000/svg',
          },
        ),
        i && n.createElement('title', null, i),
        e.children,
      )
    );
  };
  return void 0 !== w
    ? n.createElement(w.Consumer, null, function (n) {
        return t(n);
      })
    : t(C);
}
function k(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z',
        },
      },
    ],
  })(n);
}
function I(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z',
        },
      },
    ],
  })(n);
}
function T(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z',
        },
      },
    ],
  })(n);
}
function A(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 576 512' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z',
        },
      },
    ],
  })(n);
}
function R(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z',
        },
      },
    ],
  })(n);
}
function B(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z',
        },
      },
    ],
  })(n);
}
function M(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 352 512' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z',
        },
      },
    ],
  })(n);
}
var F,
  D,
  L,
  j = {
    black: '#1c1917',
    white: '#f8f7f6',
    grey100: '#f5f5f4',
    grey200: '#e7e5e4',
    grey300: '#d6d3d1',
    grey400: '#a8a29e',
    grey500: '#78716c',
    grey600: '#57534e',
    grey700: '#44403c',
    grey800: '#292524',
    grey900: '#1c1917',
    success100: '#ebf9f1',
    success200: '#afe6c7',
    success300: '#74d49c',
    success400: '#38c172',
    success500: '#2d9a5b',
    success600: '#227444',
    success700: '#113a22',
    warning100: '#fefaf0',
    warning200: '#fbeac1',
    warning300: '#f7da93',
    warning400: '#f4ca64',
    warning500: '#c3a250',
    warning600: '#7a6532',
    warning700: '#312814',
    error100: '#fceaea',
    error200: '#f1acac',
    error300: '#e76e6e',
    error400: '#dc3030',
    error500: '#b02626',
    error600: '#841d1d',
    error700: '#420e0e',
    fontSizeHeader: '1.5rem',
    fontSizeLarge: '1.25rem',
    fontSizeBase: '1rem',
    fontSizeSmall: '0.875rem',
    fontSizeExtraSmall: '0.75rem',
    fontHeader: 'Poppins, sans-serif',
    fontBody: 'Open Sans, sans-serif',
  },
  z = g(g({}, j), {
    primary800: '#301d00',
    primary700: '#794801',
    primary600: '#c17201',
    primary500: '#f18f01',
    primary400: '#f5b14d',
    primary300: '#f8c780',
    primary200: '#fbddb3',
    primary100: '#fef4e6',
    secondary100: '#e6eff6',
    secondary200: '#b3cfe4',
    secondary300: '#669fca',
    secondary400: '#337fb8',
    secondary500: '#005fa6',
    secondary600: '#004c85',
    secondary700: '#004374',
    secondary800: '#003053',
    secondary900: '#001c32',
  }),
  G = {
    alertSuccessText: z.success700,
    alertSuccessBorder: z.success400,
    alertSuccessBg: z.success100,
    alertErrorText: z.error700,
    alertErrorBorder: z.error400,
    alertErrorBg: z.error100,
    alertWarningText: z.warning700,
    alertWarningBorder: z.warning400,
    alertWarningBg: z.warning100,
    alertInfoText: z.secondary800,
    alertInfoBorder: z.secondary400,
    alertInfoBg: z.secondary200,
  },
  _ = {
    btnBg: z.primary500,
    btnBgDisabled: z.primary200,
    btnBgHover: z.primary600,
    btnText: z.white,
    btnTextDisabled: z.primary400,
    btnGhost: z.black,
    btnGhostHover: z.grey400,
    btnGhostDisabled: z.grey700,
    btnLink: z.secondary300,
    btnLoaderBg: z.white,
    btnLoader: z.primary400,
  },
  V = {
    formHeaderText: z.black,
    formGroupText: z.primary500,
    formGroupTextError: z.error400,
    formGroupInput: z.black,
    formGroupInputActive: z.primary500,
    formGroupBorder: 'rgba(0, 0, 0, 0.25)',
    formGroupBorderError: z.error400,
    formGroupBg: 'transparent',
    formGroupBgDisabled: z.grey300,
    formGroupFocusBorder: z.primary500,
    formGroupFocusGlow: z.primary200,
    eyeColour: 'rgba(255, 255, 255, 0.33)',
    eyeColourHover: 'rgba(255, 255, 255, 1)',
  },
  H = {
    loaderSpin: z.primary400,
    loaderSpinBg: 'rgba(0, 0, 0, 0.1) ',
    loaderTextColour: z.black,
  },
  U = {
    phoneInputBg: 'transparent',
    phoneInputBgDisabled: z.grey200,
    phoneInputBorder: 'rgba(0, 0, 0, 0.25)',
    phoneInputText: z.black,
    phoneInputListBg: 'white',
    phoneInputListText: z.black,
    phoneInputListHover: z.primary300,
    phoneInputListHighlight: z.primary600,
    phoneInputListHighlightText: z.white,
  },
  q = {
    menuBgColour: z.black,
    menuItemActive: z.primary400,
    menuItemColour: z.grey300,
    menuItemHover: z.primary200,
    menuButtonColour: z.white,
    menuDivider: z.grey300,
    menuShadow: '5px 5px 10px #e8e8e8, -5px -5px 10px #ffffff',
    menuDropdownBg: z.white,
    menuDropdownText: z.black,
    menuDropdownTextHover: z.primary600,
    menuDropdownTextActive: z.primary400,
    menuMobileBg: z.black,
    menuMobileWidth: '250px',
    menuHamburgerColorActive: z.white,
    menuHamburgerColor: z.white,
  },
  W = { modalBg: z.white, modalCloseBg: z.white, modalCloseText: z.black },
  K = {
    stepsColour: z.primary400,
    stepsTextColour: z.black,
    stepsDisabledColour: z.grey200,
    stepsDividerColour: z.grey200,
  },
  Y = {
    tableBodyBg: 'white',
    tableHeaderBg: z.primary400,
    tableHeaderText: z.grey400,
  },
  Z = { fontColour: z.black, editText: z.grey600 },
  J = g(g(g(g(g(g(g(g(g(g(g({}, z), G), _), V), H), q), W), U), K), Y), Z),
  X = u.div(
    F ||
      (F = x(
        [
          '\n  font-family: ',
          ';\n  font-size: 0.9rem;\n  padding: 1rem 0.75rem;\n',
        ],
        [
          '\n  font-family: ',
          ';\n  font-size: 0.9rem;\n  padding: 1rem 0.75rem;\n',
        ],
      )),
    function (n) {
      return n.theme.fontHeader;
    },
  ),
  Q = u.div(
    D ||
      (D = x(
        [
          '\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 1rem;\n\n  min-width: 28px;\n  width: 28px;\n',
        ],
        [
          '\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 1rem;\n\n  min-width: 28px;\n  width: 28px;\n',
        ],
      )),
  ),
  nn = u.div(
    L ||
      (L = x(
        [
          '\n  display: flex;\n\n  background-color: #d3d3d3;\n\n  ',
          ' {\n    color: white;\n    background-color: #343434;\n  }\n\n  ',
          ' {\n    color: #454545;\n  }\n\n  &.success {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n\n  &.error {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n\n  &.warning {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n\n  &.info {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n',
        ],
        [
          '\n  display: flex;\n\n  background-color: #d3d3d3;\n\n  ',
          ' {\n    color: white;\n    background-color: #343434;\n  }\n\n  ',
          ' {\n    color: #454545;\n  }\n\n  &.success {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n\n  &.error {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n\n  &.warning {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n\n  &.info {\n    background-color: ',
          ';\n    ',
          ' {\n      color: white;\n      background-color: ',
          ';\n    }\n    ',
          ' {\n      color: ',
          ';\n    }\n  }\n',
        ],
      )),
    Q,
    X,
    function (n) {
      return n.theme.alertSuccessBg;
    },
    Q,
    function (n) {
      return n.theme.alertSuccessBorder;
    },
    X,
    function (n) {
      return n.theme.alertSuccessText;
    },
    function (n) {
      return n.theme.alertErrorBg;
    },
    Q,
    function (n) {
      return n.theme.alertErrorBorder;
    },
    X,
    function (n) {
      return n.theme.alertErrorText;
    },
    function (n) {
      return n.theme.alertWarningBg;
    },
    Q,
    function (n) {
      return n.theme.alertWarningBorder;
    },
    X,
    function (n) {
      return n.theme.alertWarningText;
    },
    function (n) {
      return n.theme.alertInfoBg;
    },
    Q,
    function (n) {
      return n.theme.alertInfoBorder;
    },
    X,
    function (n) {
      return n.theme.alertInfoText;
    },
  );
(X.defaultProps = { theme: { fontHeader: j.fontHeader } }),
  (nn.defaultProps = { theme: J });
var en,
  tn,
  rn,
  on,
  an = function (e) {
    var t = e.className,
      r = e.success,
      o = e.error,
      a = e.warning,
      i = e.info,
      d = e.icon,
      l = e.children,
      u = y(e, [
        'className',
        'success',
        'error',
        'warning',
        'info',
        'icon',
        'children',
      ]),
      s = '',
      c = null;
    return (
      r
        ? ((s = 'success'), (c = n.createElement(k, null)))
        : o
        ? ((s = 'error'), (c = n.createElement(B, null)))
        : a
        ? ((s = 'warning'), (c = n.createElement(A, null)))
        : i && ((s = 'info'), (c = n.createElement(T, null))),
      d && (c = d),
      n.createElement(
        nn,
        g({ className: (t || '') + ' ' + s }, u),
        n.createElement(Q, null, c),
        n.createElement(X, null, l),
      )
    );
  },
  dn = s(
    en ||
      (en = x(
        [
          '\n0% {\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n100% {\n  -webkit-transform: rotate(360deg);\n  transform: rotate(360deg);\n}\n',
        ],
        [
          '\n0% {\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n100% {\n  -webkit-transform: rotate(360deg);\n  transform: rotate(360deg);\n}\n',
        ],
      )),
  ),
  ln = u.div(
    tn ||
      (tn = x(
        [
          '\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n',
        ],
        [
          '\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n',
        ],
      )),
  ),
  un = u.div(
    rn ||
      (rn = x(
        [
          '\n  display: inline-block;\n  margin: 0px auto;\n  font-size: 10px;\n  position: relative;\n  animation: ',
          ' 1.1s infinite linear;\n\n  border-top: ',
          ' solid ',
          ';\n  border-right: ',
          ' solid ',
          ';\n  border-bottom: ',
          ' solid ',
          ';\n  border-left: ',
          ' solid ',
          ';\n\n  border-radius: 50%;\n  width: ',
          ';\n  height: ',
          ';\n  max-width: ',
          ';\n  max-height: ',
          ';\n  min-width: ',
          ';\n  min-height: ',
          ';\n',
        ],
        [
          '\n  display: inline-block;\n  margin: 0px auto;\n  font-size: 10px;\n  position: relative;\n  animation: ',
          ' 1.1s infinite linear;\n\n  border-top: ',
          ' solid ',
          ';\n  border-right: ',
          ' solid ',
          ';\n  border-bottom: ',
          ' solid ',
          ';\n  border-left: ',
          ' solid ',
          ';\n\n  border-radius: 50%;\n  width: ',
          ';\n  height: ',
          ';\n  max-width: ',
          ';\n  max-height: ',
          ';\n  min-width: ',
          ';\n  min-height: ',
          ';\n',
        ],
      )),
    dn,
    '0.5em',
    function (n) {
      return n.theme.loaderSpinBg;
    },
    '0.5em',
    function (n) {
      return n.theme.loaderSpinBg;
    },
    '0.5em',
    function (n) {
      return n.theme.loaderSpinBg;
    },
    '0.5em',
    function (n) {
      return n.theme.loaderSpin;
    },
    function (n) {
      return n.size;
    },
    function (n) {
      return n.size;
    },
    function (n) {
      return n.size;
    },
    function (n) {
      return n.size;
    },
    function (n) {
      return n.size;
    },
    function (n) {
      return n.size;
    },
  ),
  sn = u.div(
    on ||
      (on = x(
        ['\n  color: ', ';\n  font-family: ', ';\n  margin-left: 0.75em;\n'],
        ['\n  color: ', ';\n  font-family: ', ';\n  margin-left: 0.75em;\n'],
      )),
    function (n) {
      return n.theme.loaderTextColour;
    },
    function (n) {
      return n.theme.fontHeader;
    },
  );
(un.defaultProps = { theme: J }), (sn.defaultProps = { theme: J });
var cn,
  fn,
  mn,
  pn,
  $n,
  hn = {
    xs: '0.25rem 1rem',
    s: '0.375rem 1.25rem',
    m: '0.5rem 1.5rem',
    lg: '0.625rem 1.75rem',
    xlg: '0.75rem 2rem',
  },
  gn = u.button(
    cn ||
      (cn = x(
        [
          '\n  padding: ',
          ';\n  border-radius: ',
          ';\n  cursor: pointer;\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  outline: none;\n\n  position: relative;\n\n  width: ',
          ';\n\n  &:disabled {\n    cursor: default;\n  }\n\n  &.loading {\n    color: transparent;\n  }\n',
        ],
        [
          '\n  padding: ',
          ';\n  border-radius: ',
          ';\n  cursor: pointer;\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  outline: none;\n\n  position: relative;\n\n  width: ',
          ';\n\n  &:disabled {\n    cursor: default;\n  }\n\n  &.loading {\n    color: transparent;\n  }\n',
        ],
      )),
    function (n) {
      var e = n.size;
      return e ? hn[e] : '0.5rem 1.5rem';
    },
    '0px',
    function (n) {
      return n.theme.fontHeader;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
    function (n) {
      return n.fill ? '100%' : 'auto';
    },
  ),
  yn = u(gn)(
    fn ||
      (fn = x(
        [
          '\n  background: ',
          ';\n  border: ',
          ' solid ',
          ';\n\n  color: ',
          ';\n\n  &:disabled {\n    &:not(.loading) {\n      color: ',
          ';\n    }\n    background-color: ',
          ';\n    border: ',
          ' solid ',
          ';\n  }\n\n  &:hover:not(:disabled):not(.loading) {\n    background-color: ',
          ';\n    border: ',
          ' solid ',
          ';\n  }\n',
        ],
        [
          '\n  background: ',
          ';\n  border: ',
          ' solid ',
          ';\n\n  color: ',
          ';\n\n  &:disabled {\n    &:not(.loading) {\n      color: ',
          ';\n    }\n    background-color: ',
          ';\n    border: ',
          ' solid ',
          ';\n  }\n\n  &:hover:not(:disabled):not(.loading) {\n    background-color: ',
          ';\n    border: ',
          ' solid ',
          ';\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.btnBg;
    },
    '2px',
    function (n) {
      return n.theme.btnBg;
    },
    function (n) {
      return n.theme.btnText;
    },
    function (n) {
      return n.theme.btnTextDisabled;
    },
    function (n) {
      return n.theme.btnBgDisabled;
    },
    '2px',
    function (n) {
      return n.theme.btnBgDisabled;
    },
    function (n) {
      return n.theme.btnBgHover;
    },
    '2px',
    function (n) {
      return n.theme.btnBgHover;
    },
  ),
  bn = u(gn)(
    mn ||
      (mn = x(
        [
          '\n  background: transparent;\n  border: ',
          ' solid ',
          ';\n\n  color: ',
          ';\n\n  &:disabled {\n    &:not(.loading) {\n      color: ',
          ';\n    }\n    border: ',
          ' solid ',
          ';\n  }\n\n  &:hover:not(:disabled):not(.loading) {\n    border: ',
          ' solid ',
          ';\n    color: ',
          ';\n  }\n',
        ],
        [
          '\n  background: transparent;\n  border: ',
          ' solid ',
          ';\n\n  color: ',
          ';\n\n  &:disabled {\n    &:not(.loading) {\n      color: ',
          ';\n    }\n    border: ',
          ' solid ',
          ';\n  }\n\n  &:hover:not(:disabled):not(.loading) {\n    border: ',
          ' solid ',
          ';\n    color: ',
          ';\n  }\n',
        ],
      )),
    '2px',
    function (n) {
      return n.theme.btnGhost;
    },
    function (n) {
      return n.theme.btnGhost;
    },
    function (n) {
      return n.theme.btnGhostDisabled;
    },
    '2px',
    function (n) {
      return n.theme.btnGhostDisabled;
    },
    '2px',
    function (n) {
      return n.theme.btnGhostHover;
    },
    function (n) {
      return n.theme.btnGhostHover;
    },
  ),
  vn = u(gn)(
    pn ||
      (pn = x(
        [
          '\n  background: transparent;\n  border: 0;\n  color: ',
          ';\n  text-decoration: underline;\n',
        ],
        [
          '\n  background: transparent;\n  border: 0;\n  color: ',
          ';\n  text-decoration: underline;\n',
        ],
      )),
    function (n) {
      return n.theme.btnLink;
    },
  ),
  xn = u.div(
    $n ||
      ($n = x(
        [
          '\n  position: absolute;\n\n  display: flex;\n  align-items: center;\n\n  left: 50%;\n  top: 50%;\n\n  transform: translate(-50%, -50%) scale(0, 0);\n  transition: all 0.1s ease-out;\n\n  &.loading {\n    transform: translate(-50%, -50%) scale(1, 1);\n  }\n\n  ',
          ' {\n    border-top: ',
          ' solid ',
          ';\n    border-right: ',
          ' solid ',
          ';\n    border-bottom: ',
          ' solid ',
          ';\n    border-left: ',
          ' solid ',
          ';\n  }\n',
        ],
        [
          '\n  position: absolute;\n\n  display: flex;\n  align-items: center;\n\n  left: 50%;\n  top: 50%;\n\n  transform: translate(-50%, -50%) scale(0, 0);\n  transition: all 0.1s ease-out;\n\n  &.loading {\n    transform: translate(-50%, -50%) scale(1, 1);\n  }\n\n  ',
          ' {\n    border-top: ',
          ' solid ',
          ';\n    border-right: ',
          ' solid ',
          ';\n    border-bottom: ',
          ' solid ',
          ';\n    border-left: ',
          ' solid ',
          ';\n  }\n',
        ],
      )),
    un,
    '0.4em',
    function (n) {
      return n.theme.btnLoaderBg;
    },
    '0.4em',
    function (n) {
      return n.theme.btnLoaderBg;
    },
    '0.4em',
    function (n) {
      return n.theme.btnLoaderBg;
    },
    '0.4em',
    function (n) {
      return n.theme.btnLoader;
    },
  );
(gn.defaultProps = { theme: J }),
  (yn.defaultProps = { theme: J }),
  (bn.defaultProps = { theme: J }),
  (vn.defaultProps = { theme: J }),
  (xn.defaultProps = { theme: J });
var Cn,
  wn = u.div(
    Cn ||
      (Cn = x(
        [
          '\n  ',
          ' {\n    border-radius: 0;\n\n    &:first-child {\n      border-radius: ',
          ' 0 0 ',
          ';\n    }\n\n    &:last-child {\n      border-radius: 0 ',
          ' ',
          ' 0;\n    }\n  }\n\n  ',
          ' {\n    border-right: 0;\n\n    &:last-child {\n      border: ',
          ' solid ',
          ';\n    }\n\n    &:hover:not(:disabled):not(.loading):not(:last-child) {\n      border-right: 0;\n    }\n  }\n\n  ',
          ' {\n    border: ',
          ' solid ',
          ';\n    border-right: 0;\n\n    &:last-child {\n      border: ',
          ' solid ',
          ';\n    }\n\n    &:hover:not(:disabled):not(.loading) {\n      border: ',
          ' solid ',
          ';\n      background-color: ',
          ';\n    }\n\n    &:hover:not(:disabled):not(.loading):not(:last-child) {\n      border-right: 0;\n    }\n  }\n',
        ],
        [
          '\n  ',
          ' {\n    border-radius: 0;\n\n    &:first-child {\n      border-radius: ',
          ' 0 0 ',
          ';\n    }\n\n    &:last-child {\n      border-radius: 0 ',
          ' ',
          ' 0;\n    }\n  }\n\n  ',
          ' {\n    border-right: 0;\n\n    &:last-child {\n      border: ',
          ' solid ',
          ';\n    }\n\n    &:hover:not(:disabled):not(.loading):not(:last-child) {\n      border-right: 0;\n    }\n  }\n\n  ',
          ' {\n    border: ',
          ' solid ',
          ';\n    border-right: 0;\n\n    &:last-child {\n      border: ',
          ' solid ',
          ';\n    }\n\n    &:hover:not(:disabled):not(.loading) {\n      border: ',
          ' solid ',
          ';\n      background-color: ',
          ';\n    }\n\n    &:hover:not(:disabled):not(.loading):not(:last-child) {\n      border-right: 0;\n    }\n  }\n',
        ],
      )),
    gn,
    '0px',
    '0px',
    '0px',
    '0px',
    bn,
    '2px',
    function (n) {
      return n.theme.btnGhost;
    },
    yn,
    '2px',
    function (n) {
      return n.theme.btnGhost;
    },
    '2px',
    function (n) {
      return n.theme.btnGhost;
    },
    '2px',
    function (n) {
      return n.theme.btnGhost;
    },
    function (n) {
      return n.theme.btnBg;
    },
  );
wn.defaultProps = { theme: J };
var En = function (e) {
  var t = e.children,
    r = e.fill,
    o = e.ghost,
    a = e.loading,
    i = e.link,
    d = e.type,
    l = y(e, ['children', 'fill', 'ghost', 'loading', 'link', 'type']),
    u = 'button';
  switch (d) {
    case 'submit':
      u = 'submit';
      break;
    case 'reset':
      u = 'reset';
      break;
    default:
      u = 'button';
  }
  var s = g(g({}, l), {
    type: u,
    fill: r ? 1 : 0,
    className: a ? 'loading' : '',
  });
  a && (s.disabled = !0);
  var c = n.createElement(
      xn,
      { className: a ? 'loading' : '' },
      n.createElement(un, { size: '1.5rem' }),
    ),
    f = n.createElement(yn, g({}, s), t, c);
  return (
    o
      ? (f = n.createElement(bn, g({}, s), t, c))
      : i && (f = n.createElement(vn, g({}, s), t)),
    f
  );
};
(En.Group = function (e) {
  var t = e.children;
  return n.createElement(wn, null, t);
}),
  (En.defaultProps = { type: 'button' });
var Nn,
  Pn,
  Sn = { mobile: 0, tablet: 737, desktop: 1195 },
  On = function (n) {
    return n / 16;
  },
  kn = Object.freeze([
    '\n          @media screen and (min-width: ',
    'em) {\n            ',
    '\n          }\n        ',
  ]),
  In = Object.freeze([
    '\n        @media screen and (min-width: ',
    'em) and (max-width: ',
    'em) {\n          ',
    '\n        }\n      ',
  ]),
  Tn = function (n, e) {
    return e in n
      ? n[e]
      : (console.error(
          'styled-components-breakpoint: Breakpoint "' + e + '" was not found.',
        ),
        0);
  },
  An = function (n) {
    return function (e, t) {
      return function (r) {
        for (var o = [], a = arguments.length - 1; a-- > 0; )
          o[a] = arguments[a + 1];
        if (e && t) {
          var i = Tn(n, e),
            d = Tn(n, t);
          return c(In, On(i), On(d - 1), c.apply(void 0, [r].concat(o)));
        }
        var l = Tn(n, e);
        return 0 === l
          ? c.apply(void 0, [r].concat(o))
          : c(kn, On(l), c.apply(void 0, [r].concat(o)));
      };
    };
  },
  Rn = function (n, e) {
    return function (t) {
      for (var r = [], o = arguments.length - 1; o-- > 0; )
        r[o] = arguments[o + 1];
      return function (o) {
        return An((a = o.theme) && a.breakpoints ? a.breakpoints : Sn)(n, e)(
          t,
          r,
        );
        var a;
      };
    };
  },
  Bn = { xlg: '1300px', lg: '1160px', md: '768px', sm: '456px', xs: '380px' },
  Mn = u.div(
    Pn ||
      (Pn = x(
        [
          '\n  margin: auto;\n  max-width: ',
          ';\n  padding: 0.5em 1em;\n\n  ',
          '\n',
        ],
        [
          '\n  margin: auto;\n  max-width: ',
          ';\n  padding: 0.5em 1em;\n\n  ',
          '\n',
        ],
      )),
    function (n) {
      var e = n.size;
      return Bn[e];
    },
    Rn('tablet')(
      Nn ||
        (Nn = x(
          [
            '\n    border-radius: 10px;\n    padding: 1em 2em;\n\n    &.border {\n      border: 1px solid grey;\n    }\n  ',
          ],
          [
            '\n    border-radius: 10px;\n    padding: 1em 2em;\n\n    &.border {\n      border: 1px solid grey;\n    }\n  ',
          ],
        )),
    ),
  ),
  Fn = function (e) {
    var t = e.border,
      r = e.children,
      o = e.className,
      a = e.size,
      i = y(e, ['border', 'children', 'className', 'size']);
    return n.createElement(
      Mn,
      g({ className: (o || '') + ' ' + (t ? 'border' : ''), size: a }, i),
      r,
    );
  };
Fn.defaultProps = { border: !1, size: 'lg' };
var Dn,
  Ln = u.div(
    Dn ||
      (Dn = x(
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  height: 22px;\n  opacity: 1;\n  overflow: hidden;\n  padding: 0.5em 0;\n  transition: all 0.1s ease-out;\n\n  &.hidden {\n    opacity: 0;\n  }\n',
        ],
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  height: 22px;\n  opacity: 1;\n  overflow: hidden;\n  padding: 0.5em 0;\n  transition: all 0.1s ease-out;\n\n  &.hidden {\n    opacity: 0;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.error400;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
  );
Ln.defaultProps = { theme: J };
var jn,
  zn = function (e) {
    var t = e.children,
      r = e.className,
      o = e.hidden;
    return n.createElement(
      Ln,
      {
        className: (r || '') + ' ' + (o ? 'hidden' : ''),
        'data-testid': 'error-message',
      },
      t,
    );
  },
  Gn = u.div(
    jn ||
      (jn = x(
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  margin-bottom: 1em;\n\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n\n  input {\n    margin: 0.2rem 0;\n  }\n',
        ],
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  margin-bottom: 1em;\n\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n\n  input {\n    margin: 0.2rem 0;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.fontColour;
    },
    function (n) {
      return n.theme.fontBody;
    },
  );
Gn.defaultProps = { theme: J };
var _n,
  Vn = function (e) {
    var t = e.label,
      r = e.name,
      o = e.updateValue,
      a = e.value,
      i = e.required,
      d = y(e, ['label', 'name', 'updateValue', 'value', 'required']);
    if (i)
      throw new Error('Checkboxes should not be assigned a required flag.');
    return n.createElement(
      Gn,
      null,
      n.createElement('label', { htmlFor: r }, t),
      ' ',
      n.createElement(
        'input',
        g(
          {
            name: r,
            onChange: function (n) {
              var e = n.target.checked;
              o && o(e ? 'true' : 'false');
            },
            value: 'true',
            checked: 'true' === a,
          },
          d,
          { type: 'checkbox' },
        ),
      ),
    );
  },
  Hn = u.div(
    _n ||
      (_n = x(
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  padding: 0.5em 0;\n',
        ],
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  padding: 0.5em 0;\n',
        ],
      )),
    function (n) {
      return n.theme.formHeaderText;
    },
    function (n) {
      return n.theme.fontHeader;
    },
    function (n) {
      return n.theme.fontSizeHeader;
    },
  );
function Un(e) {
  var t = e.children;
  return n.createElement(Hn, null, t);
}
function qn() {
  return (qn =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function Wn(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = {},
    a = Object.keys(n);
  for (r = 0; r < a.length; r++) (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
  return o;
}
function Kn(n, e) {
  return (Kn =
    Object.setPrototypeOf ||
    function (n, e) {
      return (n.__proto__ = e), n;
    })(n, e);
}
function Yn(n, e) {
  (n.prototype = Object.create(e.prototype)),
    (n.prototype.constructor = n),
    Kn(n, e);
}
function Zn(n) {
  var e = { exports: {} };
  return n(e, e.exports), e.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}
Hn.defaultProps = { theme: J };
var Jn = 'function' == typeof Symbol && Symbol.for,
  Xn = Jn ? Symbol.for('react.element') : 60103,
  Qn = Jn ? Symbol.for('react.portal') : 60106,
  ne = Jn ? Symbol.for('react.fragment') : 60107,
  ee = Jn ? Symbol.for('react.strict_mode') : 60108,
  te = Jn ? Symbol.for('react.profiler') : 60114,
  re = Jn ? Symbol.for('react.provider') : 60109,
  oe = Jn ? Symbol.for('react.context') : 60110,
  ae = Jn ? Symbol.for('react.async_mode') : 60111,
  ie = Jn ? Symbol.for('react.concurrent_mode') : 60111,
  de = Jn ? Symbol.for('react.forward_ref') : 60112,
  le = Jn ? Symbol.for('react.suspense') : 60113,
  ue = Jn ? Symbol.for('react.suspense_list') : 60120,
  se = Jn ? Symbol.for('react.memo') : 60115,
  ce = Jn ? Symbol.for('react.lazy') : 60116,
  fe = Jn ? Symbol.for('react.block') : 60121,
  me = Jn ? Symbol.for('react.fundamental') : 60117,
  pe = Jn ? Symbol.for('react.responder') : 60118,
  $e = Jn ? Symbol.for('react.scope') : 60119;
function he(n) {
  if ('object' == typeof n && null !== n) {
    var e = n.$$typeof;
    switch (e) {
      case Xn:
        switch ((n = n.type)) {
          case ae:
          case ie:
          case ne:
          case te:
          case ee:
          case le:
            return n;
          default:
            switch ((n = n && n.$$typeof)) {
              case oe:
              case de:
              case ce:
              case se:
              case re:
                return n;
              default:
                return e;
            }
        }
      case Qn:
        return e;
    }
  }
}
function ge(n) {
  return he(n) === ie;
}
var ye = {
    AsyncMode: ae,
    ConcurrentMode: ie,
    ContextConsumer: oe,
    ContextProvider: re,
    Element: Xn,
    ForwardRef: de,
    Fragment: ne,
    Lazy: ce,
    Memo: se,
    Portal: Qn,
    Profiler: te,
    StrictMode: ee,
    Suspense: le,
    isAsyncMode: function (n) {
      return ge(n) || he(n) === ae;
    },
    isConcurrentMode: ge,
    isContextConsumer: function (n) {
      return he(n) === oe;
    },
    isContextProvider: function (n) {
      return he(n) === re;
    },
    isElement: function (n) {
      return 'object' == typeof n && null !== n && n.$$typeof === Xn;
    },
    isForwardRef: function (n) {
      return he(n) === de;
    },
    isFragment: function (n) {
      return he(n) === ne;
    },
    isLazy: function (n) {
      return he(n) === ce;
    },
    isMemo: function (n) {
      return he(n) === se;
    },
    isPortal: function (n) {
      return he(n) === Qn;
    },
    isProfiler: function (n) {
      return he(n) === te;
    },
    isStrictMode: function (n) {
      return he(n) === ee;
    },
    isSuspense: function (n) {
      return he(n) === le;
    },
    isValidElementType: function (n) {
      return (
        'string' == typeof n ||
        'function' == typeof n ||
        n === ne ||
        n === ie ||
        n === te ||
        n === ee ||
        n === le ||
        n === ue ||
        ('object' == typeof n &&
          null !== n &&
          (n.$$typeof === ce ||
            n.$$typeof === se ||
            n.$$typeof === re ||
            n.$$typeof === oe ||
            n.$$typeof === de ||
            n.$$typeof === me ||
            n.$$typeof === pe ||
            n.$$typeof === $e ||
            n.$$typeof === fe))
      );
    },
    typeOf: he,
  },
  be = Zn(function (n, e) {
    'production' !== process.env.NODE_ENV &&
      (function () {
        var n = 'function' == typeof Symbol && Symbol.for,
          t = n ? Symbol.for('react.element') : 60103,
          r = n ? Symbol.for('react.portal') : 60106,
          o = n ? Symbol.for('react.fragment') : 60107,
          a = n ? Symbol.for('react.strict_mode') : 60108,
          i = n ? Symbol.for('react.profiler') : 60114,
          d = n ? Symbol.for('react.provider') : 60109,
          l = n ? Symbol.for('react.context') : 60110,
          u = n ? Symbol.for('react.async_mode') : 60111,
          s = n ? Symbol.for('react.concurrent_mode') : 60111,
          c = n ? Symbol.for('react.forward_ref') : 60112,
          f = n ? Symbol.for('react.suspense') : 60113,
          m = n ? Symbol.for('react.suspense_list') : 60120,
          p = n ? Symbol.for('react.memo') : 60115,
          $ = n ? Symbol.for('react.lazy') : 60116,
          h = n ? Symbol.for('react.block') : 60121,
          g = n ? Symbol.for('react.fundamental') : 60117,
          y = n ? Symbol.for('react.responder') : 60118,
          b = n ? Symbol.for('react.scope') : 60119;
        function v(n) {
          if ('object' == typeof n && null !== n) {
            var e = n.$$typeof;
            switch (e) {
              case t:
                var m = n.type;
                switch (m) {
                  case u:
                  case s:
                  case o:
                  case i:
                  case a:
                  case f:
                    return m;
                  default:
                    var h = m && m.$$typeof;
                    switch (h) {
                      case l:
                      case c:
                      case $:
                      case p:
                      case d:
                        return h;
                      default:
                        return e;
                    }
                }
              case r:
                return e;
            }
          }
        }
        var x = u,
          C = s,
          w = l,
          E = d,
          N = t,
          P = c,
          S = o,
          O = $,
          k = p,
          I = r,
          T = i,
          A = a,
          R = f,
          B = !1;
        function M(n) {
          return v(n) === s;
        }
        (e.AsyncMode = x),
          (e.ConcurrentMode = C),
          (e.ContextConsumer = w),
          (e.ContextProvider = E),
          (e.Element = N),
          (e.ForwardRef = P),
          (e.Fragment = S),
          (e.Lazy = O),
          (e.Memo = k),
          (e.Portal = I),
          (e.Profiler = T),
          (e.StrictMode = A),
          (e.Suspense = R),
          (e.isAsyncMode = function (n) {
            return (
              B ||
                ((B = !0),
                console.warn(
                  'The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.',
                )),
              M(n) || v(n) === u
            );
          }),
          (e.isConcurrentMode = M),
          (e.isContextConsumer = function (n) {
            return v(n) === l;
          }),
          (e.isContextProvider = function (n) {
            return v(n) === d;
          }),
          (e.isElement = function (n) {
            return 'object' == typeof n && null !== n && n.$$typeof === t;
          }),
          (e.isForwardRef = function (n) {
            return v(n) === c;
          }),
          (e.isFragment = function (n) {
            return v(n) === o;
          }),
          (e.isLazy = function (n) {
            return v(n) === $;
          }),
          (e.isMemo = function (n) {
            return v(n) === p;
          }),
          (e.isPortal = function (n) {
            return v(n) === r;
          }),
          (e.isProfiler = function (n) {
            return v(n) === i;
          }),
          (e.isStrictMode = function (n) {
            return v(n) === a;
          }),
          (e.isSuspense = function (n) {
            return v(n) === f;
          }),
          (e.isValidElementType = function (n) {
            return (
              'string' == typeof n ||
              'function' == typeof n ||
              n === o ||
              n === s ||
              n === i ||
              n === a ||
              n === f ||
              n === m ||
              ('object' == typeof n &&
                null !== n &&
                (n.$$typeof === $ ||
                  n.$$typeof === p ||
                  n.$$typeof === d ||
                  n.$$typeof === l ||
                  n.$$typeof === c ||
                  n.$$typeof === g ||
                  n.$$typeof === y ||
                  n.$$typeof === b ||
                  n.$$typeof === h))
            );
          }),
          (e.typeOf = v);
      })();
  }),
  ve = Zn(function (n) {
    'production' === process.env.NODE_ENV ? (n.exports = ye) : (n.exports = be);
  }),
  xe = Object.getOwnPropertySymbols,
  Ce = Object.prototype.hasOwnProperty,
  we = Object.prototype.propertyIsEnumerable;
function Ee(n) {
  if (null == n)
    throw new TypeError(
      'Object.assign cannot be called with null or undefined',
    );
  return Object(n);
}
var Ne = (function () {
    try {
      if (!Object.assign) return !1;
      var n = new String('abc');
      if (((n[5] = 'de'), '5' === Object.getOwnPropertyNames(n)[0])) return !1;
      for (var e = {}, t = 0; t < 10; t++) e['_' + String.fromCharCode(t)] = t;
      if (
        '0123456789' !==
        Object.getOwnPropertyNames(e)
          .map(function (n) {
            return e[n];
          })
          .join('')
      )
        return !1;
      var r = {};
      return (
        'abcdefghijklmnopqrst'.split('').forEach(function (n) {
          r[n] = n;
        }),
        'abcdefghijklmnopqrst' === Object.keys(Object.assign({}, r)).join('')
      );
    } catch (n) {
      return !1;
    }
  })()
    ? Object.assign
    : function (n, e) {
        for (var t, r, o = Ee(n), a = 1; a < arguments.length; a++) {
          for (var i in (t = Object(arguments[a])))
            Ce.call(t, i) && (o[i] = t[i]);
          if (xe) {
            r = xe(t);
            for (var d = 0; d < r.length; d++)
              we.call(t, r[d]) && (o[r[d]] = t[r[d]]);
          }
        }
        return o;
      },
  Pe = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED',
  Se = function () {};
if ('production' !== process.env.NODE_ENV) {
  var Oe = Pe,
    ke = {},
    Ie = Function.call.bind(Object.prototype.hasOwnProperty);
  Se = function (n) {
    var e = 'Warning: ' + n;
    'undefined' != typeof console && console.error(e);
    try {
      throw new Error(e);
    } catch (n) {}
  };
}
function Te(n, e, t, r, o) {
  if ('production' !== process.env.NODE_ENV)
    for (var a in n)
      if (Ie(n, a)) {
        var i;
        try {
          if ('function' != typeof n[a]) {
            var d = Error(
              (r || 'React class') +
                ': ' +
                t +
                ' type `' +
                a +
                '` is invalid; it must be a function, usually from the `prop-types` package, but received `' +
                typeof n[a] +
                '`.',
            );
            throw ((d.name = 'Invariant Violation'), d);
          }
          i = n[a](e, a, r, t, null, Oe);
        } catch (n) {
          i = n;
        }
        if (
          (!i ||
            i instanceof Error ||
            Se(
              (r || 'React class') +
                ': type specification of ' +
                t +
                ' `' +
                a +
                '` is invalid; the type checker function must return `null` or an `Error` but returned a ' +
                typeof i +
                '. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).',
            ),
          i instanceof Error && !(i.message in ke))
        ) {
          ke[i.message] = !0;
          var l = o ? o() : '';
          Se('Failed ' + t + ' type: ' + i.message + (null != l ? l : ''));
        }
      }
}
Te.resetWarningCache = function () {
  'production' !== process.env.NODE_ENV && (ke = {});
};
var Ae = Te,
  Re = Function.call.bind(Object.prototype.hasOwnProperty),
  Be = function () {};
function Me() {
  return null;
}
'production' !== process.env.NODE_ENV &&
  (Be = function (n) {
    var e = 'Warning: ' + n;
    'undefined' != typeof console && console.error(e);
    try {
      throw new Error(e);
    } catch (n) {}
  });
var Fe = function (n, e) {
  var t = 'function' == typeof Symbol && Symbol.iterator;
  var r = '<<anonymous>>',
    o = {
      array: l('array'),
      bool: l('boolean'),
      func: l('function'),
      number: l('number'),
      object: l('object'),
      string: l('string'),
      symbol: l('symbol'),
      any: d(Me),
      arrayOf: function (n) {
        return d(function (e, t, r, o, a) {
          if ('function' != typeof n)
            return new i(
              'Property `' +
                a +
                '` of component `' +
                r +
                '` has invalid PropType notation inside arrayOf.',
            );
          var d = e[t];
          if (!Array.isArray(d))
            return new i(
              'Invalid ' +
                o +
                ' `' +
                a +
                '` of type `' +
                s(d) +
                '` supplied to `' +
                r +
                '`, expected an array.',
            );
          for (var l = 0; l < d.length; l++) {
            var u = n(d, l, r, o, a + '[' + l + ']', Pe);
            if (u instanceof Error) return u;
          }
          return null;
        });
      },
      element: d(function (e, t, r, o, a) {
        var d = e[t];
        return n(d)
          ? null
          : new i(
              'Invalid ' +
                o +
                ' `' +
                a +
                '` of type `' +
                s(d) +
                '` supplied to `' +
                r +
                '`, expected a single ReactElement.',
            );
      }),
      elementType: d(function (n, e, t, r, o) {
        var a = n[e];
        return ve.isValidElementType(a)
          ? null
          : new i(
              'Invalid ' +
                r +
                ' `' +
                o +
                '` of type `' +
                s(a) +
                '` supplied to `' +
                t +
                '`, expected a single ReactElement type.',
            );
      }),
      instanceOf: function (n) {
        return d(function (e, t, o, a, d) {
          if (!(e[t] instanceof n)) {
            var l = n.name || r;
            return new i(
              'Invalid ' +
                a +
                ' `' +
                d +
                '` of type `' +
                (((u = e[t]).constructor && u.constructor.name
                  ? u.constructor.name
                  : r) +
                  '` supplied to `') +
                o +
                '`, expected instance of `' +
                l +
                '`.',
            );
          }
          var u;
          return null;
        });
      },
      node: d(function (n, e, t, r, o) {
        return u(n[e])
          ? null
          : new i(
              'Invalid ' +
                r +
                ' `' +
                o +
                '` supplied to `' +
                t +
                '`, expected a ReactNode.',
            );
      }),
      objectOf: function (n) {
        return d(function (e, t, r, o, a) {
          if ('function' != typeof n)
            return new i(
              'Property `' +
                a +
                '` of component `' +
                r +
                '` has invalid PropType notation inside objectOf.',
            );
          var d = e[t],
            l = s(d);
          if ('object' !== l)
            return new i(
              'Invalid ' +
                o +
                ' `' +
                a +
                '` of type `' +
                l +
                '` supplied to `' +
                r +
                '`, expected an object.',
            );
          for (var u in d)
            if (Re(d, u)) {
              var c = n(d, u, r, o, a + '.' + u, Pe);
              if (c instanceof Error) return c;
            }
          return null;
        });
      },
      oneOf: function (n) {
        if (!Array.isArray(n))
          return (
            'production' !== process.env.NODE_ENV &&
              Be(
                arguments.length > 1
                  ? 'Invalid arguments supplied to oneOf, expected an array, got ' +
                      arguments.length +
                      ' arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
                  : 'Invalid argument supplied to oneOf, expected an array.',
              ),
            Me
          );
        function e(e, t, r, o, d) {
          for (var l = e[t], u = 0; u < n.length; u++)
            if (a(l, n[u])) return null;
          var s = JSON.stringify(n, function (n, e) {
            return 'symbol' === c(e) ? String(e) : e;
          });
          return new i(
            'Invalid ' +
              o +
              ' `' +
              d +
              '` of value `' +
              String(l) +
              '` supplied to `' +
              r +
              '`, expected one of ' +
              s +
              '.',
          );
        }
        return d(e);
      },
      oneOfType: function (n) {
        if (!Array.isArray(n))
          return (
            'production' !== process.env.NODE_ENV &&
              Be(
                'Invalid argument supplied to oneOfType, expected an instance of array.',
              ),
            Me
          );
        for (var e = 0; e < n.length; e++) {
          var t = n[e];
          if ('function' != typeof t)
            return (
              Be(
                'Invalid argument supplied to oneOfType. Expected an array of check functions, but received ' +
                  f(t) +
                  ' at index ' +
                  e +
                  '.',
              ),
              Me
            );
        }
        return d(function (e, t, r, o, a) {
          for (var d = 0; d < n.length; d++)
            if (null == (0, n[d])(e, t, r, o, a, Pe)) return null;
          return new i(
            'Invalid ' + o + ' `' + a + '` supplied to `' + r + '`.',
          );
        });
      },
      shape: function (n) {
        return d(function (e, t, r, o, a) {
          var d = e[t],
            l = s(d);
          if ('object' !== l)
            return new i(
              'Invalid ' +
                o +
                ' `' +
                a +
                '` of type `' +
                l +
                '` supplied to `' +
                r +
                '`, expected `object`.',
            );
          for (var u in n) {
            var c = n[u];
            if (c) {
              var f = c(d, u, r, o, a + '.' + u, Pe);
              if (f) return f;
            }
          }
          return null;
        });
      },
      exact: function (n) {
        return d(function (e, t, r, o, a) {
          var d = e[t],
            l = s(d);
          if ('object' !== l)
            return new i(
              'Invalid ' +
                o +
                ' `' +
                a +
                '` of type `' +
                l +
                '` supplied to `' +
                r +
                '`, expected `object`.',
            );
          var u = Ne({}, e[t], n);
          for (var c in u) {
            var f = n[c];
            if (!f)
              return new i(
                'Invalid ' +
                  o +
                  ' `' +
                  a +
                  '` key `' +
                  c +
                  '` supplied to `' +
                  r +
                  '`.\nBad object: ' +
                  JSON.stringify(e[t], null, '  ') +
                  '\nValid keys: ' +
                  JSON.stringify(Object.keys(n), null, '  '),
              );
            var m = f(d, c, r, o, a + '.' + c, Pe);
            if (m) return m;
          }
          return null;
        });
      },
    };
  function a(n, e) {
    return n === e ? 0 !== n || 1 / n == 1 / e : n != n && e != e;
  }
  function i(n) {
    (this.message = n), (this.stack = '');
  }
  function d(n) {
    if ('production' !== process.env.NODE_ENV)
      var t = {},
        o = 0;
    function a(a, d, l, u, s, c, f) {
      if (((u = u || r), (c = c || l), f !== Pe)) {
        if (e) {
          var m = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types',
          );
          throw ((m.name = 'Invariant Violation'), m);
        }
        if (
          'production' !== process.env.NODE_ENV &&
          'undefined' != typeof console
        ) {
          var p = u + ':' + l;
          !t[p] &&
            o < 3 &&
            (Be(
              'You are manually calling a React.PropTypes validation function for the `' +
                c +
                '` prop on `' +
                u +
                '`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.',
            ),
            (t[p] = !0),
            o++);
        }
      }
      return null == d[l]
        ? a
          ? null === d[l]
            ? new i(
                'The ' +
                  s +
                  ' `' +
                  c +
                  '` is marked as required in `' +
                  u +
                  '`, but its value is `null`.',
              )
            : new i(
                'The ' +
                  s +
                  ' `' +
                  c +
                  '` is marked as required in `' +
                  u +
                  '`, but its value is `undefined`.',
              )
          : null
        : n(d, l, u, s, c);
    }
    var d = a.bind(null, !1);
    return (d.isRequired = a.bind(null, !0)), d;
  }
  function l(n) {
    return d(function (e, t, r, o, a, d) {
      var l = e[t];
      return s(l) !== n
        ? new i(
            'Invalid ' +
              o +
              ' `' +
              a +
              '` of type `' +
              c(l) +
              '` supplied to `' +
              r +
              '`, expected `' +
              n +
              '`.',
          )
        : null;
    });
  }
  function u(e) {
    switch (typeof e) {
      case 'number':
      case 'string':
      case 'undefined':
        return !0;
      case 'boolean':
        return !e;
      case 'object':
        if (Array.isArray(e)) return e.every(u);
        if (null === e || n(e)) return !0;
        var r = (function (n) {
          var e = n && ((t && n[t]) || n['@@iterator']);
          if ('function' == typeof e) return e;
        })(e);
        if (!r) return !1;
        var o,
          a = r.call(e);
        if (r !== e.entries) {
          for (; !(o = a.next()).done; ) if (!u(o.value)) return !1;
        } else
          for (; !(o = a.next()).done; ) {
            var i = o.value;
            if (i && !u(i[1])) return !1;
          }
        return !0;
      default:
        return !1;
    }
  }
  function s(n) {
    var e = typeof n;
    return Array.isArray(n)
      ? 'array'
      : n instanceof RegExp
      ? 'object'
      : (function (n, e) {
          return (
            'symbol' === n ||
            (!!e &&
              ('Symbol' === e['@@toStringTag'] ||
                ('function' == typeof Symbol && e instanceof Symbol)))
          );
        })(e, n)
      ? 'symbol'
      : e;
  }
  function c(n) {
    if (null == n) return '' + n;
    var e = s(n);
    if ('object' === e) {
      if (n instanceof Date) return 'date';
      if (n instanceof RegExp) return 'regexp';
    }
    return e;
  }
  function f(n) {
    var e = c(n);
    switch (e) {
      case 'array':
      case 'object':
        return 'an ' + e;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + e;
      default:
        return e;
    }
  }
  return (
    (i.prototype = Error.prototype),
    (o.checkPropTypes = Ae),
    (o.resetWarningCache = Ae.resetWarningCache),
    (o.PropTypes = o),
    o
  );
};
function De() {}
function Le() {}
Le.resetWarningCache = De;
var je = Zn(function (n) {
  if ('production' !== process.env.NODE_ENV) {
    var e = ve;
    n.exports = Fe(e.isElement, !0);
  } else
    n.exports = (function () {
      function n(n, e, t, r, o, a) {
        if (a !== Pe) {
          var i = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types',
          );
          throw ((i.name = 'Invariant Violation'), i);
        }
      }
      function e() {
        return n;
      }
      n.isRequired = n;
      var t = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: e,
        element: n,
        elementType: n,
        instanceOf: e,
        node: n,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: Le,
        resetWarningCache: De,
      };
      return (t.PropTypes = t), t;
    })();
});
function ze(n, e) {
  return n
    .replace(new RegExp('(^|\\s)' + e + '(?:\\s|$)', 'g'), '$1')
    .replace(/\s+/g, ' ')
    .replace(/^\s*|\s*$/g, '');
}
var Ge = !1,
  _e =
    'production' !== process.env.NODE_ENV
      ? je.oneOfType([
          je.number,
          je.shape({ enter: je.number, exit: je.number, appear: je.number })
            .isRequired,
        ])
      : null,
  Ve =
    'production' !== process.env.NODE_ENV
      ? je.oneOfType([
          je.string,
          je.shape({ enter: je.string, exit: je.string, active: je.string }),
          je.shape({
            enter: je.string,
            enterDone: je.string,
            enterActive: je.string,
            exit: je.string,
            exitDone: je.string,
            exitActive: je.string,
          }),
        ])
      : null,
  He = n.createContext(null),
  Ue = (function (e) {
    function t(n, t) {
      var r;
      r = e.call(this, n, t) || this;
      var o,
        a = t && !t.isMounting ? n.enter : n.appear;
      return (
        (r.appearStatus = null),
        n.in
          ? a
            ? ((o = 'exited'), (r.appearStatus = 'entering'))
            : (o = 'entered')
          : (o = n.unmountOnExit || n.mountOnEnter ? 'unmounted' : 'exited'),
        (r.state = { status: o }),
        (r.nextCallback = null),
        r
      );
    }
    Yn(t, e),
      (t.getDerivedStateFromProps = function (n, e) {
        return n.in && 'unmounted' === e.status ? { status: 'exited' } : null;
      });
    var r = t.prototype;
    return (
      (r.componentDidMount = function () {
        this.updateStatus(!0, this.appearStatus);
      }),
      (r.componentDidUpdate = function (n) {
        var e = null;
        if (n !== this.props) {
          var t = this.state.status;
          this.props.in
            ? 'entering' !== t && 'entered' !== t && (e = 'entering')
            : ('entering' !== t && 'entered' !== t) || (e = 'exiting');
        }
        this.updateStatus(!1, e);
      }),
      (r.componentWillUnmount = function () {
        this.cancelNextCallback();
      }),
      (r.getTimeouts = function () {
        var n,
          e,
          t,
          r = this.props.timeout;
        return (
          (n = e = t = r),
          null != r &&
            'number' != typeof r &&
            ((n = r.exit),
            (e = r.enter),
            (t = void 0 !== r.appear ? r.appear : e)),
          { exit: n, enter: e, appear: t }
        );
      }),
      (r.updateStatus = function (n, e) {
        void 0 === n && (n = !1),
          null !== e
            ? (this.cancelNextCallback(),
              'entering' === e ? this.performEnter(n) : this.performExit())
            : this.props.unmountOnExit &&
              'exited' === this.state.status &&
              this.setState({ status: 'unmounted' });
      }),
      (r.performEnter = function (n) {
        var e = this,
          t = this.props.enter,
          r = this.context ? this.context.isMounting : n,
          o = this.props.nodeRef ? [r] : [m.findDOMNode(this), r],
          a = o[0],
          i = o[1],
          d = this.getTimeouts(),
          l = r ? d.appear : d.enter;
        (!n && !t) || Ge
          ? this.safeSetState({ status: 'entered' }, function () {
              e.props.onEntered(a);
            })
          : (this.props.onEnter(a, i),
            this.safeSetState({ status: 'entering' }, function () {
              e.props.onEntering(a, i),
                e.onTransitionEnd(l, function () {
                  e.safeSetState({ status: 'entered' }, function () {
                    e.props.onEntered(a, i);
                  });
                });
            }));
      }),
      (r.performExit = function () {
        var n = this,
          e = this.props.exit,
          t = this.getTimeouts(),
          r = this.props.nodeRef ? void 0 : m.findDOMNode(this);
        e && !Ge
          ? (this.props.onExit(r),
            this.safeSetState({ status: 'exiting' }, function () {
              n.props.onExiting(r),
                n.onTransitionEnd(t.exit, function () {
                  n.safeSetState({ status: 'exited' }, function () {
                    n.props.onExited(r);
                  });
                });
            }))
          : this.safeSetState({ status: 'exited' }, function () {
              n.props.onExited(r);
            });
      }),
      (r.cancelNextCallback = function () {
        null !== this.nextCallback &&
          (this.nextCallback.cancel(), (this.nextCallback = null));
      }),
      (r.safeSetState = function (n, e) {
        (e = this.setNextCallback(e)), this.setState(n, e);
      }),
      (r.setNextCallback = function (n) {
        var e = this,
          t = !0;
        return (
          (this.nextCallback = function (r) {
            t && ((t = !1), (e.nextCallback = null), n(r));
          }),
          (this.nextCallback.cancel = function () {
            t = !1;
          }),
          this.nextCallback
        );
      }),
      (r.onTransitionEnd = function (n, e) {
        this.setNextCallback(e);
        var t = this.props.nodeRef
            ? this.props.nodeRef.current
            : m.findDOMNode(this),
          r = null == n && !this.props.addEndListener;
        if (t && !r) {
          if (this.props.addEndListener) {
            var o = this.props.nodeRef
                ? [this.nextCallback]
                : [t, this.nextCallback],
              a = o[0],
              i = o[1];
            this.props.addEndListener(a, i);
          }
          null != n && setTimeout(this.nextCallback, n);
        } else setTimeout(this.nextCallback, 0);
      }),
      (r.render = function () {
        var e = this.state.status;
        if ('unmounted' === e) return null;
        var t = this.props,
          r = t.children;
        t.in,
          t.mountOnEnter,
          t.unmountOnExit,
          t.appear,
          t.enter,
          t.exit,
          t.timeout,
          t.addEndListener,
          t.onEnter,
          t.onEntering,
          t.onEntered,
          t.onExit,
          t.onExiting,
          t.onExited,
          t.nodeRef;
        var o = Wn(t, [
          'children',
          'in',
          'mountOnEnter',
          'unmountOnExit',
          'appear',
          'enter',
          'exit',
          'timeout',
          'addEndListener',
          'onEnter',
          'onEntering',
          'onEntered',
          'onExit',
          'onExiting',
          'onExited',
          'nodeRef',
        ]);
        return n.createElement(
          He.Provider,
          { value: null },
          'function' == typeof r
            ? r(e, o)
            : n.cloneElement(n.Children.only(r), o),
        );
      }),
      t
    );
  })(n.Component);
function qe() {}
(Ue.contextType = He),
  (Ue.propTypes =
    'production' !== process.env.NODE_ENV
      ? {
          nodeRef: je.shape({
            current:
              'undefined' == typeof Element ? je.any : je.instanceOf(Element),
          }),
          children: je.oneOfType([je.func.isRequired, je.element.isRequired])
            .isRequired,
          in: je.bool,
          mountOnEnter: je.bool,
          unmountOnExit: je.bool,
          appear: je.bool,
          enter: je.bool,
          exit: je.bool,
          timeout: function (n) {
            var e = _e;
            n.addEndListener || (e = e.isRequired);
            for (
              var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1;
              o < t;
              o++
            )
              r[o - 1] = arguments[o];
            return e.apply(void 0, [n].concat(r));
          },
          addEndListener: je.func,
          onEnter: je.func,
          onEntering: je.func,
          onEntered: je.func,
          onExit: je.func,
          onExiting: je.func,
          onExited: je.func,
        }
      : {}),
  (Ue.defaultProps = {
    in: !1,
    mountOnEnter: !1,
    unmountOnExit: !1,
    appear: !1,
    enter: !0,
    exit: !0,
    onEnter: qe,
    onEntering: qe,
    onEntered: qe,
    onExit: qe,
    onExiting: qe,
    onExited: qe,
  }),
  (Ue.UNMOUNTED = 'unmounted'),
  (Ue.EXITED = 'exited'),
  (Ue.ENTERING = 'entering'),
  (Ue.ENTERED = 'entered'),
  (Ue.EXITING = 'exiting');
var We = function (n, e) {
    return (
      n &&
      e &&
      e.split(' ').forEach(function (e) {
        return (
          (r = e),
          void ((t = n).classList
            ? t.classList.add(r)
            : (function (n, e) {
                return n.classList
                  ? !!e && n.classList.contains(e)
                  : -1 !==
                      (
                        ' ' +
                        (n.className.baseVal || n.className) +
                        ' '
                      ).indexOf(' ' + e + ' ');
              })(t, r) ||
              ('string' == typeof t.className
                ? (t.className = t.className + ' ' + r)
                : t.setAttribute(
                    'class',
                    ((t.className && t.className.baseVal) || '') + ' ' + r,
                  )))
        );
        var t, r;
      })
    );
  },
  Ke = function (n, e) {
    return (
      n &&
      e &&
      e.split(' ').forEach(function (e) {
        return (
          (r = e),
          void ((t = n).classList
            ? t.classList.remove(r)
            : 'string' == typeof t.className
            ? (t.className = ze(t.className, r))
            : t.setAttribute(
                'class',
                ze((t.className && t.className.baseVal) || '', r),
              ))
        );
        var t, r;
      })
    );
  },
  Ye = (function (e) {
    function t() {
      for (var n, t = arguments.length, r = new Array(t), o = 0; o < t; o++)
        r[o] = arguments[o];
      return (
        ((n = e.call.apply(e, [this].concat(r)) || this).appliedClasses = {
          appear: {},
          enter: {},
          exit: {},
        }),
        (n.onEnter = function (e, t) {
          var r = n.resolveArguments(e, t),
            o = r[0],
            a = r[1];
          n.removeClasses(o, 'exit'),
            n.addClass(o, a ? 'appear' : 'enter', 'base'),
            n.props.onEnter && n.props.onEnter(e, t);
        }),
        (n.onEntering = function (e, t) {
          var r = n.resolveArguments(e, t),
            o = r[0],
            a = r[1] ? 'appear' : 'enter';
          n.addClass(o, a, 'active'),
            n.props.onEntering && n.props.onEntering(e, t);
        }),
        (n.onEntered = function (e, t) {
          var r = n.resolveArguments(e, t),
            o = r[0],
            a = r[1] ? 'appear' : 'enter';
          n.removeClasses(o, a),
            n.addClass(o, a, 'done'),
            n.props.onEntered && n.props.onEntered(e, t);
        }),
        (n.onExit = function (e) {
          var t = n.resolveArguments(e)[0];
          n.removeClasses(t, 'appear'),
            n.removeClasses(t, 'enter'),
            n.addClass(t, 'exit', 'base'),
            n.props.onExit && n.props.onExit(e);
        }),
        (n.onExiting = function (e) {
          var t = n.resolveArguments(e)[0];
          n.addClass(t, 'exit', 'active'),
            n.props.onExiting && n.props.onExiting(e);
        }),
        (n.onExited = function (e) {
          var t = n.resolveArguments(e)[0];
          n.removeClasses(t, 'exit'),
            n.addClass(t, 'exit', 'done'),
            n.props.onExited && n.props.onExited(e);
        }),
        (n.resolveArguments = function (e, t) {
          return n.props.nodeRef ? [n.props.nodeRef.current, e] : [e, t];
        }),
        (n.getClassNames = function (e) {
          var t = n.props.classNames,
            r = 'string' == typeof t,
            o = r ? '' + (r && t ? t + '-' : '') + e : t[e];
          return {
            baseClassName: o,
            activeClassName: r ? o + '-active' : t[e + 'Active'],
            doneClassName: r ? o + '-done' : t[e + 'Done'],
          };
        }),
        n
      );
    }
    Yn(t, e);
    var r = t.prototype;
    return (
      (r.addClass = function (n, e, t) {
        var r = this.getClassNames(e)[t + 'ClassName'],
          o = this.getClassNames('enter').doneClassName;
        'appear' === e && 'done' === t && o && (r += ' ' + o),
          'active' === t && n && n.scrollTop,
          r && ((this.appliedClasses[e][t] = r), We(n, r));
      }),
      (r.removeClasses = function (n, e) {
        var t = this.appliedClasses[e],
          r = t.base,
          o = t.active,
          a = t.done;
        (this.appliedClasses[e] = {}),
          r && Ke(n, r),
          o && Ke(n, o),
          a && Ke(n, a);
      }),
      (r.render = function () {
        var e = this.props;
        e.classNames;
        var t = Wn(e, ['classNames']);
        return n.createElement(
          Ue,
          qn({}, t, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited,
          }),
        );
      }),
      t
    );
  })(n.Component);
function Ze(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 1024 1024' },
    child: [
      {
        tag: 'defs',
        attr: {},
        child: [
          {
            tag: 'clipPath',
            attr: {},
            child: [
              {
                tag: 'path',
                attr: {
                  fill: 'none',
                  d: 'M124-288l388-672 388 672H124z',
                  clipRule: 'evenodd',
                },
              },
            ],
          },
        ],
      },
      {
        tag: 'path',
        attr: {
          d: 'M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z',
        },
      },
      {
        tag: 'path',
        attr: {
          d: 'M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z',
        },
      },
    ],
  })(n);
}
function Je(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 1024 1024' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z',
        },
      },
    ],
  })(n);
}
function Xe(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 1024 1024' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z',
        },
      },
    ],
  })(n);
}
function Qe(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 1024 1024' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z',
        },
      },
    ],
  })(n);
}
(Ye.defaultProps = { classNames: '' }),
  (Ye.propTypes =
    'production' !== process.env.NODE_ENV
      ? qn({}, Ue.propTypes, {
          classNames: Ve,
          onEnter: je.func,
          onEntering: je.func,
          onEntered: je.func,
          onExit: je.func,
          onExiting: je.func,
          onExited: je.func,
        })
      : {});
var nt,
  et,
  tt,
  rt,
  ot,
  at,
  it,
  dt = s(
    nt ||
      (nt = x(
        [
          '\n0% {\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n100% {\n  -webkit-transform: rotate(360deg);\n  transform: rotate(360deg);\n}\n',
        ],
        [
          '\n0% {\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n100% {\n  -webkit-transform: rotate(360deg);\n  transform: rotate(360deg);\n}\n',
        ],
      )),
  ),
  lt = u.span(
    et ||
      (et = x(
        ['\n  color: grey;\n  font-family: ', ';\n  padding-left: 0.25em;\n'],
        ['\n  color: grey;\n  font-family: ', ';\n  padding-left: 0.25em;\n'],
      )),
    function (n) {
      return n.theme.fontBody;
    },
  ),
  ut = u.label(
    tt ||
      (tt = x(
        [
          '\n  color: ',
          ';\n  cursor: text;\n  display: block;\n  font-family: ',
          ';\n  font-size: ',
          ';\n  top: 50%;\n  transform: translateY(-50%);\n\n  left: 0.75em;\n  position: absolute;\n\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+/Edge */\n  user-select: none; /* Standard */\n\n  &.label-enter-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-enter-done {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-exit-enter {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-exit {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-exit-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &.label-exit-done {\n    font-size: ',
          ';\n    top: 50%;\n    transform: translateY(-50%);\n  }\n',
        ],
        [
          '\n  color: ',
          ';\n  cursor: text;\n  display: block;\n  font-family: ',
          ';\n  font-size: ',
          ';\n  top: 50%;\n  transform: translateY(-50%);\n\n  left: 0.75em;\n  position: absolute;\n\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+/Edge */\n  user-select: none; /* Standard */\n\n  &.label-enter-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-enter-done {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-exit-enter {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-exit {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25em;\n    transform: translateY(0);\n  }\n\n  &.label-exit-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &.label-exit-done {\n    font-size: ',
          ';\n    top: 50%;\n    transform: translateY(-50%);\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.grey500;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
    '100ms',
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    '100ms',
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
  ),
  st = u.input(
    rt ||
      (rt = x(
        [
          '\n  background-color: ',
          ';\n  border: 1px solid\n    ',
          ';\n  border-radius: ',
          ';\n  box-sizing: border-box;\n\n  color: ',
          ';\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n  padding: 1.5em 0.75em 0.5em 0.7em;\n  width: 100%;\n\n  &.password {\n    border-radius: ',
          ' 0 0 ',
          ';\n  }\n\n  &:focus {\n    border: 1px solid ',
          ';\n    box-shadow: 0 0 0 2px ',
          ';\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ',
          ';\n    cursor: not-allowed;\n  }\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    -webkit-transition-delay: 9999s;\n    transition-delay: 9999s;\n  }\n',
        ],
        [
          '\n  background-color: ',
          ';\n  border: 1px solid\n    ',
          ';\n  border-radius: ',
          ';\n  box-sizing: border-box;\n\n  color: ',
          ';\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n  padding: 1.5em 0.75em 0.5em 0.7em;\n  width: 100%;\n\n  &.password {\n    border-radius: ',
          ' 0 0 ',
          ';\n  }\n\n  &:focus {\n    border: 1px solid ',
          ';\n    box-shadow: 0 0 0 2px ',
          ';\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ',
          ';\n    cursor: not-allowed;\n  }\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    -webkit-transition-delay: 9999s;\n    transition-delay: 9999s;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.formGroupBg;
    },
    function (n) {
      var e = n.theme;
      return n.error ? e.formGroupBorderError : e.formGroupBorder;
    },
    '3px',
    function (n) {
      return n.theme.formGroupInput;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
    '3px',
    '3px',
    function (n) {
      return n.theme.formGroupFocusBorder;
    },
    function (n) {
      return n.theme.formGroupFocusGlow;
    },
    function (n) {
      return n.theme.formGroupBgDisabled;
    },
  ),
  ct = u.div(
    ot ||
      (ot = x(
        ['\n  display: flex;\n  position: relative;\n'],
        ['\n  display: flex;\n  position: relative;\n'],
      )),
  ),
  ft = u.div(
    at ||
      (at = x(
        [
          '\n  pointer-events: none;\n  position: absolute;\n  right: 0.75em;\n  top: 50%;\n  transform: translateY(-50%);\n\n  .icon-wrapper {\n    transform: scale(0);\n\n    &.icon-enter-active {\n      transform: scale(1);\n      transition: all 100ms ease-out;\n    }\n\n    &.icon-enter-done {\n      transform: scale(1);\n    }\n\n    &.icon-exit {\n      transform: scale(1);\n    }\n\n    &.icon-exit-active {\n      transform: scale(0);\n      transition: all 100ms ease-out;\n    }\n\n    svg {\n      animation: ',
          ' 1.1s infinite linear;\n      color: ',
          ';\n      font-size: 1.5em;\n    }\n  }\n',
        ],
        [
          '\n  pointer-events: none;\n  position: absolute;\n  right: 0.75em;\n  top: 50%;\n  transform: translateY(-50%);\n\n  .icon-wrapper {\n    transform: scale(0);\n\n    &.icon-enter-active {\n      transform: scale(1);\n      transition: all 100ms ease-out;\n    }\n\n    &.icon-enter-done {\n      transform: scale(1);\n    }\n\n    &.icon-exit {\n      transform: scale(1);\n    }\n\n    &.icon-exit-active {\n      transform: scale(0);\n      transition: all 100ms ease-out;\n    }\n\n    svg {\n      animation: ',
          ' 1.1s infinite linear;\n      color: ',
          ';\n      font-size: 1.5em;\n    }\n  }\n',
        ],
      )),
    dt,
    function (n) {
      return n.theme.primary400;
    },
  ),
  mt = u.div(
    it ||
      (it = x(
        [
          '\n  background-color: ',
          ';\n  border-radius: 0 ',
          ' ',
          ' 0;\n  color: ',
          ';\n  cursor: pointer;\n  font-size: ',
          ';\n\n  display: flex;\n  align-items: center;\n\n  padding: 0 0.25em;\n\n  &:hover {\n    color: ',
          ';\n  }\n',
        ],
        [
          '\n  background-color: ',
          ';\n  border-radius: 0 ',
          ' ',
          ' 0;\n  color: ',
          ';\n  cursor: pointer;\n  font-size: ',
          ';\n\n  display: flex;\n  align-items: center;\n\n  padding: 0 0.25em;\n\n  &:hover {\n    color: ',
          ';\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.primary400;
    },
    '3px',
    '3px',
    function (n) {
      return n.theme.eyeColour;
    },
    function (n) {
      return n.theme.fontSizeLarge;
    },
    function (n) {
      return n.theme.eyeColourHover;
    },
  );
(lt.defaultProps = { theme: J }),
  (mt.defaultProps = { theme: J }),
  (ut.defaultProps = { theme: J }),
  (st.defaultProps = { theme: J }),
  (ft.defaultProps = { theme: J }),
  (ft.defaultProps = { theme: J });
var pt = function (o) {
  var a = e(!1),
    i = a[0],
    d = a[1],
    l = e(!1),
    u = l[0],
    s = l[1],
    c = e(!1),
    f = c[0],
    m = c[1],
    p = t(null),
    $ = t(null),
    h = o.className,
    b = o.error,
    v = o.errorMessage,
    x = o.label,
    C = o.loading,
    w = o.name,
    E = o.required,
    N = o.showErrorOnChange,
    P = o.showLoadingIcon,
    S = o.value,
    O = o.theme,
    k = o.updateValue,
    I = o._activated,
    A = y(o, [
      'className',
      'error',
      'errorMessage',
      'label',
      'loading',
      'name',
      'required',
      'showErrorOnChange',
      'showLoadingIcon',
      'value',
      'theme',
      'updateValue',
      '_activated',
    ]);
  var R = E ? '' : n.createElement(lt, null, '(Optional)'),
    B = null;
  x && (B = n.createElement(ut, { htmlFor: w, ref: p }, x, R));
  var M = A.type && 'password' === A.type,
    F = null;
  return (
    M &&
      ((F = n.createElement(
        mt,
        {
          onClick: function () {
            m(!f);
          },
          'data-testid': 'password-eye',
        },
        f ? n.createElement(Ze, null) : n.createElement(Je, null),
      )),
      f && (A.type = 'text')),
    r(
      function () {
        if (S) {
          d(!0);
          var n = p.current;
          if (n) {
            var e = n;
            e.classList.contains('label-exit') || e.classList.add('label-exit');
          }
        } else d(!1);
        I && s(!0);
      },
      [b, S, O, I],
    ),
    n.createElement(
      'div',
      { className: 'form-input-wrapper' },
      n.createElement(
        ct,
        null,
        n.createElement(
          Ye,
          { appear: !0, in: i, nodeRef: p, timeout: 100, classNames: 'label' },
          B,
        ),
        n.createElement(
          st,
          g(
            {
              id: w,
              className: (h || '') + ' ' + (M ? 'password' : ''),
              error: u && b,
              name: w,
              value: S,
              'data-testid': 'form-input',
              onChange: function (n) {
                var e = n.target.value;
                s(N || !1), k && k(e);
              },
            },
            A,
            {
              onBlur: function (n) {
                var e = n.target.value;
                d(e.length > 0), s(!0);
              },
              onFocus: function () {
                d(!0);
              },
              placeholder: void 0,
            },
          ),
        ),
        n.createElement(
          Ye,
          {
            appear: !0,
            in: C && P,
            nodeRef: $,
            timeout: 100,
            classNames: 'icon',
          },
          n.createElement(
            ft,
            null,
            n.createElement(
              'div',
              { className: 'icon-wrapper', ref: $ },
              n.createElement(Qe, null),
            ),
          ),
        ),
        F,
      ),
      n.createElement(
        zn,
        { hidden: !(u && b) },
        n.createElement(T, null),
        ' ',
        v,
      ),
    )
  );
};
pt.defaultProps = { label: '', name: '', theme: {}, _activated: !1 };
var $t,
  ht,
  gt,
  yt,
  bt,
  vt = f(pt),
  xt = u.span(
    $t ||
      ($t = x(
        ['\n  color: grey;\n  font-family: ', ';\n  padding-left: 0.25em;\n'],
        ['\n  color: grey;\n  font-family: ', ';\n  padding-left: 0.25em;\n'],
      )),
    function (n) {
      return n.theme.fontBody;
    },
  ),
  Ct = u.label(
    ht ||
      (ht = x(
        [
          '\n  color: ',
          ';\n  cursor: text;\n  display: block;\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  top: 0.75rem;\n  left: 0.75rem;\n\n  position: absolute;\n\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+/Edge */\n  user-select: none; /* Standard */\n\n  &.label-enter-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-enter-done {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-exit-enter {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-exit {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-exit-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.75rem;\n  }\n\n  &.label-exit-done {\n    font-size: ',
          ';\n    top: 0.75rem;\n  }\n',
        ],
        [
          '\n  color: ',
          ';\n  cursor: text;\n  display: block;\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  top: 0.75rem;\n  left: 0.75rem;\n\n  position: absolute;\n\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+/Edge */\n  user-select: none; /* Standard */\n\n  &.label-enter-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-enter-done {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-exit-enter {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-exit {\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.25rem;\n  }\n\n  &.label-exit-active {\n    transition: all ',
          ' ease-out;\n    color: ',
          ';\n    font-size: ',
          ';\n    top: 0.75rem;\n  }\n\n  &.label-exit-done {\n    font-size: ',
          ';\n    top: 0.75rem;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.grey500;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
    '100ms',
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
    '100ms',
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
  ),
  wt = u.textarea(
    gt ||
      (gt = x(
        [
          '\n  background-color: ',
          ';\n  border: 1px solid\n    ',
          ';\n  border-radius: ',
          ';\n  box-sizing: border-box;\n\n  color: ',
          ';\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n  padding: 1.5em 0.75em 0.5em 0.7em;\n  width: 100%;\n\n  &.password {\n    border-radius: ',
          ' 0 0 ',
          ';\n  }\n\n  &:focus {\n    border: 1px solid ',
          ';\n    box-shadow: 0 0 0 2px ',
          ';\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ',
          ';\n    cursor: not-allowed;\n  }\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    -webkit-transition-delay: 9999s;\n    transition-delay: 9999s;\n  }\n',
        ],
        [
          '\n  background-color: ',
          ';\n  border: 1px solid\n    ',
          ';\n  border-radius: ',
          ';\n  box-sizing: border-box;\n\n  color: ',
          ';\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n  padding: 1.5em 0.75em 0.5em 0.7em;\n  width: 100%;\n\n  &.password {\n    border-radius: ',
          ' 0 0 ',
          ';\n  }\n\n  &:focus {\n    border: 1px solid ',
          ';\n    box-shadow: 0 0 0 2px ',
          ';\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ',
          ';\n    cursor: not-allowed;\n  }\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    -webkit-transition-delay: 9999s;\n    transition-delay: 9999s;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.formGroupBg;
    },
    function (n) {
      var e = n.theme;
      return n.error ? e.formGroupBorderError : e.formGroupBorder;
    },
    '3px',
    function (n) {
      return n.theme.formGroupInput;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
    '3px',
    '3px',
    function (n) {
      return n.theme.formGroupFocusBorder;
    },
    function (n) {
      return n.theme.formGroupFocusGlow;
    },
    function (n) {
      return n.theme.formGroupBgDisabled;
    },
  ),
  Et = u.div(
    yt ||
      (yt = x(
        ['\n  display: flex;\n  position: relative;\n'],
        ['\n  display: flex;\n  position: relative;\n'],
      )),
  ),
  Nt = u.div(
    bt ||
      (bt = x(
        [
          '\n  color: ',
          ';\n\n  display: flex;\n  align-items: center;\n\n  font-family: ',
          ';\n  font-size: ',
          ";\n\n  height: 20px;\n  padding: 0.5em 0;\n  overflow: hidden;\n  transition: all 0.1s ease-out;\n  opacity: 1;\n\n  &[data-hidden='true'] {\n    opacity: 0;\n  }\n",
        ],
        [
          '\n  color: ',
          ';\n\n  display: flex;\n  align-items: center;\n\n  font-family: ',
          ';\n  font-size: ',
          ";\n\n  height: 20px;\n  padding: 0.5em 0;\n  overflow: hidden;\n  transition: all 0.1s ease-out;\n  opacity: 1;\n\n  &[data-hidden='true'] {\n    opacity: 0;\n  }\n",
        ],
      )),
    function (n) {
      return n.theme.formGroupTextError;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
  );
(xt.defaultProps = { theme: J }),
  (Ct.defaultProps = { theme: J }),
  (wt.defaultProps = { theme: J }),
  (Nt.defaultProps = { theme: J });
var Pt = function (o) {
  var a = e(!1),
    i = a[0],
    d = a[1],
    l = e(!1),
    u = l[0],
    s = l[1],
    c = t(null),
    f = o.className,
    m = o.error,
    p = o.errorMessage,
    $ = o.label,
    h = o.name,
    b = o.required,
    v = o.showErrorOnChange,
    x = o.value,
    C = o.theme,
    w = o.updateValue,
    E = o._activated,
    N = y(o, [
      'className',
      'error',
      'errorMessage',
      'label',
      'name',
      'required',
      'showErrorOnChange',
      'value',
      'theme',
      'updateValue',
      '_activated',
    ]);
  var P = b ? '' : n.createElement(xt, null, '(Optional)'),
    S = null;
  return (
    $ && (S = n.createElement(Ct, { htmlFor: h, ref: c }, $, P)),
    (N.loading = void 0),
    r(
      function () {
        if (x) {
          d(!0);
          var n = c.current;
          if (n) {
            var e = n;
            e.classList.contains('label-exit') || e.classList.add('label-exit');
          }
        } else d(!1);
        E && s(!0);
      },
      [m, x, C, E],
    ),
    n.createElement(
      n.Fragment,
      null,
      n.createElement(
        Et,
        null,
        n.createElement(
          Ye,
          { appear: !0, in: i, nodeRef: c, timeout: 100, classNames: 'label' },
          S,
        ),
        n.createElement(
          wt,
          g(
            {
              id: h,
              className: f || '',
              error: u && m,
              name: h,
              value: x,
              'data-testid': 'form-input',
              onChange: function (n) {
                var e = n.target.value;
                s(v || !1), w && w(e);
              },
            },
            N,
            {
              onBlur: function (n) {
                var e = n.target.value;
                d(e.length > 0), s(!0);
              },
              onFocus: function () {
                d(!0);
              },
              placeholder: void 0,
            },
          ),
        ),
      ),
      n.createElement(
        Nt,
        { 'data-hidden': !(u && m) },
        n.createElement(T, null),
        ' ',
        p,
      ),
    )
  );
};
Pt.defaultProps = { label: '', name: '', theme: {}, _activated: !1 };
var St,
  Ot,
  kt = f(Pt),
  It = (function (e) {
    function t(n) {
      var t = e.call(this, n) || this;
      return (
        (t.componentWillUnmount = function () {
          t.mounted = !1;
        }),
        (t.componentDidUpdate = function (n) {
          var e = t.props,
            r = e._activated,
            o = e._cleared,
            a = e.informInvalid,
            i = e.onChange,
            d = e.name;
          if (n._activated !== r && r) {
            var l = t.state.value;
            t.updateValue(l || '');
          } else
            n._activated === r ||
              r ||
              t.setState({ validationFailed: !1, validationMessage: '' });
          n._cleared !== o &&
            o &&
            (a(d, !0), i(d, ''), t.setState({ value: '' }));
        }),
        (t.finishValidation = function (n, e, r) {
          var o = t.props,
            a = o.informInvalid,
            i = o.name,
            d = o.required,
            l = t.state.value;
          t.mounted &&
            (l &&
              l === n &&
              t.setState({ validationFailed: !e, validationMessage: r }),
            l || d || t.setState({ validationFailed: !1 }),
            0 === t.activeValidators
              ? (t.setState({ loading: !1 }), a && a(i, !e))
              : a && a(i, !0));
        }),
        (t.validate = function (n) {
          return b(t, void 0, void 0, function () {
            var e, t, r, o, a, i;
            return v(this, function (d) {
              switch (d.label) {
                case 0:
                  (e = this.props.validators),
                    this.setState({ loading: !0 }),
                    (t = !0),
                    (r = ''),
                    (o = 0),
                    (a = e),
                    (d.label = 1);
                case 1:
                  return o < a.length
                    ? ((i = a[o]),
                      this.activeValidators++,
                      [4, Promise.resolve(i.validator(n))])
                    : [3, 4];
                case 2:
                  if (((t = d.sent()), this.activeValidators--, !t))
                    return (r = i.errorMessage), [3, 4];
                  d.label = 3;
                case 3:
                  return o++, [3, 1];
                case 4:
                  return this.finishValidation(n, t, r), [2];
              }
            });
          });
        }),
        (t.updateValue = function (n) {
          var e = t.props,
            r = e.informInvalid,
            o = e.onChange,
            a = e.peek,
            i = e.name,
            d = e.required;
          a && a(i, n),
            r && r(i, !0),
            o && o(i, n),
            t.setState({ value: n }),
            !n && d
              ? (t.setState({
                  validationFailed: !0,
                  validationMessage: 'This is a required field.',
                }),
                r && r(i, !0))
              : Promise.resolve().then(function () {
                  t.validate(n);
                });
        }),
        (t.activeValidators = 0),
        (t.mounted = !0),
        (t.state = {
          loading: !1,
          validationFailed: !1,
          validationMessage: '',
          value: n.defaultValue,
        }),
        t
      );
    }
    return (
      h(t, e),
      (t.prototype.render = function () {
        var e = this,
          t = this.props,
          r = t.children,
          o = t.name,
          a = t.required,
          i = t.type,
          d = t._activated,
          l = this.state,
          u = l.loading,
          s = l.validationFailed,
          c = l.validationMessage,
          f = l.value;
        return n.Children.map(r, function (t) {
          return 'checkbox' === i
            ? n.cloneElement(t, {
                updateValue: e.updateValue,
                name: o,
                type: i,
                value: f,
                required: a,
              })
            : n.cloneElement(t, {
                updateValue: e.updateValue,
                name: o,
                error: s,
                errorMessage: c,
                loading: u,
                type: i,
                value: f,
                required: a,
                _activated: d,
              });
        });
      }),
      (t.defaultProps = {
        defaultValue: '',
        onChange: void 0,
        informInvalid: void 0,
        validators: [],
        required: !1,
        type: 'text',
        peek: void 0,
        _activated: !1,
      }),
      t
    );
  })(n.Component),
  Tt = u.form(St || (St = x([''], ['']))),
  At = (function (e) {
    function t() {
      var n = (null !== e && e.apply(this, arguments)) || this;
      return (
        (n.state = {
          data: {},
          _activated: !1,
          _cleared: !1,
          _mountFinished: !1,
        }),
        (n.onChange = function (e, t) {
          var r = n.state.data;
          r[e] && ((r[e].value = t), n.setState({ data: g({}, r) }));
        }),
        (n.informInvalid = function (e, t) {
          var r = n.state.data;
          r[e] && ((r[e].validated = !t), n.setState({ data: g({}, r) }));
        }),
        (n.onSubmit = function (e) {
          e.preventDefault();
          var t = n.props,
            r = t.clearOnSubmit,
            o = t.onSubmit,
            a = n.state.data;
          if (
            (n.setState({ _activated: !0 }),
            !Object.keys(a).some(function (n) {
              var e = a[n];
              return (
                !(e.value || !e.required) ||
                (!(!e.value && !e.required) && !e.validated)
              );
            }))
          ) {
            r && n.setState({ _cleared: !0 });
            var i = {};
            Object.keys(a).forEach(function (n) {
              return (i[n] = a[n].value);
            }),
              o(i);
          }
        }),
        n
      );
    }
    return (
      h(t, e),
      (t.prototype.componentDidMount = function () {
        var e = this.props.children,
          t = {},
          r = function (e) {
            if (n.isValidElement(e)) {
              var o = e.props,
                a = e.type;
              if (a === It) {
                var i = {
                  value: o.defaultValue || '',
                  validated: !1,
                  required: o.required || !1,
                };
                t[o.name] = i;
              } else a !== Un && o.children && n.Children.map(o.children, r);
            }
          };
        n.Children.map(e, r),
          this.setState({ data: g({}, t), _mountFinished: !0 });
      }),
      (t.prototype.componentDidUpdate = function (n, e) {
        var t = this.state,
          r = t._cleared,
          o = t.data;
        e._cleared !== r &&
          r &&
          this.setState({ _activated: !1, _cleared: !1, data: g({}, o) });
      }),
      (t.prototype.render = function () {
        var e = this,
          t = this.props,
          r = t.children,
          o = y(t, ['children']),
          a = this.state,
          i = a._activated,
          d = a._cleared,
          l = a._mountFinished,
          u = function (t) {
            if (n.isValidElement(t)) {
              var r = t.props;
              if (t.type === It) {
                var o = r.defaultValue;
                return n.cloneElement(t, {
                  _activated: i || (o.length && l),
                  _cleared: d,
                  onChange: e.onChange,
                  informInvalid: e.informInvalid,
                });
              }
              return r.children
                ? n.cloneElement(t, { children: n.Children.map(r.children, u) })
                : t;
            }
            return t;
          },
          s = n.Children.map(r, u);
        return n.createElement(Tt, g({}, o, { onSubmit: this.onSubmit }), s);
      }),
      (t.Checkbox = Vn),
      (t.Header = Un),
      (t.Input = vt),
      (t.Textarea = kt),
      (t.Validator = It),
      (t.defaultProps = { clearOnSubmit: !1 }),
      t
    );
  })(n.Component),
  Rt = o({}),
  Bt = u.a(
    Ot ||
      (Ot = x(
        [
          '\n  color: ',
          ';\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n\n  font-family: ',
          ';\n  font-size: 0.9rem;\n\n  padding: 0.5rem;\n  position: relative;\n  text-decoration: none;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  &:hover {\n    color: ',
          ';\n  }\n\n  &.active {\n    color: ',
          ';\n  }\n',
        ],
        [
          '\n  color: ',
          ';\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n\n  font-family: ',
          ';\n  font-size: 0.9rem;\n\n  padding: 0.5rem;\n  position: relative;\n  text-decoration: none;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  &:hover {\n    color: ',
          ';\n  }\n\n  &.active {\n    color: ',
          ';\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.menuItemColour;
    },
    function (n) {
      return n.theme.fontHeader;
    },
    function (n) {
      return n.theme.menuItemHover;
    },
    function (n) {
      return n.theme.menuItemActive;
    },
  );
Bt.defaultProps = { theme: J };
var Mt,
  Ft,
  Dt,
  Lt,
  jt,
  zt,
  Gt,
  _t = u.div(
    Mt ||
      (Mt = x(
        [
          '\n  background-color: ',
          ';\n  position: relative;\n\n  &.shadow {\n    box-shadow: ',
          ';\n  }\n',
        ],
        [
          '\n  background-color: ',
          ';\n  position: relative;\n\n  &.shadow {\n    box-shadow: ',
          ';\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.menuBgColour;
    },
    function (n) {
      return n.theme.menuShadow;
    },
  ),
  Vt = u.div(
    Ft ||
      (Ft = x(
        [
          '\n  display: flex;\n  position: relative;\n\n  max-width: 1300px;\n  margin: auto;\n\n  .col-1 {\n    display: flex;\n    align-items: center;\n    flex-basis: 20%;\n  }\n\n  .col-2 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-basis: 60%;\n  }\n\n  .col-3 {\n    flex-basis: 20%;\n  }\n\n  @media only screen and (min-width: ',
          ') {\n    .col-1,\n    .col-3 {\n      display: none;\n    }\n    .col-2 {\n      flex-basis: 0%;\n    }\n    justify-content: space-between;\n  }\n',
        ],
        [
          '\n  display: flex;\n  position: relative;\n\n  max-width: 1300px;\n  margin: auto;\n\n  .col-1 {\n    display: flex;\n    align-items: center;\n    flex-basis: 20%;\n  }\n\n  .col-2 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-basis: 60%;\n  }\n\n  .col-3 {\n    flex-basis: 20%;\n  }\n\n  @media only screen and (min-width: ',
          ') {\n    .col-1,\n    .col-3 {\n      display: none;\n    }\n    .col-2 {\n      flex-basis: 0%;\n    }\n    justify-content: space-between;\n  }\n',
        ],
      )),
    '1200px',
  ),
  Ht = u.div(
    Dt ||
      (Dt = x(
        [
          '\n  display: none;\n\n  ',
          '.active::after {\n    background: ',
          ";\n    position: absolute;\n    bottom: 0px;\n    left: 0.5rem;\n    right: 0.5rem;\n    content: '';\n    height: 3px;\n    border-top-left-radius: 1px;\n    border-top-right-radius: 1px;\n  }\n\n  @media only screen and (min-width: ",
          ') {\n    display: flex;\n    align-items: stretch;\n  }\n',
        ],
        [
          '\n  display: none;\n\n  ',
          '.active::after {\n    background: ',
          ";\n    position: absolute;\n    bottom: 0px;\n    left: 0.5rem;\n    right: 0.5rem;\n    content: '';\n    height: 3px;\n    border-top-left-radius: 1px;\n    border-top-right-radius: 1px;\n  }\n\n  @media only screen and (min-width: ",
          ') {\n    display: flex;\n    align-items: stretch;\n  }\n',
        ],
      )),
    Bt,
    function (n) {
      return n.theme.menuItemActive;
    },
    '1200px',
  ),
  Ut = u.div(
    Lt ||
      (Lt = x(
        [
          '\n  background-color: ',
          ';\n  box-sizing: border-box;\n  position: absolute;\n  width: 0;\n  top: 100%;\n  overflow-x: hidden;\n  padding: 0.5rem 0;\n\n  z-index: 1200;\n\n  &.mobile-enter {\n    padding: 0.5rem 0;\n  }\n\n  &.mobile-enter-active {\n    padding: 0.5rem;\n    transition: all 300ms;\n    width: 100%;\n  }\n\n  &.mobile-enter-done {\n    padding: 0.5rem;\n    width: 100%;\n  }\n\n  &.mobile-exit {\n    padding: 0.5rem;\n    width: 100%;\n  }\n\n  &.mobile-exit-active {\n    padding: 0.5rem 0;\n    width: 0;\n    transition: all 300ms;\n  }\n\n  @media only screen and (min-width: ',
          ') {\n    display: none;\n  }\n',
        ],
        [
          '\n  background-color: ',
          ';\n  box-sizing: border-box;\n  position: absolute;\n  width: 0;\n  top: 100%;\n  overflow-x: hidden;\n  padding: 0.5rem 0;\n\n  z-index: 1200;\n\n  &.mobile-enter {\n    padding: 0.5rem 0;\n  }\n\n  &.mobile-enter-active {\n    padding: 0.5rem;\n    transition: all 300ms;\n    width: 100%;\n  }\n\n  &.mobile-enter-done {\n    padding: 0.5rem;\n    width: 100%;\n  }\n\n  &.mobile-exit {\n    padding: 0.5rem;\n    width: 100%;\n  }\n\n  &.mobile-exit-active {\n    padding: 0.5rem 0;\n    width: 0;\n    transition: all 300ms;\n  }\n\n  @media only screen and (min-width: ',
          ') {\n    display: none;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.menuMobileBg;
    },
    '1200px',
  ),
  qt = u.img(
    jt ||
      (jt = x(
        ['\n  height: 32px;\n  padding: 0.5rem;\n'],
        ['\n  height: 32px;\n  padding: 0.5rem;\n'],
      )),
  ),
  Wt = u.span(
    zt ||
      (zt = x(
        [
          '\n  border-left: 1px solid ',
          ';\n  display: none;\n  margin: 0.8rem;\n\n  @media only screen and (min-width: 1200px) {\n    display: block;\n  }\n',
        ],
        [
          '\n  border-left: 1px solid ',
          ';\n  display: none;\n  margin: 0.8rem;\n\n  @media only screen and (min-width: 1200px) {\n    display: block;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.menuDivider;
    },
  ),
  Kt = u.div(
    Gt ||
      (Gt = x(
        [
          '\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1199;\n',
        ],
        [
          '\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1199;\n',
        ],
      )),
  );
(_t.defaultProps = { theme: J }),
  (Wt.defaultProps = { theme: J }),
  (Ut.defaultProps = { theme: J });
var Yt,
  Zt = u.button(
    Yt ||
      (Yt = x(
        [
          '\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  margin-left: 1em;\n  padding: 0;\n  position: absolute;\n\n  height: 22px;\n  width: 32px;\n\n  z-index: 12000;\n\n  @media only screen and (min-width: ',
          ') {\n    display: none;\n  }\n\n  span {\n    background-color: ',
          ';\n    border-radius: 3px;\n    display: block;\n    height: 4px;\n    width: 100%;\n    position: absolute;\n    transition: all 125ms ease-in-out;\n    transform-origin: center center;\n\n    &:nth-child(1) {\n      top: 0;\n      transform: rotate(0deg);\n    }\n\n    &:nth-child(2) {\n      opacity: 1;\n      top: 50%;\n      transform: translateY(-50%) rotate(0deg);\n    }\n\n    &:nth-child(3) {\n      top: 100%;\n      transform: translateY(-100%) rotate(0deg);\n    }\n  }\n\n  &.open {\n    span:nth-child(1) {\n      background-color: ',
          ';\n      top: 50%;\n      transform: translateY(-50%) rotate(45deg);\n    }\n\n    span:nth-child(2) {\n      background-color: ',
          ';\n      opacity: 0;\n      width: 0;\n    }\n\n    span:nth-child(3) {\n      background-color: ',
          ';\n      top: 50%;\n      transform: translateY(-50%) rotate(-45deg);\n    }\n  }\n',
        ],
        [
          '\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  margin-left: 1em;\n  padding: 0;\n  position: absolute;\n\n  height: 22px;\n  width: 32px;\n\n  z-index: 12000;\n\n  @media only screen and (min-width: ',
          ') {\n    display: none;\n  }\n\n  span {\n    background-color: ',
          ';\n    border-radius: 3px;\n    display: block;\n    height: 4px;\n    width: 100%;\n    position: absolute;\n    transition: all 125ms ease-in-out;\n    transform-origin: center center;\n\n    &:nth-child(1) {\n      top: 0;\n      transform: rotate(0deg);\n    }\n\n    &:nth-child(2) {\n      opacity: 1;\n      top: 50%;\n      transform: translateY(-50%) rotate(0deg);\n    }\n\n    &:nth-child(3) {\n      top: 100%;\n      transform: translateY(-100%) rotate(0deg);\n    }\n  }\n\n  &.open {\n    span:nth-child(1) {\n      background-color: ',
          ';\n      top: 50%;\n      transform: translateY(-50%) rotate(45deg);\n    }\n\n    span:nth-child(2) {\n      background-color: ',
          ';\n      opacity: 0;\n      width: 0;\n    }\n\n    span:nth-child(3) {\n      background-color: ',
          ';\n      top: 50%;\n      transform: translateY(-50%) rotate(-45deg);\n    }\n  }\n',
        ],
      )),
    '1200px',
    function (n) {
      return n.theme.menuHamburgerColor;
    },
    function (n) {
      return n.theme.menuHamburgerColorActive;
    },
    function (n) {
      return n.theme.menuHamburgerColorActive;
    },
    function (n) {
      return n.theme.menuHamburgerColorActive;
    },
  );
function Jt(e) {
  var t = e.open,
    r = y(e, ['open']);
  return n.createElement(
    Zt,
    g({}, r, {
      className: t ? 'hamburger open' : 'hamburger',
      'data-cy': 'hamburger-menu',
      'aria-label': 'hamburger',
    }),
    n.createElement('span', null),
    n.createElement('span', null),
    n.createElement('span', null),
  );
}
function Xt(n) {
  return S({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      {
        tag: 'path',
        attr: { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' },
      },
    ],
  })(n);
}
(Zt.defaultProps = { theme: J }), (Jt.defaultProps = { open: !1 });
var Qt,
  nr,
  er,
  tr = u.div(
    Qt ||
      (Qt = x(
        [
          '\n  display: none;\n\n  left: 0.5rem;\n  padding: 0rem 1rem;\n  top: 100%;\n\n  z-index: 1000;\n\n  ',
          ' {\n    color: rgba(255, 255, 255, 0.75);\n\n    &.active {\n      color: ',
          ';\n    }\n  }\n\n  @media only screen and (min-width: 1200px) {\n    position: absolute;\n    background-color: ',
          ';\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n      0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    border-bottom: 4px solid ',
          ';\n    border-top: 0;\n\n    padding: 0.5rem 3rem 0.5rem 0.5rem;\n\n    ',
          ' {\n      color: ',
          ';\n\n      &::after {\n        display: none;\n      }\n\n      &:hover {\n        color: ',
          ';\n      }\n\n      &.active {\n        color: ',
          ';\n      }\n    }\n  }\n',
        ],
        [
          '\n  display: none;\n\n  left: 0.5rem;\n  padding: 0rem 1rem;\n  top: 100%;\n\n  z-index: 1000;\n\n  ',
          ' {\n    color: rgba(255, 255, 255, 0.75);\n\n    &.active {\n      color: ',
          ';\n    }\n  }\n\n  @media only screen and (min-width: 1200px) {\n    position: absolute;\n    background-color: ',
          ';\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n      0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    border-bottom: 4px solid ',
          ';\n    border-top: 0;\n\n    padding: 0.5rem 3rem 0.5rem 0.5rem;\n\n    ',
          ' {\n      color: ',
          ';\n\n      &::after {\n        display: none;\n      }\n\n      &:hover {\n        color: ',
          ';\n      }\n\n      &.active {\n        color: ',
          ';\n      }\n    }\n  }\n',
        ],
      )),
    Bt,
    function (n) {
      return n.theme.menuDropdownTextActive;
    },
    function (n) {
      return n.theme.menuDropdownBg;
    },
    function (n) {
      return n.theme.primary400;
    },
    Bt,
    function (n) {
      return n.theme.menuDropdownText;
    },
    function (n) {
      return n.theme.menuDropdownTextHover;
    },
    function (n) {
      return n.theme.menuDropdownTextActive;
    },
  ),
  rr = u.div(
    nr ||
      (nr = x(
        [
          '\n  display: flex;\n  align-items: center;\n  font-size: 1.25rem;\n  transition: transform 100ms;\n\n  margin-left: -0.45rem;\n',
        ],
        [
          '\n  display: flex;\n  align-items: center;\n  font-size: 1.25rem;\n  transition: transform 100ms;\n\n  margin-left: -0.45rem;\n',
        ],
      )),
  ),
  or = u.div(
    er ||
      (er = x(
        [
          '\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-flow: column;\n\n  ',
          ' {\n    height: calc(100% - 1rem);\n  }\n\n  &.expanded {\n    border-bottom: 1px solid grey;\n\n    ',
          ' {\n      transform: rotate(90deg);\n    }\n\n    ',
          ' {\n      display: block;\n    }\n\n    @media only screen and (min-width: 1200px) {\n      border-bottom: none;\n    }\n  }\n',
        ],
        [
          '\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-flow: column;\n\n  ',
          ' {\n    height: calc(100% - 1rem);\n  }\n\n  &.expanded {\n    border-bottom: 1px solid grey;\n\n    ',
          ' {\n      transform: rotate(90deg);\n    }\n\n    ',
          ' {\n      display: block;\n    }\n\n    @media only screen and (min-width: 1200px) {\n      border-bottom: none;\n    }\n  }\n',
        ],
      )),
    Bt,
    rr,
    tr,
  );
tr.defaultProps = { theme: J };
var ar = function (o) {
  var i = o.className,
    d = o.children,
    l = o.label,
    u = e([]),
    s = u[0],
    c = u[1],
    f = e(!1),
    m = f[0],
    p = f[1],
    $ = a(Rt),
    h = t(null);
  function g(n) {
    var e;
    (null === (e = null == h ? void 0 : h.current) || void 0 === e
      ? void 0
      : e.contains(n.target)) || p(!1);
  }
  r(
    function () {
      if (d) {
        var e = n.Children.map(d, function (n) {
          if (n && 'string' != typeof n) return n.props.to;
        });
        e && c(e);
      }
    },
    [d],
  ),
    r(function () {
      return (
        document.addEventListener('mousedown', g),
        function () {
          document.removeEventListener('mousedown', g);
        }
      );
    }, []);
  var y = s.some(function (n) {
    return n === $.activeId;
  });
  return n.createElement(
    or,
    { className: m ? 'expanded' : '', ref: h },
    n.createElement(
      Bt,
      {
        className: 'menu-dropdown ' + (i || '') + ' ' + (y ? 'active' : ''),
        onClick: function () {
          p(!m);
        },
      },
      n.createElement(rr, null, n.createElement(Xt, null)),
      l,
    ),
    n.createElement(tr, null, d),
  );
};
function ir(e) {
  var t = e.className,
    r = e.children,
    o = e.to,
    i = y(e, ['className', 'children', 'to']),
    d = a(Rt),
    l = d.activeId,
    u = d.changeActiveId;
  return n.createElement(
    Bt,
    g(
      { className: 'menu-item ' + (t || '') + ' ' + (l === o ? 'active' : '') },
      i,
      {
        onClick: function (n) {
          i.href || (n.preventDefault(), u && u(o || ''));
        },
      },
    ),
    r,
  );
}
function dr(o) {
  var a = o.activeId,
    d = o.children,
    l = o.cover,
    u = o.className,
    s = o.img,
    c = o.imgObj,
    f = o.onMenuClick,
    m = o.shadow,
    p = y(o, [
      'activeId',
      'children',
      'cover',
      'className',
      'img',
      'imgObj',
      'onMenuClick',
      'shadow',
    ]),
    $ = e(!1),
    h = $[0],
    b = $[1],
    v = e([]),
    x = v[0],
    C = v[1],
    w = t(null);
  return (
    r(
      function () {
        var e = (function e(t) {
          return n.Children.map(t, function (t) {
            if (n.isValidElement(t)) {
              if ((null == t ? void 0 : t.type) === ir)
                return n.cloneElement(t);
              if ((null == t ? void 0 : t.type) === ar) {
                var r = n.Children.map(
                  null == t ? void 0 : t.props.children,
                  e,
                );
                return n.cloneElement(t, { children: r });
              }
              if (null == t ? void 0 : t.props.children)
                return e(null == t ? void 0 : t.props.children);
            }
            return null;
          });
        })(d);
        C(e);
      },
      [d],
    ),
    i(function () {
      function n() {
        window.innerWidth >= 1200 && b(!1);
      }
      return (
        window.addEventListener('resize', n),
        function () {
          return window.removeEventListener('resize', n);
        }
      );
    }),
    n.createElement(
      n.Fragment,
      null,
      n.createElement(
        _t,
        g(
          {
            className:
              'navigation-bar ' + (u || '') + ' ' + (m ? 'shadow' : ''),
          },
          p,
        ),
        n.createElement(
          Rt.Provider,
          {
            value: {
              activeId: a,
              changeActiveId: function (n) {
                f && f(n), h && b(!1);
              },
            },
          },
          n.createElement(
            Vt,
            { className: 'head' },
            n.createElement(
              'div',
              { className: 'col-1' },
              n.createElement(Jt, {
                open: h,
                onClick: function () {
                  return b(!h);
                },
              }),
            ),
            n.createElement(
              'div',
              { className: 'col-2' },
              c || n.createElement(qt, { src: s, alt: 'logo' }),
            ),
            n.createElement('div', { className: 'col-3' }),
            n.createElement(
              Ht,
              { className: 'desktop-container', 'data-cy': 'desktop-menu' },
              d,
            ),
            n.createElement(
              Ye,
              {
                in: h,
                timeout: 300,
                nodeRef: w,
                className: 'mobile-container',
                classNames: 'mobile',
              },
              n.createElement(Ut, { ref: w, 'data-cy': 'mobile-menu' }, x),
            ),
          ),
        ),
      ),
      h && l
        ? n.createElement(Kt, {
            onClick: function () {
              b(!1);
            },
          })
        : null,
    )
  );
}
(dr.Divider = Wt), (dr.Dropdown = ar), (dr.Item = ir);
var lr,
  ur,
  sr,
  cr,
  fr,
  mr,
  pr,
  $r,
  hr = u.button(
    lr ||
      (lr = x(
        [
          '\n  background-color: ',
          ';\n  border: none;\n  cursor: pointer;\n  color: ',
          ';\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  top: 0;\n  right: 0;\n\n  font-size: 2em;\n\n  width: 36px;\n  height: 36px;\n',
        ],
        [
          '\n  background-color: ',
          ';\n  border: none;\n  cursor: pointer;\n  color: ',
          ';\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  top: 0;\n  right: 0;\n\n  font-size: 2em;\n\n  width: 36px;\n  height: 36px;\n',
        ],
      )),
    function (n) {
      return n.theme.modalCloseBg;
    },
    function (n) {
      return n.theme.modalCloseText;
    },
  ),
  gr = u.div(
    ur ||
      (ur = x(
        [
          '\n  text-align: right;\n\n  button {\n    margin-left: 0.5em;\n  }\n',
        ],
        [
          '\n  text-align: right;\n\n  button {\n    margin-left: 0.5em;\n  }\n',
        ],
      )),
  ),
  yr = u.div(
    sr ||
      (sr = x(
        [
          '\n  background-color: rgba(0, 0, 0, 0.75);\n\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1399;\n\n  width: 100vw;\n  height: 100vh;\n\n  visibility: hidden;\n\n  &.visible {\n    visibility: visible;\n  }\n',
        ],
        [
          '\n  background-color: rgba(0, 0, 0, 0.75);\n\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1399;\n\n  width: 100vw;\n  height: 100vh;\n\n  visibility: hidden;\n\n  &.visible {\n    visibility: visible;\n  }\n',
        ],
      )),
  ),
  br = u.div(
    cr ||
      (cr = x(
        [
          '\n  background-color: ',
          ';\n  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.4);\n\n  padding: 1em;\n',
        ],
        [
          '\n  background-color: ',
          ';\n  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.4);\n\n  padding: 1em;\n',
        ],
      )),
    function (n) {
      return n.theme.modalBg;
    },
  ),
  vr = u.div(
    $r ||
      ($r = x(
        [
          '\n  min-width: 300px;\n  max-width: 300px;\n\n  opacity: 0;\n\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  visibility: hidden;\n\n  z-index: 1400;\n\n  &.modal-enter {\n    opacity: 0;\n  }\n\n  &.modal-enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    visibility: visible;\n  }\n  &.modal-enter-done {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.modal-exit {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.modal-exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    visibility: visible;\n  }\n\n  ',
          '\n\n  ',
          '\n\n  ',
          '\n',
        ],
        [
          '\n  min-width: 300px;\n  max-width: 300px;\n\n  opacity: 0;\n\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  visibility: hidden;\n\n  z-index: 1400;\n\n  &.modal-enter {\n    opacity: 0;\n  }\n\n  &.modal-enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    visibility: visible;\n  }\n  &.modal-enter-done {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.modal-exit {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.modal-exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    visibility: visible;\n  }\n\n  ',
          '\n\n  ',
          '\n\n  ',
          '\n',
        ],
      )),
    Rn('mobile')(
      fr ||
        (fr = x(
          ['\n    min-width: 90vw;\n    max-width: 90vw;\n  '],
          ['\n    min-width: 90vw;\n    max-width: 90vw;\n  '],
        )),
    ),
    Rn('tablet')(
      mr ||
        (mr = x(
          ['\n    min-width: 80vw;\n    max-width: 80vw;\n  '],
          ['\n    min-width: 80vw;\n    max-width: 80vw;\n  '],
        )),
    ),
    Rn('desktop')(
      pr ||
        (pr = x(
          ['\n    min-width: 900px;\n    max-width: 900px;\n  '],
          ['\n    min-width: 900px;\n    max-width: 900px;\n  '],
        )),
    ),
  );
function xr(e) {
  var t = e.className,
    r = e.cancel,
    o = e.confirm,
    a = e.children,
    i = e.footer,
    d = e.visible,
    l = y(e, [
      'className',
      'cancel',
      'confirm',
      'children',
      'footer',
      'visible',
    ]),
    u = n.useRef(null),
    s = i;
  return (
    s ||
      (s = n.createElement(
        gr,
        null,
        n.createElement(En, { ghost: !0, onClick: r }, 'Cancel'),
        n.createElement(En, { onClick: o }, 'Confirm'),
      )),
    n.createElement(
      n.Fragment,
      null,
      n.createElement(yr, {
        className: d ? 'visible' : '',
        onClick: r,
        'data-testid': 'modal-screen',
      }),
      n.createElement(
        Ye,
        { in: d, timeout: 200, classNames: 'modal', nodeRef: u },
        n.createElement(
          vr,
          { className: 'modal__wrapper', ref: u },
          n.createElement(
            hr,
            { onClick: r, 'data-testid': 'modal-close' },
            n.createElement(Xe, null),
          ),
          n.createElement(br, g({ className: t || '' }, l), a, s),
        ),
      ),
    )
  );
}
(hr.defaultProps = { theme: J }),
  (br.defaultProps = { theme: J }),
  (xr.defaultProps = {
    cancel: void 0,
    confirm: void 0,
    footer: void 0,
    visible: !1,
  });
var Cr = {
    version: 4,
    country_calling_codes: {
      1: [
        'US',
        'AG',
        'AI',
        'AS',
        'BB',
        'BM',
        'BS',
        'CA',
        'DM',
        'DO',
        'GD',
        'GU',
        'JM',
        'KN',
        'KY',
        'LC',
        'MP',
        'MS',
        'PR',
        'SX',
        'TC',
        'TT',
        'VC',
        'VG',
        'VI',
      ],
      7: ['RU', 'KZ'],
      20: ['EG'],
      27: ['ZA'],
      30: ['GR'],
      31: ['NL'],
      32: ['BE'],
      33: ['FR'],
      34: ['ES'],
      36: ['HU'],
      39: ['IT', 'VA'],
      40: ['RO'],
      41: ['CH'],
      43: ['AT'],
      44: ['GB', 'GG', 'IM', 'JE'],
      45: ['DK'],
      46: ['SE'],
      47: ['NO', 'SJ'],
      48: ['PL'],
      49: ['DE'],
      51: ['PE'],
      52: ['MX'],
      53: ['CU'],
      54: ['AR'],
      55: ['BR'],
      56: ['CL'],
      57: ['CO'],
      58: ['VE'],
      60: ['MY'],
      61: ['AU', 'CC', 'CX'],
      62: ['ID'],
      63: ['PH'],
      64: ['NZ'],
      65: ['SG'],
      66: ['TH'],
      81: ['JP'],
      82: ['KR'],
      84: ['VN'],
      86: ['CN'],
      90: ['TR'],
      91: ['IN'],
      92: ['PK'],
      93: ['AF'],
      94: ['LK'],
      95: ['MM'],
      98: ['IR'],
      211: ['SS'],
      212: ['MA', 'EH'],
      213: ['DZ'],
      216: ['TN'],
      218: ['LY'],
      220: ['GM'],
      221: ['SN'],
      222: ['MR'],
      223: ['ML'],
      224: ['GN'],
      225: ['CI'],
      226: ['BF'],
      227: ['NE'],
      228: ['TG'],
      229: ['BJ'],
      230: ['MU'],
      231: ['LR'],
      232: ['SL'],
      233: ['GH'],
      234: ['NG'],
      235: ['TD'],
      236: ['CF'],
      237: ['CM'],
      238: ['CV'],
      239: ['ST'],
      240: ['GQ'],
      241: ['GA'],
      242: ['CG'],
      243: ['CD'],
      244: ['AO'],
      245: ['GW'],
      246: ['IO'],
      247: ['AC'],
      248: ['SC'],
      249: ['SD'],
      250: ['RW'],
      251: ['ET'],
      252: ['SO'],
      253: ['DJ'],
      254: ['KE'],
      255: ['TZ'],
      256: ['UG'],
      257: ['BI'],
      258: ['MZ'],
      260: ['ZM'],
      261: ['MG'],
      262: ['RE', 'YT'],
      263: ['ZW'],
      264: ['NA'],
      265: ['MW'],
      266: ['LS'],
      267: ['BW'],
      268: ['SZ'],
      269: ['KM'],
      290: ['SH', 'TA'],
      291: ['ER'],
      297: ['AW'],
      298: ['FO'],
      299: ['GL'],
      350: ['GI'],
      351: ['PT'],
      352: ['LU'],
      353: ['IE'],
      354: ['IS'],
      355: ['AL'],
      356: ['MT'],
      357: ['CY'],
      358: ['FI', 'AX'],
      359: ['BG'],
      370: ['LT'],
      371: ['LV'],
      372: ['EE'],
      373: ['MD'],
      374: ['AM'],
      375: ['BY'],
      376: ['AD'],
      377: ['MC'],
      378: ['SM'],
      380: ['UA'],
      381: ['RS'],
      382: ['ME'],
      383: ['XK'],
      385: ['HR'],
      386: ['SI'],
      387: ['BA'],
      389: ['MK'],
      420: ['CZ'],
      421: ['SK'],
      423: ['LI'],
      500: ['FK'],
      501: ['BZ'],
      502: ['GT'],
      503: ['SV'],
      504: ['HN'],
      505: ['NI'],
      506: ['CR'],
      507: ['PA'],
      508: ['PM'],
      509: ['HT'],
      590: ['GP', 'BL', 'MF'],
      591: ['BO'],
      592: ['GY'],
      593: ['EC'],
      594: ['GF'],
      595: ['PY'],
      596: ['MQ'],
      597: ['SR'],
      598: ['UY'],
      599: ['CW', 'BQ'],
      670: ['TL'],
      672: ['NF'],
      673: ['BN'],
      674: ['NR'],
      675: ['PG'],
      676: ['TO'],
      677: ['SB'],
      678: ['VU'],
      679: ['FJ'],
      680: ['PW'],
      681: ['WF'],
      682: ['CK'],
      683: ['NU'],
      685: ['WS'],
      686: ['KI'],
      687: ['NC'],
      688: ['TV'],
      689: ['PF'],
      690: ['TK'],
      691: ['FM'],
      692: ['MH'],
      850: ['KP'],
      852: ['HK'],
      853: ['MO'],
      855: ['KH'],
      856: ['LA'],
      880: ['BD'],
      886: ['TW'],
      960: ['MV'],
      961: ['LB'],
      962: ['JO'],
      963: ['SY'],
      964: ['IQ'],
      965: ['KW'],
      966: ['SA'],
      967: ['YE'],
      968: ['OM'],
      970: ['PS'],
      971: ['AE'],
      972: ['IL'],
      973: ['BH'],
      974: ['QA'],
      975: ['BT'],
      976: ['MN'],
      977: ['NP'],
      992: ['TJ'],
      993: ['TM'],
      994: ['AZ'],
      995: ['GE'],
      996: ['KG'],
      998: ['UZ'],
    },
    countries: {
      AC: ['247', '00', '(?:[01589]\\d|[46])\\d{4}', [5, 6]],
      AD: [
        '376',
        '00',
        '(?:1|6\\d)\\d{7}|[135-9]\\d{5}',
        [6, 8, 9],
        [
          ['(\\d{3})(\\d{3})', '$1 $2', ['[135-9]']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['1']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['6']],
        ],
      ],
      AE: [
        '971',
        '00',
        '(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}',
        [5, 6, 7, 8, 9, 10, 11, 12],
        [
          ['(\\d{3})(\\d{2,9})', '$1 $2', ['60|8']],
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[236]|[479][2-8]'], '0$1'],
          ['(\\d{3})(\\d)(\\d{5})', '$1 $2 $3', ['[479]']],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['5'], '0$1'],
        ],
        '0',
      ],
      AF: [
        '93',
        '00',
        '[2-7]\\d{8}',
        [9],
        [['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[2-7]'], '0$1']],
        '0',
      ],
      AG: [
        '1',
        '011',
        '(?:268|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([457]\\d{6})$',
        '268$1',
        0,
        '268',
      ],
      AI: [
        '1',
        '011',
        '(?:264|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2457]\\d{6})$',
        '264$1',
        0,
        '264',
      ],
      AL: [
        '355',
        '00',
        '(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}',
        [6, 7, 8, 9],
        [
          ['(\\d{3})(\\d{3,4})', '$1 $2', ['80|9'], '0$1'],
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['4[2-6]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2358][2-5]|4'], '0$1'],
          ['(\\d{3})(\\d{5})', '$1 $2', ['[23578]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['6'], '0$1'],
        ],
        '0',
      ],
      AM: [
        '374',
        '00',
        '(?:[1-489]\\d|55|60|77)\\d{6}',
        [8],
        [
          ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[89]0'], '0 $1'],
          ['(\\d{3})(\\d{5})', '$1 $2', ['2|3[12]'], '(0$1)'],
          ['(\\d{2})(\\d{6})', '$1 $2', ['1|47'], '(0$1)'],
          ['(\\d{2})(\\d{6})', '$1 $2', ['[3-9]'], '0$1'],
        ],
        '0',
      ],
      AO: [
        '244',
        '00',
        '[29]\\d{8}',
        [9],
        [['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[29]']]],
      ],
      AR: [
        '54',
        '00',
        '(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}',
        [10, 11],
        [
          [
            '(\\d{4})(\\d{2})(\\d{4})',
            '$1 $2-$3',
            [
              '2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])',
              '2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)',
              '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
              '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]',
            ],
            '0$1',
            1,
          ],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2-$3', ['1'], '0$1', 1],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2-$3', ['[68]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2-$3', ['[23]'], '0$1', 1],
          [
            '(\\d)(\\d{4})(\\d{2})(\\d{4})',
            '$2 15-$3-$4',
            [
              '9(?:2[2-469]|3[3-578])',
              '9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))',
              '9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)',
              '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
              '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]',
            ],
            '0$1',
            0,
            '$1 $2 $3-$4',
          ],
          [
            '(\\d)(\\d{2})(\\d{4})(\\d{4})',
            '$2 15-$3-$4',
            ['91'],
            '0$1',
            0,
            '$1 $2 $3-$4',
          ],
          ['(\\d{3})(\\d{3})(\\d{5})', '$1-$2-$3', ['8'], '0$1'],
          [
            '(\\d)(\\d{3})(\\d{3})(\\d{4})',
            '$2 15-$3-$4',
            ['9'],
            '0$1',
            0,
            '$1 $2 $3-$4',
          ],
        ],
        '0',
        0,
        '0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?',
        '9$1',
      ],
      AS: [
        '1',
        '011',
        '(?:[58]\\d\\d|684|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([267]\\d{6})$',
        '684$1',
        0,
        '684',
      ],
      AT: [
        '43',
        '00',
        '1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}',
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        [
          ['(\\d)(\\d{3,12})', '$1 $2', ['1(?:11|[2-9])'], '0$1'],
          ['(\\d{3})(\\d{2})', '$1 $2', ['517'], '0$1'],
          ['(\\d{2})(\\d{3,5})', '$1 $2', ['5[079]'], '0$1'],
          [
            '(\\d{3})(\\d{3,10})',
            '$1 $2',
            ['(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]'],
            '0$1',
          ],
          ['(\\d{4})(\\d{3,9})', '$1 $2', ['[2-467]|5[2-6]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['5'], '0$1'],
          ['(\\d{2})(\\d{4})(\\d{4,7})', '$1 $2 $3', ['5'], '0$1'],
        ],
        '0',
      ],
      AU: [
        '61',
        '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
        '1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}',
        [5, 6, 7, 8, 9, 10],
        [
          ['(\\d{2})(\\d{3,4})', '$1 $2', ['16'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{2,4})', '$1 $2 $3', ['16'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['14|4'], '0$1'],
          ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['[2378]'], '(0$1)'],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1(?:30|[89])']],
        ],
        '0',
        0,
        '0|(183[12])',
        0,
        0,
        0,
        [
          [
            '(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}',
            [9],
          ],
          [
            '4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
            [9],
          ],
          ['180(?:0\\d{3}|2)\\d{3}', [7, 10]],
          ['190[0-26]\\d{6}', [10]],
          0,
          0,
          0,
          ['163\\d{2,6}', [5, 6, 7, 8, 9]],
          ['14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}', [9]],
          ['13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}', [6, 8, 10]],
        ],
        '0011',
      ],
      AW: [
        '297',
        '00',
        '(?:[25-79]\\d\\d|800)\\d{4}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[25-9]']]],
      ],
      AX: [
        '358',
        '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
        '2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}',
        [5, 6, 7, 8, 9, 10, 11, 12],
        0,
        '0',
        0,
        0,
        0,
        0,
        '18',
        0,
        '00',
      ],
      AZ: [
        '994',
        '00',
        '365\\d{6}|(?:[124579]\\d|60|88)\\d{7}',
        [9],
        [
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['90'], '0$1'],
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            [
              '1[28]|2|365|46',
              '1[28]|2|365|46',
              '1[28]|2|365(?:[0-46-9]|5[0-35-9])|46',
            ],
            '(0$1)',
          ],
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[13-9]'],
            '0$1',
          ],
        ],
        '0',
      ],
      BA: [
        '387',
        '00',
        '6\\d{8}|(?:[35689]\\d|49|70)\\d{6}',
        [8, 9],
        [
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['6[1-3]|[7-9]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2-$3', ['[3-5]|6[56]'], '0$1'],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['6'], '0$1'],
        ],
        '0',
      ],
      BB: [
        '1',
        '011',
        '(?:246|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-9]\\d{6})$',
        '246$1',
        0,
        '246',
      ],
      BD: [
        '880',
        '00',
        '1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}',
        [6, 7, 8, 9, 10],
        [
          ['(\\d{2})(\\d{4,6})', '$1-$2', ['31[5-8]|[459]1'], '0$1'],
          [
            '(\\d{3})(\\d{3,7})',
            '$1-$2',
            [
              '3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]',
            ],
            '0$1',
          ],
          ['(\\d{4})(\\d{3,6})', '$1-$2', ['[13-9]'], '0$1'],
          ['(\\d)(\\d{7,8})', '$1-$2', ['2'], '0$1'],
        ],
        '0',
      ],
      BE: [
        '32',
        '00',
        '4\\d{8}|[1-9]\\d{7}',
        [8, 9],
        [
          ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['(?:80|9)0'], '0$1'],
          [
            '(\\d)(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[239]|4[23]'],
            '0$1',
          ],
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[15-8]'],
            '0$1',
          ],
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['4'], '0$1'],
        ],
        '0',
      ],
      BF: [
        '226',
        '00',
        '[025-7]\\d{7}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[025-7]']]],
      ],
      BG: [
        '359',
        '00',
        '[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}',
        [6, 7, 8, 9],
        [
          ['(\\d)(\\d)(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['2'], '0$1'],
          ['(\\d{3})(\\d{4})', '$1 $2', ['43[1-6]|70[1-9]'], '0$1'],
          ['(\\d)(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2'], '0$1'],
          [
            '(\\d{2})(\\d{3})(\\d{2,3})',
            '$1 $2 $3',
            ['[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]'],
            '0$1',
          ],
          ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['(?:70|8)0'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{2})', '$1 $2 $3', ['43[1-7]|7'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[48]|9[08]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['9'], '0$1'],
        ],
        '0',
      ],
      BH: [
        '973',
        '00',
        '[136-9]\\d{7}',
        [8],
        [['(\\d{4})(\\d{4})', '$1 $2', ['[13679]|8[047]']]],
      ],
      BI: [
        '257',
        '00',
        '(?:[267]\\d|31)\\d{6}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2367]']]],
      ],
      BJ: [
        '229',
        '00',
        '[25689]\\d{7}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[25689]']]],
      ],
      BL: [
        '590',
        '00',
        '(?:590|69\\d|976)\\d{6}',
        [9],
        0,
        '0',
        0,
        0,
        0,
        0,
        0,
        [
          ['590(?:2[7-9]|5[12]|87)\\d{4}'],
          ['69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'],
          0,
          0,
          0,
          0,
          0,
          0,
          ['976[01]\\d{5}'],
        ],
      ],
      BM: [
        '1',
        '011',
        '(?:441|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-8]\\d{6})$',
        '441$1',
        0,
        '441',
      ],
      BN: [
        '673',
        '00',
        '[2-578]\\d{6}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[2-578]']]],
      ],
      BO: [
        '591',
        '00(?:1\\d)?',
        '(?:[2-467]\\d\\d|8001)\\d{5}',
        [8, 9],
        [
          ['(\\d)(\\d{7})', '$1 $2', ['[23]|4[46]']],
          ['(\\d{8})', '$1', ['[67]']],
          ['(\\d{3})(\\d{2})(\\d{4})', '$1 $2 $3', ['8']],
        ],
        '0',
        0,
        '0(1\\d)?',
      ],
      BQ: ['599', '00', '(?:[34]1|7\\d)\\d{5}', [7], 0, 0, 0, 0, 0, 0, '[347]'],
      BR: [
        '55',
        '00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)',
        '(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}',
        [8, 9, 10, 11],
        [
          [
            '(\\d{4})(\\d{4})',
            '$1-$2',
            ['300|4(?:0[02]|37)', '4(?:02|37)0|[34]00'],
          ],
          ['(\\d{3})(\\d{2,3})(\\d{4})', '$1 $2 $3', ['(?:[358]|90)0'], '0$1'],
          [
            '(\\d{2})(\\d{4})(\\d{4})',
            '$1 $2-$3',
            ['(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]'],
            '($1)',
          ],
          [
            '(\\d{2})(\\d{5})(\\d{4})',
            '$1 $2-$3',
            ['[16][1-9]|[2-57-9]'],
            '($1)',
          ],
        ],
        '0',
        0,
        '(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?',
        '$2',
      ],
      BS: [
        '1',
        '011',
        '(?:242|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([3-8]\\d{6})$',
        '242$1',
        0,
        '242',
      ],
      BT: [
        '975',
        '00',
        '[17]\\d{7}|[2-8]\\d{6}',
        [7, 8],
        [
          ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-68]|7[246]']],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['1[67]|7']],
        ],
      ],
      BW: [
        '267',
        '00',
        '(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}',
        [7, 8, 10],
        [
          ['(\\d{2})(\\d{5})', '$1 $2', ['90']],
          ['(\\d{3})(\\d{4})', '$1 $2', ['[24-6]|3[15-79]']],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[37]']],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['0']],
          ['(\\d{3})(\\d{4})(\\d{3})', '$1 $2 $3', ['8']],
        ],
      ],
      BY: [
        '375',
        '810',
        '(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}',
        [6, 7, 8, 9, 10, 11],
        [
          ['(\\d{3})(\\d{3})', '$1 $2', ['800'], '8 $1'],
          ['(\\d{3})(\\d{2})(\\d{2,4})', '$1 $2 $3', ['800'], '8 $1'],
          [
            '(\\d{4})(\\d{2})(\\d{3})',
            '$1 $2-$3',
            [
              '1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])',
              '1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])',
            ],
            '8 0$1',
          ],
          [
            '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2-$3-$4',
            ['1(?:[56]|7[467])|2[1-3]'],
            '8 0$1',
          ],
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2-$3-$4',
            ['[1-4]'],
            '8 0$1',
          ],
          ['(\\d{3})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['[89]'], '8 $1'],
        ],
        '8',
        0,
        '0|80?',
        0,
        0,
        0,
        0,
        '8~10',
      ],
      BZ: [
        '501',
        '00',
        '(?:0800\\d|[2-8])\\d{6}',
        [7, 11],
        [
          ['(\\d{3})(\\d{4})', '$1-$2', ['[2-8]']],
          ['(\\d)(\\d{3})(\\d{4})(\\d{3})', '$1-$2-$3-$4', ['0']],
        ],
      ],
      CA: [
        '1',
        '011',
        '(?:[2-8]\\d|90)\\d{8}',
        [10],
        0,
        '1',
        0,
        0,
        0,
        0,
        0,
        [
          [
            '(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}',
          ],
          [''],
          ['8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'],
          ['900[2-9]\\d{6}'],
          [
            '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}',
          ],
          0,
          0,
          0,
          ['600[2-9]\\d{6}'],
        ],
      ],
      CC: [
        '61',
        '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
        '1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}',
        [6, 7, 8, 9, 10],
        0,
        '0',
        0,
        '0|([59]\\d{7})$',
        '8$1',
        0,
        0,
        [
          [
            '8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}',
            [9],
          ],
          [
            '4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
            [9],
          ],
          ['180(?:0\\d{3}|2)\\d{3}', [7, 10]],
          ['190[0-26]\\d{6}', [10]],
          0,
          0,
          0,
          0,
          ['14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}', [9]],
          ['13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}', [6, 8, 10]],
        ],
        '0011',
      ],
      CD: [
        '243',
        '00',
        '[189]\\d{8}|[1-68]\\d{6}',
        [7, 9],
        [
          ['(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3', ['88'], '0$1'],
          ['(\\d{2})(\\d{5})', '$1 $2', ['[1-6]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[89]'], '0$1'],
        ],
        '0',
      ],
      CF: [
        '236',
        '00',
        '(?:[27]\\d{3}|8776)\\d{4}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[278]']]],
      ],
      CG: [
        '242',
        '00',
        '222\\d{6}|(?:0\\d|80)\\d{7}',
        [9],
        [
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['801']],
          ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['8']],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[02]']],
        ],
      ],
      CH: [
        '41',
        '00',
        '8\\d{11}|[2-9]\\d{8}',
        [9],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8[047]|90'], '0$1'],
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[2-79]|81'],
            '0$1',
          ],
          [
            '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4 $5',
            ['8'],
            '0$1',
          ],
        ],
        '0',
      ],
      CI: [
        '225',
        '00',
        '[02]\\d{9}|[02-9]\\d{7}',
        [8, 10],
        [
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            [
              '[03-9]|2(?:[02-4]|1[023578])',
              '[03-9]|2(?:[02-4]|1(?:[02357]|80))',
            ],
          ],
          ['(\\d{2})(\\d{2})(\\d)(\\d{5})', '$1 $2 $3 $4', ['2']],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3 $4', ['0']],
        ],
      ],
      CK: [
        '682',
        '00',
        '[2-578]\\d{4}',
        [5],
        [['(\\d{2})(\\d{3})', '$1 $2', ['[2-578]']]],
      ],
      CL: [
        '56',
        '(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0',
        '12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}',
        [9, 10, 11],
        [
          ['(\\d{5})(\\d{4})', '$1 $2', ['219', '2196'], '($1)'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['44']],
          ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['2[1-3]'], '($1)'],
          ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['9[2-9]']],
          [
            '(\\d{2})(\\d{3})(\\d{4})',
            '$1 $2 $3',
            ['3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])'],
            '($1)',
          ],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['60|8']],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
          ['(\\d{3})(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['60']],
        ],
      ],
      CM: [
        '237',
        '00',
        '[26]\\d{8}|88\\d{6,7}',
        [8, 9],
        [
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['88']],
          [
            '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4 $5',
            ['[26]|88'],
          ],
        ],
      ],
      CN: [
        '86',
        '00|1(?:[12]\\d|79)\\d\\d00',
        '1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}',
        [7, 8, 9, 10, 11, 12],
        [
          [
            '(\\d{2})(\\d{5,6})',
            '$1 $2',
            [
              '(?:10|2[0-57-9])[19]',
              '(?:10|2[0-57-9])(?:10|9[56])',
              '(?:10|2[0-57-9])(?:100|9[56])',
            ],
            '0$1',
          ],
          [
            '(\\d{3})(\\d{5,6})',
            '$1 $2',
            [
              '3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]',
              '(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]',
              '85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])',
              '85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])',
            ],
            '0$1',
          ],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['(?:4|80)0']],
          [
            '(\\d{2})(\\d{4})(\\d{4})',
            '$1 $2 $3',
            [
              '10|2(?:[02-57-9]|1[1-9])',
              '10|2(?:[02-57-9]|1[1-9])',
              '10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])',
            ],
            '0$1',
            1,
          ],
          [
            '(\\d{3})(\\d{3})(\\d{4})',
            '$1 $2 $3',
            [
              '3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]',
            ],
            '0$1',
            1,
          ],
          ['(\\d{3})(\\d{7,8})', '$1 $2', ['9']],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['80'], '0$1', 1],
          ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['[3-578]'], '0$1', 1],
          ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['1[3-9]']],
          [
            '(\\d{2})(\\d{3})(\\d{3})(\\d{4})',
            '$1 $2 $3 $4',
            ['[12]'],
            '0$1',
            1,
          ],
        ],
        '0',
        0,
        '0|(1(?:[12]\\d|79)\\d\\d)',
        0,
        0,
        0,
        0,
        '00',
      ],
      CO: [
        '57',
        '00(?:4(?:[14]4|56)|[579])',
        '(?:1\\d|3)\\d{9}|[124-8]\\d{7}',
        [8, 10, 11],
        [
          ['(\\d)(\\d{7})', '$1 $2', ['[14][2-9]|[25-8]'], '($1)'],
          ['(\\d{3})(\\d{7})', '$1 $2', ['3']],
          ['(\\d)(\\d{3})(\\d{7})', '$1-$2-$3', ['1'], '0$1', 0, '$1 $2 $3'],
        ],
        '0',
        0,
        '0([3579]|4(?:[14]4|56))?',
      ],
      CR: [
        '506',
        '00',
        '(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}',
        [8, 10],
        [
          ['(\\d{4})(\\d{4})', '$1 $2', ['[2-7]|8[3-9]']],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2-$3', ['[89]']],
        ],
        0,
        0,
        '(19(?:0[0-2468]|1[09]|20|66|77|99))',
      ],
      CU: [
        '53',
        '119',
        '[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}',
        [6, 7, 8, 10],
        [
          ['(\\d{2})(\\d{4,6})', '$1 $2', ['2[1-4]|[34]'], '(0$1)'],
          ['(\\d)(\\d{6,7})', '$1 $2', ['7'], '(0$1)'],
          ['(\\d)(\\d{7})', '$1 $2', ['5'], '0$1'],
          ['(\\d{3})(\\d{7})', '$1 $2', ['8'], '0$1'],
        ],
        '0',
      ],
      CV: [
        '238',
        '0',
        '(?:[2-59]\\d\\d|800)\\d{4}',
        [7],
        [['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['[2-589]']]],
      ],
      CW: [
        '599',
        '00',
        '(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}',
        [7, 8],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['[3467]']],
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['9[4-8]']],
        ],
        0,
        0,
        0,
        0,
        0,
        '[69]',
      ],
      CX: [
        '61',
        '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
        '1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}',
        [6, 7, 8, 9, 10],
        0,
        '0',
        0,
        '0|([59]\\d{7})$',
        '8$1',
        0,
        0,
        [
          [
            '8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}',
            [9],
          ],
          [
            '4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
            [9],
          ],
          ['180(?:0\\d{3}|2)\\d{3}', [7, 10]],
          ['190[0-26]\\d{6}', [10]],
          0,
          0,
          0,
          0,
          ['14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}', [9]],
          ['13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}', [6, 8, 10]],
        ],
        '0011',
      ],
      CY: [
        '357',
        '00',
        '(?:[279]\\d|[58]0)\\d{6}',
        [8],
        [['(\\d{2})(\\d{6})', '$1 $2', ['[257-9]']]],
      ],
      CZ: [
        '420',
        '00',
        '(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}',
        [9],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-8]|9[015-7]']],
          ['(\\d{2})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9']],
          ['(\\d{3})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9']],
        ],
      ],
      DE: [
        '49',
        '00',
        '[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}',
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [
          ['(\\d{2})(\\d{3,13})', '$1 $2', ['3[02]|40|[68]9'], '0$1'],
          [
            '(\\d{3})(\\d{3,12})',
            '$1 $2',
            [
              '2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1',
              '2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1',
            ],
            '0$1',
          ],
          [
            '(\\d{4})(\\d{2,11})',
            '$1 $2',
            [
              '[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]',
              '[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]',
            ],
            '0$1',
          ],
          ['(\\d{3})(\\d{4})', '$1 $2', ['138'], '0$1'],
          ['(\\d{5})(\\d{2,10})', '$1 $2', ['3'], '0$1'],
          ['(\\d{3})(\\d{5,11})', '$1 $2', ['181'], '0$1'],
          ['(\\d{3})(\\d)(\\d{4,10})', '$1 $2 $3', ['1(?:3|80)|9'], '0$1'],
          ['(\\d{3})(\\d{7,8})', '$1 $2', ['1[67]'], '0$1'],
          ['(\\d{3})(\\d{7,12})', '$1 $2', ['8'], '0$1'],
          ['(\\d{5})(\\d{6})', '$1 $2', ['185', '1850', '18500'], '0$1'],
          ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
          ['(\\d{4})(\\d{7})', '$1 $2', ['18[68]'], '0$1'],
          ['(\\d{5})(\\d{6})', '$1 $2', ['15[0568]'], '0$1'],
          ['(\\d{4})(\\d{7})', '$1 $2', ['15[1279]'], '0$1'],
          ['(\\d{3})(\\d{8})', '$1 $2', ['18'], '0$1'],
          ['(\\d{3})(\\d{2})(\\d{7,8})', '$1 $2 $3', ['1(?:6[023]|7)'], '0$1'],
          ['(\\d{4})(\\d{2})(\\d{7})', '$1 $2 $3', ['15[279]'], '0$1'],
          ['(\\d{3})(\\d{2})(\\d{8})', '$1 $2 $3', ['15'], '0$1'],
        ],
        '0',
      ],
      DJ: [
        '253',
        '00',
        '(?:2\\d|77)\\d{6}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[27]']]],
      ],
      DK: [
        '45',
        '00',
        '[2-9]\\d{7}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-9]']]],
      ],
      DM: [
        '1',
        '011',
        '(?:[58]\\d\\d|767|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-7]\\d{6})$',
        '767$1',
        0,
        '767',
      ],
      DO: [
        '1',
        '011',
        '(?:[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        0,
        0,
        0,
        '8001|8[024]9',
      ],
      DZ: [
        '213',
        '00',
        '(?:[1-4]|[5-79]\\d|80)\\d{7}',
        [8, 9],
        [
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[1-4]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['9'], '0$1'],
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[5-8]'], '0$1'],
        ],
        '0',
      ],
      EC: [
        '593',
        '00',
        '1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}',
        [8, 9, 10, 11],
        [
          [
            '(\\d)(\\d{3})(\\d{4})',
            '$1 $2-$3',
            ['[2-7]'],
            '(0$1)',
            0,
            '$1-$2-$3',
          ],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['9'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['1']],
        ],
        '0',
      ],
      EE: [
        '372',
        '00',
        '8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}',
        [7, 8, 10],
        [
          [
            '(\\d{3})(\\d{4})',
            '$1 $2',
            [
              '[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88',
              '[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88',
            ],
          ],
          [
            '(\\d{4})(\\d{3,4})',
            '$1 $2',
            ['[45]|8(?:00|[1-49])', '[45]|8(?:00[1-9]|[1-49])'],
          ],
          ['(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3', ['7']],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['8']],
        ],
      ],
      EG: [
        '20',
        '00',
        '[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}',
        [8, 9, 10],
        [
          ['(\\d)(\\d{7,8})', '$1 $2', ['[23]'], '0$1'],
          [
            '(\\d{2})(\\d{6,7})',
            '$1 $2',
            ['1[35]|[4-6]|8[2468]|9[235-7]'],
            '0$1',
          ],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[189]'], '0$1'],
        ],
        '0',
      ],
      EH: ['212', '00', '[5-8]\\d{8}', [9], 0, '0', 0, 0, 0, 0, '528[89]'],
      ER: [
        '291',
        '00',
        '[178]\\d{6}',
        [7],
        [['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[178]'], '0$1']],
        '0',
      ],
      ES: [
        '34',
        '00',
        '[5-9]\\d{8}',
        [9],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[89]00']],
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[5-9]']],
        ],
      ],
      ET: [
        '251',
        '00',
        '(?:11|[2-59]\\d)\\d{7}',
        [9],
        [['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1-59]'], '0$1']],
        '0',
      ],
      FI: [
        '358',
        '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
        '[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}',
        [5, 6, 7, 8, 9, 10, 11, 12],
        [
          [
            '(\\d)(\\d{4,9})',
            '$1 $2',
            ['[2568][1-8]|3(?:0[1-9]|[1-9])|9'],
            '0$1',
          ],
          ['(\\d{3})(\\d{3,7})', '$1 $2', ['[12]00|[368]|70[07-9]'], '0$1'],
          ['(\\d{2})(\\d{4,8})', '$1 $2', ['[1245]|7[135]'], '0$1'],
          ['(\\d{2})(\\d{6,10})', '$1 $2', ['7'], '0$1'],
        ],
        '0',
        0,
        0,
        0,
        0,
        '1[03-79]|[2-9]',
        0,
        '00',
      ],
      FJ: [
        '679',
        '0(?:0|52)',
        '45\\d{5}|(?:0800\\d|[235-9])\\d{6}',
        [7, 11],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['[235-9]|45']],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['0']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      FK: ['500', '00', '[2-7]\\d{4}', [5]],
      FM: [
        '691',
        '00',
        '(?:[39]\\d\\d|820)\\d{4}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[389]']]],
      ],
      FO: [
        '298',
        '00',
        '[2-9]\\d{5}',
        [6],
        [['(\\d{6})', '$1', ['[2-9]']]],
        0,
        0,
        '(10(?:01|[12]0|88))',
      ],
      FR: [
        '33',
        '00',
        '[1-9]\\d{8}',
        [9],
        [
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['8'], '0 $1'],
          [
            '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4 $5',
            ['[1-79]'],
            '0$1',
          ],
        ],
        '0',
      ],
      GA: [
        '241',
        '00',
        '(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}',
        [7, 8],
        [
          ['(\\d)(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-7]'], '0$1'],
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['11|[67]'],
            '0$1',
          ],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['0']],
        ],
        0,
        0,
        '0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})',
        '$1',
      ],
      GB: [
        '44',
        '00',
        '[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}',
        [7, 9, 10],
        [
          [
            '(\\d{3})(\\d{4})',
            '$1 $2',
            ['800', '8001', '80011', '800111', '8001111'],
            '0$1',
          ],
          [
            '(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3',
            ['845', '8454', '84546', '845464'],
            '0$1',
          ],
          ['(\\d{3})(\\d{6})', '$1 $2', ['800'], '0$1'],
          [
            '(\\d{5})(\\d{4,5})',
            '$1 $2',
            [
              '1(?:38|5[23]|69|76|94)',
              '1(?:(?:38|69)7|5(?:24|39)|768|946)',
              '1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)',
            ],
            '0$1',
          ],
          ['(\\d{4})(\\d{5,6})', '$1 $2', ['1(?:[2-69][02-9]|[78])'], '0$1'],
          [
            '(\\d{2})(\\d{4})(\\d{4})',
            '$1 $2 $3',
            ['[25]|7(?:0|6[02-9])', '[25]|7(?:0|6(?:[03-9]|2[356]))'],
            '0$1',
          ],
          ['(\\d{4})(\\d{6})', '$1 $2', ['7'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1389]'], '0$1'],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        [
          [
            '(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|4(?:[0-5]\\d\\d|69[7-9])|(?:5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}',
            [9, 10],
          ],
          [
            '7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}',
            [10],
          ],
          ['80[08]\\d{7}|800\\d{6}|8001111'],
          [
            '(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d',
            [7, 10],
          ],
          ['70\\d{8}', [10]],
          0,
          ['(?:3[0347]|55)\\d{8}', [10]],
          [
            '76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}',
            [10],
          ],
          ['56\\d{8}', [10]],
        ],
        0,
        ' x',
      ],
      GD: [
        '1',
        '011',
        '(?:473|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-9]\\d{6})$',
        '473$1',
        0,
        '473',
      ],
      GE: [
        '995',
        '00',
        '(?:[3-57]\\d\\d|800)\\d{6}',
        [9],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['70'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['32'], '0$1'],
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[57]']],
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[348]'], '0$1'],
        ],
        '0',
      ],
      GF: [
        '594',
        '00',
        '(?:[56]94|976)\\d{6}',
        [9],
        [['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[569]'], '0$1']],
        '0',
      ],
      GG: [
        '44',
        '00',
        '(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?',
        [7, 9, 10],
        0,
        '0',
        0,
        '0|([25-9]\\d{5})$',
        '1481$1',
        0,
        0,
        [
          ['1481[25-9]\\d{5}', [10]],
          ['7(?:(?:781|839)\\d|911[17])\\d{5}', [10]],
          ['80[08]\\d{7}|800\\d{6}|8001111'],
          [
            '(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d',
            [7, 10],
          ],
          ['70\\d{8}', [10]],
          0,
          ['(?:3[0347]|55)\\d{8}', [10]],
          [
            '76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}',
            [10],
          ],
          ['56\\d{8}', [10]],
        ],
      ],
      GH: [
        '233',
        '00',
        '(?:[235]\\d{3}|800)\\d{5}',
        [8, 9],
        [
          ['(\\d{3})(\\d{5})', '$1 $2', ['8'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[235]'], '0$1'],
        ],
        '0',
      ],
      GI: [
        '350',
        '00',
        '(?:[25]\\d\\d|606)\\d{5}',
        [8],
        [['(\\d{3})(\\d{5})', '$1 $2', ['2']]],
      ],
      GL: [
        '299',
        '00',
        '(?:19|[2-689]\\d)\\d{4}',
        [6],
        [['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['19|[2-689]']]],
      ],
      GM: [
        '220',
        '00',
        '[2-9]\\d{6}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[2-9]']]],
      ],
      GN: [
        '224',
        '00',
        '722\\d{6}|(?:3|6\\d)\\d{7}',
        [8, 9],
        [
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['3']],
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[67]']],
        ],
      ],
      GP: [
        '590',
        '00',
        '(?:590|69\\d|976)\\d{6}',
        [9],
        [['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[569]'], '0$1']],
        '0',
        0,
        0,
        0,
        0,
        0,
        [
          [
            '590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}',
          ],
          ['69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'],
          0,
          0,
          0,
          0,
          0,
          0,
          ['976[01]\\d{5}'],
        ],
      ],
      GQ: [
        '240',
        '00',
        '222\\d{6}|(?:3\\d|55|[89]0)\\d{7}',
        [9],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[235]']],
          ['(\\d{3})(\\d{6})', '$1 $2', ['[89]']],
        ],
      ],
      GR: [
        '30',
        '00',
        '5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}',
        [10, 11],
        [
          ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['21|7']],
          [
            '(\\d{4})(\\d{6})',
            '$1 $2',
            ['2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5'],
          ],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[2689]']],
          ['(\\d{3})(\\d{3})(\\d{5})', '$1 $2 $3', ['8']],
        ],
      ],
      GT: [
        '502',
        '00',
        '(?:1\\d{3}|[2-7])\\d{7}',
        [8, 11],
        [
          ['(\\d{4})(\\d{4})', '$1 $2', ['[2-7]']],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
        ],
      ],
      GU: [
        '1',
        '011',
        '(?:[58]\\d\\d|671|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([3-9]\\d{6})$',
        '671$1',
        0,
        '671',
      ],
      GW: [
        '245',
        '00',
        '[49]\\d{8}|4\\d{6}',
        [7, 9],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['40']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[49]']],
        ],
      ],
      GY: [
        '592',
        '001',
        '(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[2-46-9]']]],
      ],
      HK: [
        '852',
        '00(?:30|5[09]|[126-9]?)',
        '8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}',
        [5, 6, 7, 8, 9, 11],
        [
          ['(\\d{3})(\\d{2,5})', '$1 $2', ['900', '9003']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['[2-7]|8[1-4]|9(?:0[1-9]|[1-8])']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8']],
          ['(\\d{3})(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      HN: [
        '504',
        '00',
        '8\\d{10}|[237-9]\\d{7}',
        [8, 11],
        [['(\\d{4})(\\d{4})', '$1-$2', ['[237-9]']]],
      ],
      HR: [
        '385',
        '00',
        '(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}',
        [6, 7, 8, 9],
        [
          ['(\\d{2})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['6[01]'], '0$1'],
          ['(\\d{3})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['8'], '0$1'],
          ['(\\d)(\\d{4})(\\d{3})', '$1 $2 $3', ['1'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[67]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['9'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-5]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8'], '0$1'],
        ],
        '0',
      ],
      HT: [
        '509',
        '00',
        '[2-489]\\d{7}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3', ['[2-489]']]],
      ],
      HU: [
        '36',
        '00',
        '[235-7]\\d{8}|[1-9]\\d{7}',
        [8, 9],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '(06 $1)'],
          [
            '(\\d{2})(\\d{3})(\\d{3})',
            '$1 $2 $3',
            ['[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]'],
            '(06 $1)',
          ],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-9]'], '06 $1'],
        ],
        '06',
      ],
      ID: [
        '62',
        '00[89]',
        '(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}',
        [7, 8, 9, 10, 11, 12, 13],
        [
          ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['15']],
          ['(\\d{2})(\\d{5,9})', '$1 $2', ['2[124]|[36]1'], '(0$1)'],
          ['(\\d{3})(\\d{5,7})', '$1 $2', ['800'], '0$1'],
          ['(\\d{3})(\\d{5,8})', '$1 $2', ['[2-79]'], '(0$1)'],
          ['(\\d{3})(\\d{3,4})(\\d{3})', '$1-$2-$3', ['8[1-35-9]'], '0$1'],
          ['(\\d{3})(\\d{6,8})', '$1 $2', ['1'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['804'], '0$1'],
          ['(\\d{3})(\\d)(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['80'], '0$1'],
          ['(\\d{3})(\\d{4})(\\d{4,5})', '$1-$2-$3', ['8'], '0$1'],
        ],
        '0',
      ],
      IE: [
        '353',
        '00',
        '(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}',
        [7, 8, 9, 10],
        [
          [
            '(\\d{2})(\\d{5})',
            '$1 $2',
            ['2[24-9]|47|58|6[237-9]|9[35-9]'],
            '(0$1)',
          ],
          ['(\\d{3})(\\d{5})', '$1 $2', ['[45]0'], '(0$1)'],
          ['(\\d)(\\d{3,4})(\\d{4})', '$1 $2 $3', ['1'], '(0$1)'],
          [
            '(\\d{2})(\\d{3})(\\d{3,4})',
            '$1 $2 $3',
            ['[2569]|4[1-69]|7[14]'],
            '(0$1)',
          ],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['70'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['81'], '(0$1)'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[78]'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['4'], '(0$1)'],
          ['(\\d{2})(\\d)(\\d{3})(\\d{4})', '$1 $2 $3 $4', ['8'], '0$1'],
        ],
        '0',
      ],
      IL: [
        '972',
        '0(?:0|1[2-9])',
        '1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}',
        [7, 8, 9, 10, 11, 12],
        [
          ['(\\d{4})(\\d{3})', '$1-$2', ['125']],
          ['(\\d{4})(\\d{2})(\\d{2})', '$1-$2-$3', ['121']],
          ['(\\d)(\\d{3})(\\d{4})', '$1-$2-$3', ['[2-489]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['[57]'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1-$2-$3', ['12']],
          ['(\\d{4})(\\d{6})', '$1-$2', ['159']],
          ['(\\d)(\\d{3})(\\d{3})(\\d{3})', '$1-$2-$3-$4', ['1[7-9]']],
          ['(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})', '$1-$2 $3-$4', ['15']],
        ],
        '0',
      ],
      IM: [
        '44',
        '00',
        '1624\\d{6}|(?:[3578]\\d|90)\\d{8}',
        [10],
        0,
        '0',
        0,
        '0|([25-8]\\d{5})$',
        '1624$1',
        0,
        '74576|(?:16|7[56])24',
      ],
      IN: [
        '91',
        '00',
        '(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}',
        [8, 9, 10, 11, 12, 13],
        [
          [
            '(\\d{8})',
            '$1',
            [
              '5(?:0|2[23]|3[03]|[67]1|88)',
              '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)',
              '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)',
            ],
            0,
            1,
          ],
          ['(\\d{4})(\\d{4,5})', '$1 $2', ['180', '1800'], 0, 1],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['140'], 0, 1],
          [
            '(\\d{2})(\\d{4})(\\d{4})',
            '$1 $2 $3',
            [
              '11|2[02]|33|4[04]|79[1-7]|80[2-46]',
              '11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])',
              '11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])',
            ],
            '0$1',
            1,
          ],
          [
            '(\\d{3})(\\d{3})(\\d{4})',
            '$1 $2 $3',
            [
              '1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]',
              '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]',
              '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]',
            ],
            '0$1',
            1,
          ],
          [
            '(\\d{4})(\\d{3})(\\d{3})',
            '$1 $2 $3',
            [
              '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807',
              '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]',
              '1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]',
            ],
            '0$1',
            1,
          ],
          ['(\\d{5})(\\d{5})', '$1 $2', ['[6-9]'], '0$1', 1],
          [
            '(\\d{4})(\\d{2,4})(\\d{4})',
            '$1 $2 $3',
            ['1(?:6|8[06])', '1(?:6|8[06]0)'],
            0,
            1,
          ],
          ['(\\d{4})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['18'], 0, 1],
        ],
        '0',
      ],
      IO: ['246', '00', '3\\d{6}', [7], [['(\\d{3})(\\d{4})', '$1 $2', ['3']]]],
      IQ: [
        '964',
        '00',
        '(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}',
        [8, 9, 10],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-6]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
        ],
        '0',
      ],
      IR: [
        '98',
        '00',
        '[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}',
        [4, 5, 6, 7, 10],
        [
          ['(\\d{4,5})', '$1', ['96'], '0$1'],
          [
            '(\\d{2})(\\d{4,5})',
            '$1 $2',
            [
              '(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]',
            ],
            '0$1',
          ],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['9'], '0$1'],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['[1-8]'], '0$1'],
        ],
        '0',
      ],
      IS: [
        '354',
        '00|1(?:0(?:01|[12]0)|100)',
        '(?:38\\d|[4-9])\\d{6}',
        [7, 9],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['[4-9]']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['3']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      IT: [
        '39',
        '00',
        '0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}',
        [6, 7, 8, 9, 10, 11],
        [
          ['(\\d{2})(\\d{4,6})', '$1 $2', ['0[26]']],
          [
            '(\\d{3})(\\d{3,6})',
            '$1 $2',
            [
              '0[13-57-9][0159]|8(?:03|4[17]|9[245])',
              '0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))',
            ],
          ],
          ['(\\d{4})(\\d{2,6})', '$1 $2', ['0(?:[13-579][2-46-8]|8[236-8])']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['894']],
          ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['0[26]|5']],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['1[4679]|[38]']],
          ['(\\d{3})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['0[13-57-9][0159]']],
          ['(\\d{2})(\\d{4})(\\d{5})', '$1 $2 $3', ['0[26]']],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['0']],
          ['(\\d{3})(\\d{4})(\\d{4,5})', '$1 $2 $3', ['3']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        [
          [
            '0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}',
          ],
          ['3[1-9]\\d{8}|3[2-9]\\d{7}', [9, 10]],
          ['80(?:0\\d{3}|3)\\d{3}', [6, 9]],
          [
            '(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}',
            [6, 8, 9, 10],
          ],
          ['1(?:78\\d|99)\\d{6}', [9, 10]],
          0,
          0,
          0,
          ['55\\d{8}', [10]],
          ['84(?:[08]\\d{3}|[17])\\d{3}', [6, 9]],
        ],
      ],
      JE: [
        '44',
        '00',
        '1534\\d{6}|(?:[3578]\\d|90)\\d{8}',
        [10],
        0,
        '0',
        0,
        '0|([0-24-8]\\d{5})$',
        '1534$1',
        0,
        0,
        [
          ['1534[0-24-8]\\d{5}'],
          ['7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}'],
          ['80(?:07(?:35|81)|8901)\\d{4}'],
          [
            '(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}',
          ],
          ['701511\\d{4}'],
          0,
          [
            '(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}',
          ],
          [
            '76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}',
          ],
          ['56\\d{8}'],
        ],
      ],
      JM: [
        '1',
        '011',
        '(?:[58]\\d\\d|658|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        0,
        0,
        0,
        '658|876',
      ],
      JO: [
        '962',
        '00',
        '(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}',
        [8, 9],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[2356]|87'], '(0$1)'],
          ['(\\d{3})(\\d{5,6})', '$1 $2', ['[89]'], '0$1'],
          ['(\\d{2})(\\d{7})', '$1 $2', ['70'], '0$1'],
          ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
        ],
        '0',
      ],
      JP: [
        '81',
        '010',
        '00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}',
        [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1-$2-$3', ['(?:12|57|99)0'], '0$1'],
          [
            '(\\d{4})(\\d)(\\d{4})',
            '$1-$2-$3',
            [
              '1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])',
              '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]',
              '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]',
            ],
            '0$1',
          ],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['60'], '0$1'],
          [
            '(\\d)(\\d{4})(\\d{4})',
            '$1-$2-$3',
            [
              '[36]|4(?:2[09]|7[01])',
              '[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))',
            ],
            '0$1',
          ],
          [
            '(\\d{2})(\\d{3})(\\d{4})',
            '$1-$2-$3',
            [
              '1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])',
              '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]',
              '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]',
              '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]',
            ],
            '0$1',
          ],
          [
            '(\\d{3})(\\d{2})(\\d{4})',
            '$1-$2-$3',
            ['[14]|[289][2-9]|5[3-9]|7[2-4679]'],
            '0$1',
          ],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2-$3', ['800'], '0$1'],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2-$3', ['[257-9]'], '0$1'],
        ],
        '0',
      ],
      KE: [
        '254',
        '000',
        '(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}',
        [7, 8, 9, 10],
        [
          ['(\\d{2})(\\d{5,7})', '$1 $2', ['[24-6]'], '0$1'],
          ['(\\d{3})(\\d{6})', '$1 $2', ['[17]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[89]'], '0$1'],
        ],
        '0',
      ],
      KG: [
        '996',
        '00',
        '8\\d{9}|(?:[235-8]\\d|99)\\d{7}',
        [9, 10],
        [
          ['(\\d{4})(\\d{5})', '$1 $2', ['3(?:1[346]|[24-79])'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[235-79]|88'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d)(\\d{2,3})', '$1 $2 $3 $4', ['8'], '0$1'],
        ],
        '0',
      ],
      KH: [
        '855',
        '00[14-9]',
        '1\\d{9}|[1-9]\\d{7,8}',
        [8, 9, 10],
        [
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[1-9]'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
        ],
        '0',
      ],
      KI: [
        '686',
        '00',
        '(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}',
        [5, 8],
        0,
        '0',
      ],
      KM: [
        '269',
        '00',
        '[3478]\\d{6}',
        [7],
        [['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['[3478]']]],
      ],
      KN: [
        '1',
        '011',
        '(?:[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-7]\\d{6})$',
        '869$1',
        0,
        '869',
      ],
      KP: [
        '850',
        '00|99',
        '85\\d{6}|(?:19\\d|[2-7])\\d{7}',
        [8, 10],
        [
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['8'], '0$1'],
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[2-7]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
        ],
        '0',
      ],
      KR: [
        '82',
        '00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))',
        '00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}',
        [5, 6, 8, 9, 10, 11, 12, 13, 14],
        [
          [
            '(\\d{2})(\\d{3,4})',
            '$1-$2',
            ['(?:3[1-3]|[46][1-4]|5[1-5])1'],
            '0$1',
          ],
          ['(\\d{4})(\\d{4})', '$1-$2', ['1']],
          ['(\\d)(\\d{3,4})(\\d{4})', '$1-$2-$3', ['2'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['60|8'], '0$1'],
          ['(\\d{2})(\\d{3,4})(\\d{4})', '$1-$2-$3', ['[1346]|5[1-5]'], '0$1'],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2-$3', ['[57]'], '0$1'],
          ['(\\d{2})(\\d{5})(\\d{4})', '$1-$2-$3', ['5'], '0$1'],
        ],
        '0',
        0,
        '0(8(?:[1-46-8]|5\\d\\d))?',
      ],
      KW: [
        '965',
        '00',
        '(?:18|[2569]\\d\\d)\\d{5}',
        [7, 8],
        [
          ['(\\d{4})(\\d{3,4})', '$1 $2', ['[169]|2(?:[235]|4[1-35-9])|52']],
          ['(\\d{3})(\\d{5})', '$1 $2', ['[25]']],
        ],
      ],
      KY: [
        '1',
        '011',
        '(?:345|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-9]\\d{6})$',
        '345$1',
        0,
        '345',
      ],
      KZ: [
        '7',
        '810',
        '33622\\d{5}|(?:7\\d|80)\\d{8}',
        [10],
        0,
        '8',
        0,
        0,
        0,
        0,
        '33|7',
        0,
        '8~10',
      ],
      LA: [
        '856',
        '00',
        '[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}',
        [8, 9, 10],
        [
          [
            '(\\d{2})(\\d{3})(\\d{3})',
            '$1 $2 $3',
            ['2[13]|3[14]|[4-8]'],
            '0$1',
          ],
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
            '$1 $2 $3 $4',
            ['30[013-9]'],
            '0$1',
          ],
          ['(\\d{2})(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['[23]'], '0$1'],
        ],
        '0',
      ],
      LB: [
        '961',
        '00',
        '[27-9]\\d{7}|[13-9]\\d{6}',
        [7, 8],
        [
          [
            '(\\d)(\\d{3})(\\d{3})',
            '$1 $2 $3',
            ['[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]'],
            '0$1',
          ],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[27-9]']],
        ],
        '0',
      ],
      LC: [
        '1',
        '011',
        '(?:[58]\\d\\d|758|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-8]\\d{6})$',
        '758$1',
        0,
        '758',
      ],
      LI: [
        '423',
        '00',
        '90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}',
        [7, 9],
        [
          ['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['[237-9]']],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['69']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['6']],
        ],
        '0',
        0,
        '0|(1001)',
      ],
      LK: [
        '94',
        '00',
        '[1-9]\\d{8}',
        [9],
        [
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[1-689]'], '0$1'],
        ],
        '0',
      ],
      LR: [
        '231',
        '00',
        '(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}',
        [7, 8, 9],
        [
          ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[4-6]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['2'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[3578]'], '0$1'],
        ],
        '0',
      ],
      LS: [
        '266',
        '00',
        '(?:[256]\\d\\d|800)\\d{5}',
        [8],
        [['(\\d{4})(\\d{4})', '$1 $2', ['[2568]']]],
      ],
      LT: [
        '370',
        '00',
        '(?:[3469]\\d|52|[78]0)\\d{6}',
        [8],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['52[0-7]'], '(8-$1)', 1],
          ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[7-9]'], '8 $1', 1],
          ['(\\d{2})(\\d{6})', '$1 $2', ['37|4(?:[15]|6[1-8])'], '(8-$1)', 1],
          ['(\\d{3})(\\d{5})', '$1 $2', ['[3-6]'], '(8-$1)', 1],
        ],
        '8',
        0,
        '[08]',
      ],
      LU: [
        '352',
        '00',
        '35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}',
        [4, 5, 6, 7, 8, 9, 10, 11],
        [
          [
            '(\\d{2})(\\d{3})',
            '$1 $2',
            [
              '2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])',
            ],
          ],
          [
            '(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3',
            [
              '2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])',
            ],
          ],
          ['(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3', ['20[2-689]']],
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})',
            '$1 $2 $3 $4',
            ['2(?:[0367]|4[3-8])'],
          ],
          ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['80[01]|90[015]']],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['20']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['6']],
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})',
            '$1 $2 $3 $4 $5',
            ['2(?:[0367]|4[3-8])'],
          ],
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})',
            '$1 $2 $3 $4',
            ['[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]'],
          ],
        ],
        0,
        0,
        '(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)',
      ],
      LV: [
        '371',
        '00',
        '(?:[268]\\d|90)\\d{6}',
        [8],
        [['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[269]|8[01]']]],
      ],
      LY: [
        '218',
        '00',
        '[2-9]\\d{8}',
        [9],
        [['(\\d{2})(\\d{7})', '$1-$2', ['[2-9]'], '0$1']],
        '0',
      ],
      MA: [
        '212',
        '00',
        '[5-8]\\d{8}',
        [9],
        [
          [
            '(\\d{5})(\\d{4})',
            '$1-$2',
            ['5(?:29|38)', '5(?:29|38)[89]', '5(?:29|38)[89]0'],
            '0$1',
          ],
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['5[45]'], '0$1'],
          [
            '(\\d{4})(\\d{5})',
            '$1-$2',
            [
              '5(?:2[2-489]|3[5-9]|9)|892',
              '5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892',
            ],
            '0$1',
          ],
          ['(\\d{2})(\\d{7})', '$1-$2', ['8'], '0$1'],
          ['(\\d{3})(\\d{6})', '$1-$2', ['[5-7]'], '0$1'],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        [
          [
            '5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}',
          ],
          ['(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|6[1267]|7[0-57]))\\d{6}'],
          ['80\\d{7}'],
          ['89\\d{7}'],
          0,
          0,
          0,
          0,
          ['592(?:4[0-2]|93)\\d{4}'],
        ],
      ],
      MC: [
        '377',
        '00',
        '(?:[3489]|6\\d)\\d{7}',
        [8, 9],
        [
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['4'], '0$1'],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[389]']],
          [
            '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4 $5',
            ['6'],
            '0$1',
          ],
        ],
        '0',
      ],
      MD: [
        '373',
        '00',
        '(?:[235-7]\\d|[89]0)\\d{6}',
        [8],
        [
          ['(\\d{3})(\\d{5})', '$1 $2', ['[89]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['22|3'], '0$1'],
          ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[25-7]'], '0$1'],
        ],
        '0',
      ],
      ME: [
        '382',
        '00',
        '(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}',
        [8, 9],
        [['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-9]'], '0$1']],
        '0',
      ],
      MF: [
        '590',
        '00',
        '(?:590|69\\d|976)\\d{6}',
        [9],
        0,
        '0',
        0,
        0,
        0,
        0,
        0,
        [
          ['590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}'],
          ['69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'],
          0,
          0,
          0,
          0,
          0,
          0,
          ['976[01]\\d{5}'],
        ],
      ],
      MG: [
        '261',
        '00',
        '[23]\\d{8}',
        [9],
        [['(\\d{2})(\\d{2})(\\d{3})(\\d{2})', '$1 $2 $3 $4', ['[23]'], '0$1']],
        '0',
        0,
        '0|([24-9]\\d{6})$',
        '20$1',
      ],
      MH: [
        '692',
        '011',
        '329\\d{4}|(?:[256]\\d|45)\\d{5}',
        [7],
        [['(\\d{3})(\\d{4})', '$1-$2', ['[2-6]']]],
        '1',
      ],
      MK: [
        '389',
        '00',
        '[2-578]\\d{7}',
        [8],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[347]'], '0$1'],
          ['(\\d{3})(\\d)(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[58]'], '0$1'],
        ],
        '0',
      ],
      ML: [
        '223',
        '00',
        '[24-9]\\d{7}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[24-9]']]],
      ],
      MM: [
        '95',
        '00',
        '1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}',
        [6, 7, 8, 9, 10],
        [
          ['(\\d)(\\d{2})(\\d{3})', '$1 $2 $3', ['16|2'], '0$1'],
          [
            '(\\d{2})(\\d{2})(\\d{3})',
            '$1 $2 $3',
            ['[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]'],
            '0$1',
          ],
          ['(\\d)(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[12]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[4-7]|8[1-35]'], '0$1'],
          [
            '(\\d)(\\d{3})(\\d{4,6})',
            '$1 $2 $3',
            ['9(?:2[0-4]|[35-9]|4[137-9])'],
            '0$1',
          ],
          ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8'], '0$1'],
          ['(\\d)(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['92'], '0$1'],
          ['(\\d)(\\d{5})(\\d{4})', '$1 $2 $3', ['9'], '0$1'],
        ],
        '0',
      ],
      MN: [
        '976',
        '001',
        '[12]\\d{7,9}|[57-9]\\d{7}',
        [8, 9, 10],
        [
          ['(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3', ['[12]1'], '0$1'],
          ['(\\d{4})(\\d{4})', '$1 $2', ['[57-9]']],
          ['(\\d{3})(\\d{5,6})', '$1 $2', ['[12]2[1-3]'], '0$1'],
          [
            '(\\d{4})(\\d{5,6})',
            '$1 $2',
            [
              '[12](?:27|3[2-8]|4[2-68]|5[1-4689])',
              '[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]',
            ],
            '0$1',
          ],
          ['(\\d{5})(\\d{4,5})', '$1 $2', ['[12]'], '0$1'],
        ],
        '0',
      ],
      MO: [
        '853',
        '00',
        '(?:28|[68]\\d)\\d{6}',
        [8],
        [['(\\d{4})(\\d{4})', '$1 $2', ['[268]']]],
      ],
      MP: [
        '1',
        '011',
        '[58]\\d{9}|(?:67|90)0\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-9]\\d{6})$',
        '670$1',
        0,
        '670',
      ],
      MQ: [
        '596',
        '00',
        '69\\d{7}|(?:59|97)6\\d{6}',
        [9],
        [['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[569]'], '0$1']],
        '0',
      ],
      MR: [
        '222',
        '00',
        '(?:[2-4]\\d\\d|800)\\d{5}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-48]']]],
      ],
      MS: [
        '1',
        '011',
        '(?:[58]\\d\\d|664|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([34]\\d{6})$',
        '664$1',
        0,
        '664',
      ],
      MT: [
        '356',
        '00',
        '3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}',
        [8],
        [['(\\d{4})(\\d{4})', '$1 $2', ['[2357-9]']]],
      ],
      MU: [
        '230',
        '0(?:0|[24-7]0|3[03])',
        '(?:[2-468]|5\\d)\\d{6}',
        [7, 8],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['[2-46]|8[013]']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['5']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '020',
      ],
      MV: [
        '960',
        '0(?:0|19)',
        '(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}',
        [7, 10],
        [
          ['(\\d{3})(\\d{4})', '$1-$2', ['[3467]|9[13-9]']],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[89]']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      MW: [
        '265',
        '00',
        '1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}',
        [7, 9],
        [
          ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['1[2-9]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['2'], '0$1'],
          [
            '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[137-9]'],
            '0$1',
          ],
        ],
        '0',
      ],
      MX: [
        '52',
        '0[09]',
        '(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}',
        [10, 11],
        [
          ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['33|5[56]|81'], 0, 1],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[2-9]'], 0, 1],
          [
            '(\\d)(\\d{2})(\\d{4})(\\d{4})',
            '$2 $3 $4',
            ['1(?:33|5[56]|81)'],
            0,
            1,
          ],
          ['(\\d)(\\d{3})(\\d{3})(\\d{4})', '$2 $3 $4', ['1'], 0, 1],
        ],
        '01',
        0,
        '0(?:[12]|4[45])|1',
        0,
        0,
        0,
        0,
        '00',
      ],
      MY: [
        '60',
        '00',
        '1\\d{8,9}|(?:3\\d|[4-9])\\d{7}',
        [8, 9, 10],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1-$2 $3', ['[4-79]'], '0$1'],
          [
            '(\\d{2})(\\d{3})(\\d{3,4})',
            '$1-$2 $3',
            ['1(?:[02469]|[378][1-9])|8'],
            '0$1',
          ],
          ['(\\d)(\\d{4})(\\d{4})', '$1-$2 $3', ['3'], '0$1'],
          ['(\\d)(\\d{3})(\\d{2})(\\d{4})', '$1-$2-$3-$4', ['1[36-8]']],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2 $3', ['15'], '0$1'],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2 $3', ['1'], '0$1'],
        ],
        '0',
      ],
      MZ: [
        '258',
        '00',
        '(?:2|8\\d)\\d{7}',
        [8, 9],
        [
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2|8[2-79]']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8']],
        ],
      ],
      NA: [
        '264',
        '00',
        '[68]\\d{7,8}',
        [8, 9],
        [
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['88'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['6'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['87'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['8'], '0$1'],
        ],
        '0',
      ],
      NC: [
        '687',
        '00',
        '[2-57-9]\\d{5}',
        [6],
        [['(\\d{2})(\\d{2})(\\d{2})', '$1.$2.$3', ['[2-57-9]']]],
      ],
      NE: [
        '227',
        '00',
        '[027-9]\\d{7}',
        [8],
        [
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['08']],
          [
            '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[089]|2[013]|7[04]'],
          ],
        ],
      ],
      NF: [
        '672',
        '00',
        '[13]\\d{5}',
        [6],
        [
          ['(\\d{2})(\\d{4})', '$1 $2', ['1[0-3]']],
          ['(\\d)(\\d{5})', '$1 $2', ['[13]']],
        ],
        0,
        0,
        '([0-258]\\d{4})$',
        '3$1',
      ],
      NG: [
        '234',
        '009',
        '(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}',
        [7, 8, 10, 11, 12, 13, 14],
        [
          ['(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3', ['78'], '0$1'],
          [
            '(\\d)(\\d{3})(\\d{3,4})',
            '$1 $2 $3',
            ['[12]|9(?:0[3-9]|[1-9])'],
            '0$1',
          ],
          ['(\\d{2})(\\d{3})(\\d{2,3})', '$1 $2 $3', ['[3-7]|8[2-9]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[7-9]'], '0$1'],
          ['(\\d{3})(\\d{4})(\\d{4,5})', '$1 $2 $3', ['[78]'], '0$1'],
          ['(\\d{3})(\\d{5})(\\d{5,6})', '$1 $2 $3', ['[78]'], '0$1'],
        ],
        '0',
      ],
      NI: [
        '505',
        '00',
        '(?:1800|[25-8]\\d{3})\\d{4}',
        [8],
        [['(\\d{4})(\\d{4})', '$1 $2', ['[125-8]']]],
      ],
      NL: [
        '31',
        '00',
        '(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}',
        [5, 6, 7, 8, 9, 10],
        [
          ['(\\d{3})(\\d{4,7})', '$1 $2', ['[89]0'], '0$1'],
          ['(\\d{2})(\\d{7})', '$1 $2', ['66'], '0$1'],
          ['(\\d)(\\d{8})', '$1 $2', ['6'], '0$1'],
          [
            '(\\d{3})(\\d{3})(\\d{3})',
            '$1 $2 $3',
            ['1[16-8]|2[259]|3[124]|4[17-9]|5[124679]'],
            '0$1',
          ],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1-57-9]'], '0$1'],
        ],
        '0',
      ],
      NO: [
        '47',
        '00',
        '(?:0|[2-9]\\d{3})\\d{4}',
        [5, 8],
        [
          ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[489]|59']],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[235-7]']],
        ],
        0,
        0,
        0,
        0,
        0,
        '[02-689]|7[0-8]',
      ],
      NP: [
        '977',
        '00',
        '(?:1\\d|9)\\d{9}|[1-9]\\d{7}',
        [8, 10, 11],
        [
          ['(\\d)(\\d{7})', '$1-$2', ['1[2-6]'], '0$1'],
          [
            '(\\d{2})(\\d{6})',
            '$1-$2',
            ['1[01]|[2-8]|9(?:[1-579]|6[2-6])'],
            '0$1',
          ],
          ['(\\d{3})(\\d{7})', '$1-$2', ['9']],
        ],
        '0',
      ],
      NR: [
        '674',
        '00',
        '(?:444|(?:55|8\\d)\\d|666)\\d{4}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[4-68]']]],
      ],
      NU: [
        '683',
        '00',
        '(?:[47]|888\\d)\\d{3}',
        [4, 7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['8']]],
      ],
      NZ: [
        '64',
        '0(?:0|161)',
        '[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}',
        [5, 6, 7, 8, 9, 10],
        [
          ['(\\d{2})(\\d{3,8})', '$1 $2', ['8[1-579]'], '0$1'],
          [
            '(\\d{3})(\\d{2})(\\d{2,3})',
            '$1 $2 $3',
            ['50[036-8]|[89]0', '50(?:[0367]|88)|[89]0'],
            '0$1',
          ],
          [
            '(\\d)(\\d{3})(\\d{4})',
            '$1-$2 $3',
            ['24|[346]|7[2-57-9]|9[2-9]'],
            '0$1',
          ],
          [
            '(\\d{3})(\\d{3})(\\d{3,4})',
            '$1 $2 $3',
            ['2(?:10|74)|[59]|80'],
            '0$1',
          ],
          ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['1|2[028]'], '0$1'],
          [
            '(\\d{2})(\\d{3})(\\d{3,5})',
            '$1 $2 $3',
            ['2(?:[169]|7[0-35-9])|7|86'],
            '0$1',
          ],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      OM: [
        '968',
        '00',
        '(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}',
        [7, 8, 9],
        [
          ['(\\d{3})(\\d{4,6})', '$1 $2', ['[58]']],
          ['(\\d{2})(\\d{6})', '$1 $2', ['2']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['[179]']],
        ],
      ],
      PA: [
        '507',
        '00',
        '8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}',
        [7, 8, 10],
        [
          ['(\\d{3})(\\d{4})', '$1-$2', ['[1-57-9]']],
          ['(\\d{4})(\\d{4})', '$1-$2', ['[68]']],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']],
        ],
      ],
      PE: [
        '51',
        '19(?:1[124]|77|90)00',
        '(?:[14-8]|9\\d)\\d{7}',
        [8, 9],
        [
          ['(\\d{3})(\\d{5})', '$1 $2', ['80'], '(0$1)'],
          ['(\\d)(\\d{7})', '$1 $2', ['1'], '(0$1)'],
          ['(\\d{2})(\\d{6})', '$1 $2', ['[4-8]'], '(0$1)'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['9']],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        ' Anexo ',
      ],
      PF: [
        '689',
        '00',
        '[48]\\d{7}|4\\d{5}',
        [6, 8],
        [
          ['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['44']],
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[48]']],
        ],
      ],
      PG: [
        '675',
        '00|140[1-3]',
        '(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}',
        [7, 8],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['18|[2-69]|85']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['[78]']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      PH: [
        '63',
        '00',
        '1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}',
        [6, 8, 9, 10, 11, 12, 13],
        [
          ['(\\d)(\\d{5})', '$1 $2', ['2'], '(0$1)'],
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '(0$1)'],
          [
            '(\\d{4})(\\d{4,6})',
            '$1 $2',
            [
              '3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2',
              '3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))',
            ],
            '(0$1)',
          ],
          [
            '(\\d{5})(\\d{4})',
            '$1 $2',
            ['346|4(?:27|9[35])|883', '3469|4(?:279|9(?:30|56))|8834'],
            '(0$1)',
          ],
          ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['2'], '(0$1)'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[3-7]|8[2-8]'], '(0$1)'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[89]'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
          ['(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})', '$1 $2 $3 $4', ['1']],
        ],
        '0',
      ],
      PK: [
        '92',
        '00',
        '122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}',
        [8, 9, 10, 11, 12],
        [
          ['(\\d{3})(\\d{3})(\\d{2,7})', '$1 $2 $3', ['[89]0'], '0$1'],
          ['(\\d{4})(\\d{5})', '$1 $2', ['1']],
          [
            '(\\d{3})(\\d{6,7})',
            '$1 $2',
            [
              '2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])',
              '9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]',
            ],
            '(0$1)',
          ],
          [
            '(\\d{2})(\\d{7,8})',
            '$1 $2',
            ['(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]'],
            '(0$1)',
          ],
          ['(\\d{5})(\\d{5})', '$1 $2', ['58'], '(0$1)'],
          ['(\\d{3})(\\d{7})', '$1 $2', ['3'], '0$1'],
          [
            '(\\d{2})(\\d{3})(\\d{3})(\\d{3})',
            '$1 $2 $3 $4',
            ['2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91'],
            '(0$1)',
          ],
          [
            '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
            '$1 $2 $3 $4',
            ['[24-9]'],
            '(0$1)',
          ],
        ],
        '0',
      ],
      PL: [
        '48',
        '00',
        '6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?',
        [6, 7, 8, 9, 10],
        [
          ['(\\d{5})', '$1', ['19']],
          ['(\\d{3})(\\d{3})', '$1 $2', ['11|64']],
          [
            '(\\d{2})(\\d{2})(\\d{3})',
            '$1 $2 $3',
            [
              '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1',
              '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19',
            ],
          ],
          ['(\\d{3})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['64']],
          [
            '(\\d{3})(\\d{3})(\\d{3})',
            '$1 $2 $3',
            ['39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)'],
          ],
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['1[2-8]|[2-7]|8[1-79]|9[145]'],
          ],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['8']],
        ],
      ],
      PM: [
        '508',
        '00',
        '[45]\\d{5}',
        [6],
        [['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['[45]'], '0$1']],
        '0',
      ],
      PR: [
        '1',
        '011',
        '(?:[589]\\d\\d|787)\\d{7}',
        [10],
        0,
        '1',
        0,
        0,
        0,
        0,
        '787|939',
      ],
      PS: [
        '970',
        '00',
        '[2489]2\\d{6}|(?:1\\d|5)\\d{8}',
        [8, 9, 10],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[2489]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['5'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
        ],
        '0',
      ],
      PT: [
        '351',
        '00',
        '(?:[26-9]\\d|30)\\d{7}',
        [9],
        [
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['2[12]']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[236-9]']],
        ],
      ],
      PW: [
        '680',
        '01[12]',
        '(?:[24-8]\\d\\d|345|900)\\d{4}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[2-9]']]],
      ],
      PY: [
        '595',
        '00',
        '59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}',
        [6, 7, 8, 9, 10, 11],
        [
          ['(\\d{3})(\\d{3,6})', '$1 $2', ['[2-9]0'], '0$1'],
          [
            '(\\d{2})(\\d{5})',
            '$1 $2',
            ['[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]'],
            '(0$1)',
          ],
          [
            '(\\d{3})(\\d{4,5})',
            '$1 $2',
            ['2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85'],
            '(0$1)',
          ],
          [
            '(\\d{2})(\\d{3})(\\d{3,4})',
            '$1 $2 $3',
            ['2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]'],
            '(0$1)',
          ],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['87']],
          ['(\\d{3})(\\d{6})', '$1 $2', ['9(?:[5-79]|8[1-6])'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-8]'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['9']],
        ],
        '0',
      ],
      QA: [
        '974',
        '00',
        '[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}',
        [7, 8],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['2[126]|8']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['[2-7]']],
        ],
      ],
      RE: [
        '262',
        '00',
        '9769\\d{5}|(?:26|[68]\\d)\\d{7}',
        [9],
        [
          [
            '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[2689]'],
            '0$1',
          ],
        ],
        '0',
        0,
        0,
        0,
        0,
        '26[23]|69|[89]',
      ],
      RO: [
        '40',
        '00',
        '(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}',
        [6, 9],
        [
          ['(\\d{3})(\\d{3})', '$1 $2', ['2[3-6]', '2[3-6]\\d9'], '0$1'],
          ['(\\d{2})(\\d{4})', '$1 $2', ['219|31'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[23]1'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[237-9]'], '0$1'],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        ' int ',
      ],
      RS: [
        '381',
        '00',
        '38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}',
        [6, 7, 8, 9, 10, 11, 12],
        [
          ['(\\d{3})(\\d{3,9})', '$1 $2', ['(?:2[389]|39)0|[7-9]'], '0$1'],
          ['(\\d{2})(\\d{5,10})', '$1 $2', ['[1-36]'], '0$1'],
        ],
        '0',
      ],
      RU: [
        '7',
        '810',
        '[347-9]\\d{9}',
        [10],
        [
          [
            '(\\d{4})(\\d{2})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            [
              '7(?:1[0-8]|2[1-9])',
              '7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))',
              '7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2',
            ],
            '8 ($1)',
            1,
          ],
          [
            '(\\d{5})(\\d)(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            [
              '7(?:1[0-68]|2[1-9])',
              '7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))',
              '7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]',
            ],
            '8 ($1)',
            1,
          ],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '8 ($1)', 1],
          [
            '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2-$3-$4',
            ['[3489]'],
            '8 ($1)',
            1,
          ],
        ],
        '8',
        0,
        0,
        0,
        0,
        '3[04-689]|[489]',
        0,
        '8~10',
      ],
      RW: [
        '250',
        '00',
        '(?:06|[27]\\d\\d|[89]00)\\d{6}',
        [8, 9],
        [
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['0']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[7-9]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['2']],
        ],
        '0',
      ],
      SA: [
        '966',
        '00',
        '92\\d{7}|(?:[15]|8\\d)\\d{8}',
        [9, 10],
        [
          ['(\\d{4})(\\d{5})', '$1 $2', ['9']],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['5'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['81'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']],
        ],
        '0',
      ],
      SB: [
        '677',
        '0[01]',
        '(?:[1-6]|[7-9]\\d\\d)\\d{4}',
        [5, 7],
        [['(\\d{2})(\\d{5})', '$1 $2', ['7|8[4-9]|9(?:[1-8]|9[0-8])']]],
      ],
      SC: [
        '248',
        '010|0[0-2]',
        '8000\\d{3}|(?:[249]\\d|64)\\d{5}',
        [7],
        [['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[246]|9[57]']]],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      SD: [
        '249',
        '00',
        '[19]\\d{8}',
        [9],
        [['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[19]'], '0$1']],
        '0',
      ],
      SE: [
        '46',
        '00',
        '(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}',
        [6, 7, 8, 9, 10],
        [
          [
            '(\\d{2})(\\d{2,3})(\\d{2})',
            '$1-$2 $3',
            ['20'],
            '0$1',
            0,
            '$1 $2 $3',
          ],
          ['(\\d{3})(\\d{4})', '$1-$2', ['9(?:00|39|44)'], '0$1', 0, '$1 $2'],
          [
            '(\\d{2})(\\d{3})(\\d{2})',
            '$1-$2 $3',
            ['[12][136]|3[356]|4[0246]|6[03]|90[1-9]'],
            '0$1',
            0,
            '$1 $2 $3',
          ],
          [
            '(\\d)(\\d{2,3})(\\d{2})(\\d{2})',
            '$1-$2 $3 $4',
            ['8'],
            '0$1',
            0,
            '$1 $2 $3 $4',
          ],
          [
            '(\\d{3})(\\d{2,3})(\\d{2})',
            '$1-$2 $3',
            [
              '1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])',
            ],
            '0$1',
            0,
            '$1 $2 $3',
          ],
          [
            '(\\d{3})(\\d{2,3})(\\d{3})',
            '$1-$2 $3',
            ['9(?:00|39|44)'],
            '0$1',
            0,
            '$1 $2 $3',
          ],
          [
            '(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})',
            '$1-$2 $3 $4',
            ['1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]'],
            '0$1',
            0,
            '$1 $2 $3 $4',
          ],
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1-$2 $3 $4',
            ['10|7'],
            '0$1',
            0,
            '$1 $2 $3 $4',
          ],
          [
            '(\\d)(\\d{3})(\\d{3})(\\d{2})',
            '$1-$2 $3 $4',
            ['8'],
            '0$1',
            0,
            '$1 $2 $3 $4',
          ],
          [
            '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
            '$1-$2 $3 $4',
            [
              '[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])',
            ],
            '0$1',
            0,
            '$1 $2 $3 $4',
          ],
          [
            '(\\d{3})(\\d{2})(\\d{2})(\\d{3})',
            '$1-$2 $3 $4',
            ['9'],
            '0$1',
            0,
            '$1 $2 $3 $4',
          ],
          [
            '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1-$2 $3 $4 $5',
            ['[26]'],
            '0$1',
            0,
            '$1 $2 $3 $4 $5',
          ],
        ],
        '0',
      ],
      SG: [
        '65',
        '0[0-3]\\d',
        '(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}',
        [8, 10, 11],
        [
          ['(\\d{4})(\\d{4})', '$1 $2', ['[369]|8(?:0[1-3]|[1-9])']],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']],
          ['(\\d{4})(\\d{4})(\\d{3})', '$1 $2 $3', ['7']],
          ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
        ],
      ],
      SH: [
        '290',
        '00',
        '(?:[256]\\d|8)\\d{3}',
        [4, 5],
        0,
        0,
        0,
        0,
        0,
        0,
        '[256]',
      ],
      SI: [
        '386',
        '00|10(?:22|66|88|99)',
        '[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}',
        [5, 6, 7, 8],
        [
          ['(\\d{2})(\\d{3,6})', '$1 $2', ['8[09]|9'], '0$1'],
          ['(\\d{3})(\\d{5})', '$1 $2', ['59|8'], '0$1'],
          [
            '(\\d{2})(\\d{3})(\\d{3})',
            '$1 $2 $3',
            ['[37][01]|4[0139]|51|6'],
            '0$1',
          ],
          ['(\\d)(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[1-57]'], '(0$1)'],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      SJ: [
        '47',
        '00',
        '0\\d{4}|(?:[489]\\d|[57]9)\\d{6}',
        [5, 8],
        0,
        0,
        0,
        0,
        0,
        0,
        '79',
      ],
      SK: [
        '421',
        '00',
        '[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}',
        [6, 7, 9],
        [
          ['(\\d)(\\d{2})(\\d{3,4})', '$1 $2 $3', ['21'], '0$1'],
          [
            '(\\d{2})(\\d{2})(\\d{2,3})',
            '$1 $2 $3',
            ['[3-5][1-8]1', '[3-5][1-8]1[67]'],
            '0$1',
          ],
          ['(\\d)(\\d{3})(\\d{3})(\\d{2})', '$1/$2 $3 $4', ['2'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[689]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1/$2 $3 $4', ['[3-5]'], '0$1'],
        ],
        '0',
      ],
      SL: [
        '232',
        '00',
        '(?:[2378]\\d|66|99)\\d{6}',
        [8],
        [['(\\d{2})(\\d{6})', '$1 $2', ['[236-9]'], '(0$1)']],
        '0',
      ],
      SM: [
        '378',
        '00',
        '(?:0549|[5-7]\\d)\\d{6}',
        [8, 10],
        [
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[5-7]']],
          ['(\\d{4})(\\d{6})', '$1 $2', ['0']],
        ],
        0,
        0,
        '([89]\\d{5})$',
        '0549$1',
      ],
      SN: [
        '221',
        '00',
        '(?:[378]\\d{4}|93330)\\d{4}',
        [9],
        [
          ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['8']],
          ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[379]']],
        ],
      ],
      SO: [
        '252',
        '00',
        '[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}',
        [6, 7, 8, 9],
        [
          ['(\\d{2})(\\d{4})', '$1 $2', ['8[125]']],
          ['(\\d{6})', '$1', ['[134]']],
          ['(\\d)(\\d{6})', '$1 $2', ['[15]|2[0-79]|3[0-46-8]|4[0-7]']],
          ['(\\d)(\\d{7})', '$1 $2', ['24|[67]']],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[3478]|64|90']],
          ['(\\d{2})(\\d{5,7})', '$1 $2', ['1|28|6[1-35-9]|9[2-9]']],
        ],
        '0',
      ],
      SR: [
        '597',
        '00',
        '(?:[2-5]|68|[78]\\d)\\d{5}',
        [6, 7],
        [
          ['(\\d{2})(\\d{2})(\\d{2})', '$1-$2-$3', ['56']],
          ['(\\d{3})(\\d{3})', '$1-$2', ['[2-5]']],
          ['(\\d{3})(\\d{4})', '$1-$2', ['[6-8]']],
        ],
      ],
      SS: [
        '211',
        '00',
        '[19]\\d{8}',
        [9],
        [['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[19]'], '0$1']],
        '0',
      ],
      ST: [
        '239',
        '00',
        '(?:22|9\\d)\\d{5}',
        [7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[29]']]],
      ],
      SV: [
        '503',
        '00',
        '[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?',
        [7, 8, 11],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['[89]']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['[267]']],
          ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['[89]']],
        ],
      ],
      SX: [
        '1',
        '011',
        '7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|(5\\d{6})$',
        '721$1',
        0,
        '721',
      ],
      SY: [
        '963',
        '00',
        '[1-39]\\d{8}|[1-5]\\d{7}',
        [8, 9],
        [
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[1-5]'], '0$1', 1],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['9'], '0$1', 1],
        ],
        '0',
      ],
      SZ: [
        '268',
        '00',
        '0800\\d{4}|(?:[237]\\d|900)\\d{6}',
        [8, 9],
        [
          ['(\\d{4})(\\d{4})', '$1 $2', ['[0237]']],
          ['(\\d{5})(\\d{4})', '$1 $2', ['9']],
        ],
      ],
      TA: ['290', '00', '8\\d{3}', [4], 0, 0, 0, 0, 0, 0, '8'],
      TC: [
        '1',
        '011',
        '(?:[58]\\d\\d|649|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-479]\\d{6})$',
        '649$1',
        0,
        '649',
      ],
      TD: [
        '235',
        '00|16',
        '(?:22|[69]\\d|77)\\d{6}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2679]']]],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
      ],
      TG: [
        '228',
        '00',
        '[279]\\d{7}',
        [8],
        [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[279]']]],
      ],
      TH: [
        '66',
        '00[1-9]',
        '1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}',
        [8, 9, 10],
        [
          ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[13-9]'], '0$1'],
          ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
        ],
        '0',
      ],
      TJ: [
        '992',
        '810',
        '(?:[02]0|11|[3-57-9]\\d)\\d{7}',
        [9],
        [
          ['(\\d{6})(\\d)(\\d{2})', '$1 $2 $3', ['331', '3317'], 0, 1],
          ['(\\d{3})(\\d{2})(\\d{4})', '$1 $2 $3', ['[34]7|91[78]'], 0, 1],
          ['(\\d{4})(\\d)(\\d{4})', '$1 $2 $3', ['3[1-5]'], 0, 1],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[02-57-9]|11'], 0, 1],
        ],
        '8',
        0,
        0,
        0,
        0,
        0,
        0,
        '8~10',
      ],
      TK: ['690', '00', '[2-47]\\d{3,6}', [4, 5, 6, 7]],
      TL: [
        '670',
        '00',
        '7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}',
        [7, 8],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['[2-489]|70']],
          ['(\\d{4})(\\d{4})', '$1 $2', ['7']],
        ],
      ],
      TM: [
        '993',
        '810',
        '[1-6]\\d{7}',
        [8],
        [
          ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2-$3-$4', ['12'], '(8 $1)'],
          ['(\\d{3})(\\d)(\\d{2})(\\d{2})', '$1 $2-$3-$4', ['[1-5]'], '(8 $1)'],
          ['(\\d{2})(\\d{6})', '$1 $2', ['6'], '8 $1'],
        ],
        '8',
        0,
        0,
        0,
        0,
        0,
        0,
        '8~10',
      ],
      TN: [
        '216',
        '00',
        '[2-57-9]\\d{7}',
        [8],
        [['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-57-9]']]],
      ],
      TO: [
        '676',
        '00',
        '(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}',
        [5, 7],
        [
          ['(\\d{2})(\\d{3})', '$1-$2', ['[2-4]|50|6[09]|7[0-24-69]|8[05]']],
          ['(\\d{4})(\\d{3})', '$1 $2', ['0']],
          ['(\\d{3})(\\d{4})', '$1 $2', ['[5-9]']],
        ],
      ],
      TR: [
        '90',
        '00',
        '4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}',
        [7, 10, 12, 13],
        [
          [
            '(\\d{3})(\\d{3})(\\d{4})',
            '$1 $2 $3',
            ['512|8[01589]|90'],
            '0$1',
            1,
          ],
          [
            '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['5(?:[0-59]|61)', '5(?:[0-59]|616)', '5(?:[0-59]|6161)'],
            '0$1',
            1,
          ],
          [
            '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[24][1-8]|3[1-9]'],
            '(0$1)',
            1,
          ],
          ['(\\d{3})(\\d{3})(\\d{6,7})', '$1 $2 $3', ['80'], '0$1', 1],
        ],
        '0',
      ],
      TT: [
        '1',
        '011',
        '(?:[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-46-8]\\d{6})$',
        '868$1',
        0,
        '868',
      ],
      TV: [
        '688',
        '00',
        '(?:2|7\\d\\d|90)\\d{4}',
        [5, 6, 7],
        [
          ['(\\d{2})(\\d{3})', '$1 $2', ['2']],
          ['(\\d{2})(\\d{4})', '$1 $2', ['90']],
          ['(\\d{2})(\\d{5})', '$1 $2', ['7']],
        ],
      ],
      TW: [
        '886',
        '0(?:0[25-79]|19)',
        '[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}',
        [7, 8, 9, 10, 11],
        [
          ['(\\d{2})(\\d)(\\d{4})', '$1 $2 $3', ['202'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[258]0'], '0$1'],
          [
            '(\\d)(\\d{3,4})(\\d{4})',
            '$1 $2 $3',
            [
              '[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]',
              '[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]',
            ],
            '0$1',
          ],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[49]'], '0$1'],
          ['(\\d{2})(\\d{4})(\\d{4,5})', '$1 $2 $3', ['7'], '0$1'],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        '#',
      ],
      TZ: [
        '255',
        '00[056]',
        '(?:[26-8]\\d|41|90)\\d{7}',
        [9],
        [
          ['(\\d{3})(\\d{2})(\\d{4})', '$1 $2 $3', ['[89]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[24]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[67]'], '0$1'],
        ],
        '0',
      ],
      UA: [
        '380',
        '00',
        '[89]\\d{9}|[3-9]\\d{8}',
        [9, 10],
        [
          [
            '(\\d{3})(\\d{3})(\\d{3})',
            '$1 $2 $3',
            [
              '6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]',
              '6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]',
            ],
            '0$1',
          ],
          [
            '(\\d{2})(\\d{3})(\\d{4})',
            '$1 $2 $3',
            [
              '4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]',
              '4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]',
            ],
            '0$1',
          ],
          ['(\\d{4})(\\d{5})', '$1 $2', ['[3-6]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[89]'], '0$1'],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        0,
        '0~0',
      ],
      UG: [
        '256',
        '00[057]',
        '800\\d{6}|(?:[29]0|[347]\\d)\\d{7}',
        [9],
        [
          ['(\\d{4})(\\d{5})', '$1 $2', ['202', '2024'], '0$1'],
          ['(\\d{3})(\\d{6})', '$1 $2', ['[27-9]|4(?:6[45]|[7-9])'], '0$1'],
          ['(\\d{2})(\\d{7})', '$1 $2', ['[34]'], '0$1'],
        ],
        '0',
      ],
      US: [
        '1',
        '011',
        '[2-9]\\d{9}',
        [10],
        [
          [
            '(\\d{3})(\\d{3})(\\d{4})',
            '($1) $2-$3',
            ['[2-9]'],
            0,
            1,
            '$1-$2-$3',
          ],
        ],
        '1',
        0,
        0,
        0,
        0,
        0,
        [
          [
            '(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[02357]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}',
          ],
          [''],
          ['8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'],
          ['900[2-9]\\d{6}'],
          [
            '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
          ],
        ],
      ],
      UY: [
        '598',
        '0(?:0|1[3-9]\\d)',
        '4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}',
        [7, 8, 10],
        [
          ['(\\d{3})(\\d{4})', '$1 $2', ['405|8|90'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['9'], '0$1'],
          ['(\\d{4})(\\d{4})', '$1 $2', ['[24]']],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['4'], '0$1'],
        ],
        '0',
        0,
        0,
        0,
        0,
        0,
        0,
        '00',
        ' int. ',
      ],
      UZ: [
        '998',
        '810',
        '55501\\d{4}|(?:33|[679]\\d|88)\\d{7}',
        [9],
        [
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[35-9]'],
            '8 $1',
          ],
        ],
        '8',
        0,
        0,
        0,
        0,
        0,
        0,
        '8~10',
      ],
      VA: [
        '39',
        '00',
        '0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}',
        [6, 7, 8, 9, 10, 11],
        0,
        0,
        0,
        0,
        0,
        0,
        '06698',
      ],
      VC: [
        '1',
        '011',
        '(?:[58]\\d\\d|784|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-7]\\d{6})$',
        '784$1',
        0,
        '784',
      ],
      VE: [
        '58',
        '00',
        '[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}',
        [10],
        [['(\\d{3})(\\d{7})', '$1-$2', ['[24-689]'], '0$1']],
        '0',
      ],
      VG: [
        '1',
        '011',
        '(?:284|[58]\\d\\d|900)\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-578]\\d{6})$',
        '284$1',
        0,
        '284',
      ],
      VI: [
        '1',
        '011',
        '[58]\\d{9}|(?:34|90)0\\d{7}',
        [10],
        0,
        '1',
        0,
        '1|([2-9]\\d{6})$',
        '340$1',
        0,
        '340',
      ],
      VN: [
        '84',
        '00',
        '[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}',
        [7, 8, 9, 10],
        [
          ['(\\d{2})(\\d{5})', '$1 $2', ['80'], '0$1', 1],
          ['(\\d{4})(\\d{4,6})', '$1 $2', ['1'], 0, 1],
          [
            '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
            '$1 $2 $3 $4',
            ['[69]'],
            '0$1',
            1,
          ],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[3578]'], '0$1', 1],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['2[48]'], '0$1', 1],
          ['(\\d{3})(\\d{4})(\\d{3})', '$1 $2 $3', ['2'], '0$1', 1],
        ],
        '0',
      ],
      VU: [
        '678',
        '00',
        '[48]8\\d{3}|(?:[23]|[579]\\d\\d)\\d{4}',
        [5, 7],
        [['(\\d{3})(\\d{4})', '$1 $2', ['[579]']]],
      ],
      WF: [
        '681',
        '00',
        '(?:[45]0|68|72|8\\d)\\d{4}',
        [6],
        [['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['[4-8]']]],
      ],
      WS: [
        '685',
        '0',
        '(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}',
        [5, 6, 7, 10],
        [
          ['(\\d{5})', '$1', ['[2-5]|6[1-9]']],
          ['(\\d{3})(\\d{3,7})', '$1 $2', ['[68]']],
          ['(\\d{2})(\\d{5})', '$1 $2', ['7']],
        ],
      ],
      XK: [
        '383',
        '00',
        '[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}',
        [8, 9],
        [
          ['(\\d{3})(\\d{5})', '$1 $2', ['[89]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-4]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[23]'], '0$1'],
        ],
        '0',
      ],
      YE: [
        '967',
        '00',
        '(?:1|7\\d)\\d{7}|[1-7]\\d{6}',
        [7, 8, 9],
        [
          ['(\\d)(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[1-6]|7[24-68]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['7'], '0$1'],
        ],
        '0',
      ],
      YT: [
        '262',
        '00',
        '80\\d{7}|(?:26|63)9\\d{6}',
        [9],
        0,
        '0',
        0,
        0,
        0,
        0,
        '269|63',
      ],
      ZA: [
        '27',
        '00',
        '[1-79]\\d{8}|8\\d{4,9}',
        [5, 6, 7, 8, 9, 10],
        [
          ['(\\d{2})(\\d{3,4})', '$1 $2', ['8[1-4]'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{2,3})', '$1 $2 $3', ['8[1-4]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['860'], '0$1'],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1-9]'], '0$1'],
          ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8'], '0$1'],
        ],
        '0',
      ],
      ZM: [
        '260',
        '00',
        '(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}',
        [9],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[28]'], '0$1'],
          ['(\\d{2})(\\d{7})', '$1 $2', ['[79]'], '0$1'],
        ],
        '0',
      ],
      ZW: [
        '263',
        '00',
        '2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}',
        [5, 6, 7, 8, 9, 10],
        [
          [
            '(\\d{3})(\\d{3,5})',
            '$1 $2',
            [
              '2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]',
            ],
            '0$1',
          ],
          ['(\\d)(\\d{3})(\\d{2,4})', '$1 $2 $3', ['[49]'], '0$1'],
          ['(\\d{3})(\\d{4})', '$1 $2', ['80'], '0$1'],
          [
            '(\\d{2})(\\d{7})',
            '$1 $2',
            [
              '24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2',
              '2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]',
            ],
            '(0$1)',
          ],
          ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
          [
            '(\\d{3})(\\d{3})(\\d{3,4})',
            '$1 $2 $3',
            [
              '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)',
              '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)',
            ],
            '0$1',
          ],
          ['(\\d{4})(\\d{6})', '$1 $2', ['8'], '0$1'],
          [
            '(\\d{2})(\\d{3,5})',
            '$1 $2',
            [
              '1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]',
            ],
            '0$1',
          ],
          [
            '(\\d{2})(\\d{3})(\\d{3,4})',
            '$1 $2 $3',
            ['29[013-9]|39|54'],
            '0$1',
          ],
          ['(\\d{4})(\\d{3,5})', '$1 $2', ['(?:25|54)8', '258|5483'], '0$1'],
        ],
        '0',
      ],
    },
    nonGeographic: {
      800: [
        '800',
        0,
        '[1-9]\\d{7}',
        [8],
        [['(\\d{4})(\\d{4})', '$1 $2', ['[1-9]']]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, ['[1-9]\\d{7}']],
      ],
      808: [
        '808',
        0,
        '[1-9]\\d{7}',
        [8],
        [['(\\d{4})(\\d{4})', '$1 $2', ['[1-9]']]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, 0, 0, 0, 0, 0, 0, ['[1-9]\\d{7}']],
      ],
      870: [
        '870',
        0,
        '7\\d{11}|[35-7]\\d{8}',
        [9, 12],
        [['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[35-7]']]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, ['(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}']],
      ],
      878: [
        '878',
        0,
        '10\\d{10}',
        [12],
        [['(\\d{2})(\\d{5})(\\d{5})', '$1 $2 $3', ['1']]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, 0, 0, 0, 0, 0, ['10\\d{10}']],
      ],
      881: [
        '881',
        0,
        '[0-36-9]\\d{8}',
        [9],
        [['(\\d)(\\d{3})(\\d{5})', '$1 $2 $3', ['[0-36-9]']]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, ['[0-36-9]\\d{8}']],
      ],
      882: [
        '882',
        0,
        '[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}',
        [7, 8, 9, 10, 11, 12],
        [
          ['(\\d{2})(\\d{5})', '$1 $2', ['16|342']],
          ['(\\d{2})(\\d{6})', '$1 $2', ['4']],
          ['(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3', ['[19]']],
          ['(\\d{2})(\\d{4})(\\d{3})', '$1 $2 $3', ['3[23]']],
          ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['1']],
          ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['34[57]']],
          ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['34']],
          ['(\\d{2})(\\d{4,5})(\\d{5})', '$1 $2 $3', ['[1-3]']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        [
          0,
          [
            '342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}',
            [7, 8, 9, 10, 12],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          [
            '1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}',
          ],
        ],
      ],
      883: [
        '883',
        0,
        '51\\d{7}(?:\\d{3})?',
        [9, 12],
        [
          ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['510']],
          ['(\\d{3})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['510']],
          ['(\\d{4})(\\d{4})(\\d{4})', '$1 $2 $3', ['5']],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, 0, 0, 0, 0, 0, ['51[013]0\\d{8}|5100\\d{5}']],
      ],
      888: [
        '888',
        0,
        '\\d{11}',
        [11],
        [['(\\d{3})(\\d{3})(\\d{5})', '$1 $2 $3']],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, 0, 0, 0, ['\\d{11}']],
      ],
      979: [
        '979',
        0,
        '[1359]\\d{8}',
        [9],
        [['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['[1359]']]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, ['[1359]\\d{8}']],
      ],
    },
  },
  wr = Zn(function (n) {
    !(function () {
      var e = {}.hasOwnProperty;
      function t() {
        for (var n = [], r = 0; r < arguments.length; r++) {
          var o = arguments[r];
          if (o) {
            var a = typeof o;
            if ('string' === a || 'number' === a) n.push(o);
            else if (Array.isArray(o) && o.length) {
              var i = t.apply(null, o);
              i && n.push(i);
            } else if ('object' === a)
              for (var d in o) e.call(o, d) && o[d] && n.push(d);
          }
        }
        return n.join(' ');
      }
      n.exports ? ((t.default = t), (n.exports = t)) : (window.classNames = t);
    })();
  });
function Er(n, e) {
  var t = 0,
    r = e.split(''),
    o = Array.isArray(r),
    a = 0;
  for (r = o ? r : r[Symbol.iterator](); ; ) {
    var i;
    if (o) {
      if (a >= r.length) break;
      i = r[a++];
    } else {
      if ((a = r.next()).done) break;
      i = a.value;
    }
    i === n && t++;
  }
  return t;
}
function Nr(n, e) {
  for (
    var t =
        arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 'x',
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ' ',
      o = n.length,
      a = Er('(', n),
      i = Er(')', n),
      d = a - i;
    d > 0 && o < e.length;

  )
    (n += e[o].replace(t, r)), ')' === e[o] && d--, o++;
  return n;
}
function Pr(n, e, t) {
  'string' == typeof t &&
    (t = (function (n) {
      var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'x',
        t = arguments.length > 2 ? arguments[2] : void 0;
      if (!n)
        return function (n) {
          return { text: n };
        };
      var r = Er(e, n);
      return function (o) {
        if (!o) return { text: '', template: n };
        var a = 0,
          i = '',
          d = n.split(''),
          l = Array.isArray(d),
          u = 0;
        for (d = l ? d : d[Symbol.iterator](); ; ) {
          var s;
          if (l) {
            if (u >= d.length) break;
            s = d[u++];
          } else {
            if ((u = d.next()).done) break;
            s = u.value;
          }
          var c = s;
          if (c === e) {
            if (((i += o[a]), ++a === o.length && o.length < r)) break;
          } else i += c;
        }
        return t && (i = Nr(i, n)), { text: i, template: n };
      };
    })(t));
  var r = t(n) || {},
    o = r.text,
    a = r.template;
  if ((void 0 === o && (o = n), a))
    if (void 0 === e) e = o.length;
    else {
      for (var i = 0, d = !1, l = -1; i < o.length && i < a.length; ) {
        if (o[i] !== a[i]) {
          if (0 === e) {
            (d = !0), (e = i);
            break;
          }
          (l = i), e--;
        }
        i++;
      }
      d || (e = l + 1);
    }
  return { text: o, caret: e };
}
var Sr = 8,
  Or = 46;
function kr(n, e) {
  void 0 !== e &&
    (!(function () {
      if ('undefined' != typeof navigator) return Ir.test(navigator.userAgent);
    })()
      ? n.setSelectionRange(e, e)
      : setTimeout(function () {
          return n.setSelectionRange(e, e);
        }, 0));
}
var Ir = /Android/i;
function Tr(n, e, t, r, o) {
  var a = (function (n) {
    switch (n.keyCode) {
      case Sr:
        return 'Backspace';
      case Or:
        return 'Delete';
    }
  })(n);
  switch (a) {
    case 'Delete':
    case 'Backspace':
      n.preventDefault();
      var i = (function (n) {
        if (n.selectionStart !== n.selectionEnd)
          return { start: n.selectionStart, end: n.selectionEnd };
      })(e);
      return i
        ? ((function (n, e) {
            var t = n.value;
            (t = t.slice(0, e.start) + t.slice(e.end)),
              (n.value = t),
              kr(n, e.start);
          })(e, i),
          Ar(e, t, r, void 0, o))
        : Ar(e, t, r, a, o);
  }
}
function Ar(n, e, t, r, o) {
  var a = (function (n, e, t) {
      for (var r = '', o = 0, a = 0; a < n.length; ) {
        var i = t(n[a], r);
        void 0 !== i &&
          ((r += i),
          void 0 !== e &&
            (e === a ? (o = r.length - 1) : e > a && (o = r.length))),
          a++;
      }
      return void 0 === e && (o = r.length), { value: r, caret: o };
    })(n.value, n.selectionStart, e),
    i = a.value,
    d = a.caret;
  if (r) {
    var l = (function (n, e, t) {
      switch (t) {
        case 'Backspace':
          e > 0 && ((n = n.slice(0, e - 1) + n.slice(e)), e--);
          break;
        case 'Delete':
          n = n.slice(0, e) + n.slice(e + 1);
      }
      return { value: n, caret: e };
    })(i, d, r);
    (i = l.value), (d = l.caret);
  }
  var u = Pr(i, d, t),
    s = u.text;
  (d = u.caret), (n.value = s), kr(n, d), o(i);
}
function Rr() {
  return (Rr =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function Br(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = (function (n, e) {
      if (null == n) return {};
      var t,
        r,
        o = {},
        a = Object.keys(n);
      for (r = 0; r < a.length; r++)
        (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
      return o;
    })(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (r = 0; r < a.length; r++)
      (t = a[r]),
        e.indexOf(t) >= 0 ||
          (Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]));
  }
  return o;
}
function Mr(e, r) {
  var o = e.value,
    a = e.parse,
    i = e.format,
    l = e.inputComponent,
    u = e.onChange,
    s = e.onKeyDown,
    c = Br(e, [
      'value',
      'parse',
      'format',
      'inputComponent',
      'onChange',
      'onKeyDown',
    ]),
    f = t(),
    m = d(function (n) {
      (f.current = n), r && ('function' == typeof r ? r(n) : (r.current = n));
    }, []),
    p = d(
      function (n) {
        Ar(f.current, a, i, void 0, u);
      },
      [f, a, i, u],
    ),
    $ = d(
      function (n) {
        return s && s(n), Tr(n, f.current, a, i, u);
      },
      [f, a, i, u, s],
    );
  return n.createElement(
    l,
    Rr({}, c, {
      ref: m,
      value: i(Dr(o) ? '' : o).text,
      onKeyDown: $,
      onChange: p,
    }),
  );
}
((Mr = n.forwardRef(Mr)).propTypes = {
  parse: je.func.isRequired,
  format: je.func.isRequired,
  inputComponent: je.elementType.isRequired,
  type: je.string.isRequired,
  value: je.string,
  onChange: je.func.isRequired,
  onKeyDown: je.func,
  onCut: je.func,
  onPaste: je.func,
}),
  (Mr.defaultProps = { inputComponent: 'input', type: 'text' });
var Fr = Mr;
function Dr(n) {
  return null == n;
}
var Lr = function n(e) {
  !(function (n, e) {
    if (!(n instanceof e))
      throw new TypeError('Cannot call a class as a function');
  })(this, n),
    (this.name = this.constructor.name),
    (this.message = e),
    (this.stack = new Error(e).stack);
};
(Lr.prototype = Object.create(Error.prototype)).constructor = Lr;
var jr = ''
  .concat('-‐-―−ー－')
  .concat('／/')
  .concat('．.')
  .concat('  ­​⁠　')
  .concat('()（）［］\\[\\]')
  .concat('~⁓∼～');
function zr(n, e) {
  (n = n.split('-')), (e = e.split('-'));
  for (var t = n[0].split('.'), r = e[0].split('.'), o = 0; o < 3; o++) {
    var a = Number(t[o]),
      i = Number(r[o]);
    if (a > i) return 1;
    if (i > a) return -1;
    if (!isNaN(a) && isNaN(i)) return 1;
    if (isNaN(a) && !isNaN(i)) return -1;
  }
  return n[1] && e[1]
    ? n[1] > e[1]
      ? 1
      : n[1] < e[1]
      ? -1
      : 0
    : !n[1] && e[1]
    ? 1
    : n[1] && !e[1]
    ? -1
    : 0;
}
function Gr(n) {
  return (Gr =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (n) {
          return typeof n;
        }
      : function (n) {
          return n &&
            'function' == typeof Symbol &&
            n.constructor === Symbol &&
            n !== Symbol.prototype
            ? 'symbol'
            : typeof n;
        })(n);
}
function _r(n, e) {
  if (!(n instanceof e))
    throw new TypeError('Cannot call a class as a function');
}
function Vr(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      'value' in r && (r.writable = !0),
      Object.defineProperty(n, r.key, r);
  }
}
function Hr(n, e, t) {
  return e && Vr(n.prototype, e), t && Vr(n, t), n;
}
var Ur = /^\d+$/,
  qr = (function () {
    function n(e) {
      _r(this, n),
        (function (n) {
          if (!n)
            throw new Error(
              '[libphonenumber-js] `metadata` argument not passed. Check your arguments.',
            );
          if (!Xr(n) || !Xr(n.countries))
            throw new Error(
              "[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(
                Xr(n)
                  ? 'an object of shape: { ' + Object.keys(n).join(', ') + ' }'
                  : 'a ' + Qr(n) + ': ' + n,
                '.',
              ),
            );
        })(e),
        (this.metadata = e),
        to.call(this, e);
    }
    return (
      Hr(n, [
        {
          key: 'getCountries',
          value: function () {
            return Object.keys(this.metadata.countries).filter(function (n) {
              return '001' !== n;
            });
          },
        },
        {
          key: 'getCountryMetadata',
          value: function (n) {
            return this.metadata.countries[n];
          },
        },
        {
          key: 'nonGeographic',
          value: function () {
            if (!(this.v1 || this.v2 || this.v3))
              return (
                this.metadata.nonGeographic || this.metadata.nonGeographical
              );
          },
        },
        {
          key: 'hasCountry',
          value: function (n) {
            return void 0 !== this.getCountryMetadata(n);
          },
        },
        {
          key: 'hasCallingCode',
          value: function (n) {
            if (this.getCountryCodesForCallingCode(n)) return !0;
            if (this.nonGeographic()) {
              if (this.nonGeographic()[n]) return !0;
            } else {
              var e = this.countryCallingCodes()[n];
              if (e && 1 === e.length && '001' === e[0]) return !0;
            }
          },
        },
        {
          key: 'isNonGeographicCallingCode',
          value: function (n) {
            return this.nonGeographic()
              ? !!this.nonGeographic()[n]
              : !this.getCountryCodesForCallingCode(n);
          },
        },
        {
          key: 'country',
          value: function (n) {
            return this.selectNumberingPlan(n);
          },
        },
        {
          key: 'selectNumberingPlan',
          value: function (n, e) {
            if ((n && Ur.test(n) && ((e = n), (n = null)), n && '001' !== n)) {
              if (!this.hasCountry(n))
                throw new Error('Unknown country: '.concat(n));
              this.numberingPlan = new Wr(this.getCountryMetadata(n), this);
            } else if (e) {
              if (!this.hasCallingCode(e))
                throw new Error('Unknown calling code: '.concat(e));
              this.numberingPlan = new Wr(
                this.getNumberingPlanMetadata(e),
                this,
              );
            } else this.numberingPlan = void 0;
            return this;
          },
        },
        {
          key: 'getCountryCodesForCallingCode',
          value: function (n) {
            var e = this.countryCallingCodes()[n];
            if (e) {
              if (1 === e.length && 3 === e[0].length) return;
              return e;
            }
          },
        },
        {
          key: 'getCountryCodeForCallingCode',
          value: function (n) {
            var e = this.getCountryCodesForCallingCode(n);
            if (e) return e[0];
          },
        },
        {
          key: 'getNumberingPlanMetadata',
          value: function (n) {
            var e = this.getCountryCodeForCallingCode(n);
            if (e) return this.getCountryMetadata(e);
            if (this.nonGeographic()) {
              var t = this.nonGeographic()[n];
              if (t) return t;
            } else {
              var r = this.countryCallingCodes()[n];
              if (r && 1 === r.length && '001' === r[0])
                return this.metadata.countries['001'];
            }
          },
        },
        {
          key: 'countryCallingCode',
          value: function () {
            return this.numberingPlan.callingCode();
          },
        },
        {
          key: 'IDDPrefix',
          value: function () {
            return this.numberingPlan.IDDPrefix();
          },
        },
        {
          key: 'defaultIDDPrefix',
          value: function () {
            return this.numberingPlan.defaultIDDPrefix();
          },
        },
        {
          key: 'nationalNumberPattern',
          value: function () {
            return this.numberingPlan.nationalNumberPattern();
          },
        },
        {
          key: 'possibleLengths',
          value: function () {
            return this.numberingPlan.possibleLengths();
          },
        },
        {
          key: 'formats',
          value: function () {
            return this.numberingPlan.formats();
          },
        },
        {
          key: 'nationalPrefixForParsing',
          value: function () {
            return this.numberingPlan.nationalPrefixForParsing();
          },
        },
        {
          key: 'nationalPrefixTransformRule',
          value: function () {
            return this.numberingPlan.nationalPrefixTransformRule();
          },
        },
        {
          key: 'leadingDigits',
          value: function () {
            return this.numberingPlan.leadingDigits();
          },
        },
        {
          key: 'hasTypes',
          value: function () {
            return this.numberingPlan.hasTypes();
          },
        },
        {
          key: 'type',
          value: function (n) {
            return this.numberingPlan.type(n);
          },
        },
        {
          key: 'ext',
          value: function () {
            return this.numberingPlan.ext();
          },
        },
        {
          key: 'countryCallingCodes',
          value: function () {
            return this.v1
              ? this.metadata.country_phone_code_to_countries
              : this.metadata.country_calling_codes;
          },
        },
        {
          key: 'chooseCountryByCountryCallingCode',
          value: function (n) {
            return this.selectNumberingPlan(n);
          },
        },
        {
          key: 'hasSelectedNumberingPlan',
          value: function () {
            return void 0 !== this.numberingPlan;
          },
        },
      ]),
      n
    );
  })(),
  Wr = (function () {
    function n(e, t) {
      _r(this, n),
        (this.globalMetadataObject = t),
        (this.metadata = e),
        to.call(this, t.metadata);
    }
    return (
      Hr(n, [
        {
          key: 'callingCode',
          value: function () {
            return this.metadata[0];
          },
        },
        {
          key: 'getDefaultCountryMetadataForRegion',
          value: function () {
            return this.globalMetadataObject.getNumberingPlanMetadata(
              this.callingCode(),
            );
          },
        },
        {
          key: 'IDDPrefix',
          value: function () {
            if (!this.v1 && !this.v2) return this.metadata[1];
          },
        },
        {
          key: 'defaultIDDPrefix',
          value: function () {
            if (!this.v1 && !this.v2) return this.metadata[12];
          },
        },
        {
          key: 'nationalNumberPattern',
          value: function () {
            return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
          },
        },
        {
          key: 'possibleLengths',
          value: function () {
            if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
          },
        },
        {
          key: '_getFormats',
          value: function (n) {
            return n[this.v1 ? 2 : this.v2 ? 3 : 4];
          },
        },
        {
          key: 'formats',
          value: function () {
            var n = this,
              e =
                this._getFormats(this.metadata) ||
                this._getFormats(this.getDefaultCountryMetadataForRegion()) ||
                [];
            return e.map(function (e) {
              return new Kr(e, n);
            });
          },
        },
        {
          key: 'nationalPrefix',
          value: function () {
            return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
          },
        },
        {
          key: '_getNationalPrefixFormattingRule',
          value: function (n) {
            return n[this.v1 ? 4 : this.v2 ? 5 : 6];
          },
        },
        {
          key: 'nationalPrefixFormattingRule',
          value: function () {
            return (
              this._getNationalPrefixFormattingRule(this.metadata) ||
              this._getNationalPrefixFormattingRule(
                this.getDefaultCountryMetadataForRegion(),
              )
            );
          },
        },
        {
          key: '_nationalPrefixForParsing',
          value: function () {
            return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
          },
        },
        {
          key: 'nationalPrefixForParsing',
          value: function () {
            return this._nationalPrefixForParsing() || this.nationalPrefix();
          },
        },
        {
          key: 'nationalPrefixTransformRule',
          value: function () {
            return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
          },
        },
        {
          key: '_getNationalPrefixIsOptionalWhenFormatting',
          value: function () {
            return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
          },
        },
        {
          key: 'nationalPrefixIsOptionalWhenFormattingInNationalFormat',
          value: function () {
            return (
              this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) ||
              this._getNationalPrefixIsOptionalWhenFormatting(
                this.getDefaultCountryMetadataForRegion(),
              )
            );
          },
        },
        {
          key: 'leadingDigits',
          value: function () {
            return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
          },
        },
        {
          key: 'types',
          value: function () {
            return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
          },
        },
        {
          key: 'hasTypes',
          value: function () {
            return (
              (!this.types() || 0 !== this.types().length) && !!this.types()
            );
          },
        },
        {
          key: 'type',
          value: function (n) {
            if (this.hasTypes() && Jr(this.types(), n))
              return new Zr(Jr(this.types(), n), this);
          },
        },
        {
          key: 'ext',
          value: function () {
            return this.v1 || this.v2
              ? ' ext. '
              : this.metadata[13] || ' ext. ';
          },
        },
      ]),
      n
    );
  })(),
  Kr = (function () {
    function n(e, t) {
      _r(this, n), (this._format = e), (this.metadata = t);
    }
    return (
      Hr(n, [
        {
          key: 'pattern',
          value: function () {
            return this._format[0];
          },
        },
        {
          key: 'format',
          value: function () {
            return this._format[1];
          },
        },
        {
          key: 'leadingDigitsPatterns',
          value: function () {
            return this._format[2] || [];
          },
        },
        {
          key: 'nationalPrefixFormattingRule',
          value: function () {
            return (
              this._format[3] || this.metadata.nationalPrefixFormattingRule()
            );
          },
        },
        {
          key: 'nationalPrefixIsOptionalWhenFormattingInNationalFormat',
          value: function () {
            return (
              !!this._format[4] ||
              this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat()
            );
          },
        },
        {
          key: 'nationalPrefixIsMandatoryWhenFormattingInNationalFormat',
          value: function () {
            return (
              this.usesNationalPrefix() &&
              !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat()
            );
          },
        },
        {
          key: 'usesNationalPrefix',
          value: function () {
            return !(
              !this.nationalPrefixFormattingRule() ||
              Yr.test(this.nationalPrefixFormattingRule())
            );
          },
        },
        {
          key: 'internationalFormat',
          value: function () {
            return this._format[5] || this.format();
          },
        },
      ]),
      n
    );
  })(),
  Yr = /^\(?\$1\)?$/,
  Zr = (function () {
    function n(e, t) {
      _r(this, n), (this.type = e), (this.metadata = t);
    }
    return (
      Hr(n, [
        {
          key: 'pattern',
          value: function () {
            return this.metadata.v1 ? this.type : this.type[0];
          },
        },
        {
          key: 'possibleLengths',
          value: function () {
            if (!this.metadata.v1)
              return this.type[1] || this.metadata.possibleLengths();
          },
        },
      ]),
      n
    );
  })();
function Jr(n, e) {
  switch (e) {
    case 'FIXED_LINE':
      return n[0];
    case 'MOBILE':
      return n[1];
    case 'TOLL_FREE':
      return n[2];
    case 'PREMIUM_RATE':
      return n[3];
    case 'PERSONAL_NUMBER':
      return n[4];
    case 'VOICEMAIL':
      return n[5];
    case 'UAN':
      return n[6];
    case 'PAGER':
      return n[7];
    case 'VOIP':
      return n[8];
    case 'SHARED_COST':
      return n[9];
  }
}
var Xr = function (n) {
    return 'object' === Gr(n);
  },
  Qr = function (n) {
    return Gr(n);
  };
function no(n, e) {
  if ((e = new qr(e)).hasCountry(n)) return e.country(n).countryCallingCode();
  throw new Error('Unknown country: '.concat(n));
}
function eo(n, e) {
  return void 0 !== e.countries[n];
}
function to(n) {
  var e = n.version;
  'number' == typeof e
    ? ((this.v1 = 1 === e),
      (this.v2 = 2 === e),
      (this.v3 = 3 === e),
      (this.v4 = 4 === e))
    : e
    ? -1 === zr(e, '1.2.0')
      ? (this.v2 = !0)
      : -1 === zr(e, '1.7.35')
      ? (this.v3 = !0)
      : (this.v4 = !0)
    : (this.v1 = !0);
}
var ro = function (n) {
  return '(['.concat('0-9０-９٠-٩۰-۹', ']{1,').concat(n, '})');
};
function oo(n) {
  var e = '#?';
  return (
    ';ext=' +
    ro('20') +
    '|' +
    ('[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*' +
      ro('20') +
      e) +
    '|' +
    ('[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*' + ro('9') + e) +
    '|' +
    ('[- ]+' + ro('6') + '#') +
    '|' +
    ('[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*' + ro('15') + e) +
    '|' +
    ('[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*' + ro('9') + e)
  );
}
var ao =
    '[+＋]{0,1}(?:[' +
    jr +
    ']*[0-9０-９٠-٩۰-۹]){3,}[' +
    jr +
    '0-9０-９٠-٩۰-۹]*' +
    '(?:' +
    oo() +
    ')?',
  io = new RegExp('^[0-9０-９٠-٩۰-۹]{2}$|^' + ao + '$', 'i');
function lo(n) {
  return n.length >= 2 && io.test(n);
}
var uo = new RegExp('(?:' + oo() + ')$', 'i');
var so = {
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  '０': '0',
  '１': '1',
  '２': '2',
  '３': '3',
  '４': '4',
  '５': '5',
  '６': '6',
  '７': '7',
  '８': '8',
  '９': '9',
  '٠': '0',
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
  '۰': '0',
  '۱': '1',
  '۲': '2',
  '۳': '3',
  '۴': '4',
  '۵': '5',
  '۶': '6',
  '۷': '7',
  '۸': '8',
  '۹': '9',
};
function co(n) {
  return so[n];
}
function fo(n) {
  var e = '',
    t = n.split(''),
    r = Array.isArray(t),
    o = 0;
  for (t = r ? t : t[Symbol.iterator](); ; ) {
    var a;
    if (r) {
      if (o >= t.length) break;
      a = t[o++];
    } else {
      if ((o = t.next()).done) break;
      a = o.value;
    }
    var i = co(a);
    i && (e += i);
  }
  return e;
}
function mo(n) {
  var e = '',
    t = n.split(''),
    r = Array.isArray(t),
    o = 0;
  for (t = r ? t : t[Symbol.iterator](); ; ) {
    var a;
    if (r) {
      if (o >= t.length) break;
      a = t[o++];
    } else {
      if ((o = t.next()).done) break;
      a = o.value;
    }
    e += po(a, e) || '';
  }
  return e;
}
function po(n, e) {
  if ('+' === n) {
    if (e) return;
    return '+';
  }
  return co(n);
}
function $o(n, e) {
  return ho(n, void 0, e);
}
function ho(n, e, t) {
  var r = t.type(e),
    o = (r && r.possibleLengths()) || t.possibleLengths();
  if (!o) return 'IS_POSSIBLE';
  if ('FIXED_LINE_OR_MOBILE' === e) {
    if (!t.type('FIXED_LINE')) return ho(n, 'MOBILE', t);
    var a = t.type('MOBILE');
    a &&
      (o = (function (n, e) {
        var t = n.slice(),
          r = e,
          o = Array.isArray(r),
          a = 0;
        for (r = o ? r : r[Symbol.iterator](); ; ) {
          var i;
          if (o) {
            if (a >= r.length) break;
            i = r[a++];
          } else {
            if ((a = r.next()).done) break;
            i = a.value;
          }
          var d = i;
          n.indexOf(d) < 0 && t.push(d);
        }
        return t.sort(function (n, e) {
          return n - e;
        });
      })(o, a.possibleLengths()));
  } else if (e && !r) return 'INVALID_LENGTH';
  var i = n.length,
    d = o[0];
  return d === i
    ? 'IS_POSSIBLE'
    : d > i
    ? 'TOO_SHORT'
    : o[o.length - 1] < i
    ? 'TOO_LONG'
    : o.indexOf(i, 1) >= 0
    ? 'IS_POSSIBLE'
    : 'INVALID_LENGTH';
}
function go(n, e) {
  switch ($o(n, e)) {
    case 'IS_POSSIBLE':
      return !0;
    default:
      return !1;
  }
}
function yo(n, e) {
  return (
    (function (n) {
      if (Array.isArray(n)) return n;
    })(n) ||
    (function (n, e) {
      var t = [],
        r = !0,
        o = !1,
        a = void 0;
      try {
        for (
          var i, d = n[Symbol.iterator]();
          !(r = (i = d.next()).done) && (t.push(i.value), !e || t.length !== e);
          r = !0
        );
      } catch (n) {
        (o = !0), (a = n);
      } finally {
        try {
          r || null == d.return || d.return();
        } finally {
          if (o) throw a;
        }
      }
      return t;
    })(n, e) ||
    (function () {
      throw new TypeError(
        'Invalid attempt to destructure non-iterable instance',
      );
    })()
  );
}
function bo(n, e) {
  return (n = n || ''), new RegExp('^(?:' + e + ')$').test(n);
}
var vo = [
  'MOBILE',
  'PREMIUM_RATE',
  'TOLL_FREE',
  'SHARED_COST',
  'VOIP',
  'PERSONAL_NUMBER',
  'PAGER',
  'UAN',
  'VOICEMAIL',
];
function xo(n, e, t) {
  if (((e = e || {}), n.country)) {
    (t = new qr(t)).selectNumberingPlan(n.country, n.countryCallingCode);
    var r = e.v2 ? n.nationalNumber : n.phone;
    if (bo(r, t.nationalNumberPattern())) {
      if (Co(r, 'FIXED_LINE', t))
        return t.type('MOBILE') && '' === t.type('MOBILE').pattern()
          ? 'FIXED_LINE_OR_MOBILE'
          : t.type('MOBILE')
          ? Co(r, 'MOBILE', t)
            ? 'FIXED_LINE_OR_MOBILE'
            : 'FIXED_LINE'
          : 'FIXED_LINE_OR_MOBILE';
      for (var o = 0, a = vo; o < a.length; o++) {
        var i = a[o];
        if (Co(r, i, t)) return i;
      }
    }
  }
}
function Co(n, e, t) {
  return (
    !(!(e = t.type(e)) || !e.pattern()) &&
    !(e.possibleLengths() && e.possibleLengths().indexOf(n.length) < 0) &&
    bo(n, e.pattern())
  );
}
function wo(n) {
  return n.replace(new RegExp('['.concat(jr, ']+'), 'g'), ' ').trim();
}
var Eo = /(\$\d)/;
function No(n, e, t) {
  var r = t.useInternationalFormat,
    o = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var a = n.replace(
    new RegExp(e.pattern()),
    r
      ? e.internationalFormat()
      : o && e.nationalPrefixFormattingRule()
      ? e.format().replace(Eo, e.nationalPrefixFormattingRule())
      : e.format(),
  );
  return r ? wo(a) : a;
}
var Po = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function So(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
var Oo = {
  formatExtension: function (n, e, t) {
    return ''.concat(n).concat(t.ext()).concat(e);
  },
};
function ko(n, e, t, r) {
  if (
    ((t = t
      ? (function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(t);
            'function' == typeof Object.getOwnPropertySymbols &&
              (r = r.concat(
                Object.getOwnPropertySymbols(t).filter(function (n) {
                  return Object.getOwnPropertyDescriptor(t, n).enumerable;
                }),
              )),
              r.forEach(function (e) {
                So(n, e, t[e]);
              });
          }
          return n;
        })({}, Oo, t)
      : Oo),
    (r = new qr(r)),
    n.country && '001' !== n.country)
  ) {
    if (!r.hasCountry(n.country))
      throw new Error('Unknown country: '.concat(n.country));
    r.country(n.country);
  } else {
    if (!n.countryCallingCode) return n.phone || '';
    r.selectNumberingPlan(n.countryCallingCode);
  }
  var o,
    a = r.countryCallingCode(),
    i = t.v2 ? n.nationalNumber : n.phone;
  switch (e) {
    case 'NATIONAL':
      return i
        ? To(
            (o = Io(i, n.carrierCode, 'NATIONAL', r, t)),
            n.ext,
            r,
            t.formatExtension,
          )
        : '';
    case 'INTERNATIONAL':
      return i
        ? ((o = Io(i, null, 'INTERNATIONAL', r, t)),
          To((o = '+'.concat(a, ' ').concat(o)), n.ext, r, t.formatExtension))
        : '+'.concat(a);
    case 'E.164':
      return '+'.concat(a).concat(i);
    case 'RFC3966':
      return (function (n) {
        var e = n.number,
          t = n.ext;
        if (!e) return '';
        if ('+' !== e[0])
          throw new Error(
            '"formatRFC3966()" expects "number" to be in E.164 format.',
          );
        return 'tel:'.concat(e).concat(t ? ';ext=' + t : '');
      })({ number: '+'.concat(a).concat(i), ext: n.ext });
    case 'IDD':
      if (!t.fromCountry) return;
      return To(
        (function (n, e, t, r, o) {
          if (no(r, o.metadata) === t) {
            var a = Io(n, e, 'NATIONAL', o);
            return '1' === t ? t + ' ' + a : a;
          }
          var i = (function (n, e, t) {
            var r = new qr(t);
            return (
              r.selectNumberingPlan(n, e),
              Po.test(r.IDDPrefix()) ? r.IDDPrefix() : r.defaultIDDPrefix()
            );
          })(r, void 0, o.metadata);
          if (i)
            return ''
              .concat(i, ' ')
              .concat(t, ' ')
              .concat(Io(n, null, 'INTERNATIONAL', o));
        })(i, n.carrierCode, a, t.fromCountry, r),
        n.ext,
        r,
        t.formatExtension,
      );
    default:
      throw new Error(
        'Unknown "format" argument passed to "formatNumber()": "'.concat(
          e,
          '"',
        ),
      );
  }
}
function Io(n, e, t, r, o) {
  var a = (function (n, e) {
    var t = n,
      r = Array.isArray(t),
      o = 0;
    for (t = r ? t : t[Symbol.iterator](); ; ) {
      var a;
      if (r) {
        if (o >= t.length) break;
        a = t[o++];
      } else {
        if ((o = t.next()).done) break;
        a = o.value;
      }
      var i = a;
      if (i.leadingDigitsPatterns().length > 0) {
        var d = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
        if (0 !== e.search(d)) continue;
      }
      if (bo(e, i.pattern())) return i;
    }
  })(r.formats(), n);
  return a
    ? No(n, a, {
        useInternationalFormat: 'INTERNATIONAL' === t,
        withNationalPrefix:
          !a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() ||
          !o ||
          !1 !== o.nationalPrefix,
        carrierCode: e,
        metadata: r,
      })
    : n;
}
function To(n, e, t, r) {
  return e ? r(n, e, t) : n;
}
function Ao(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
function Ro(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      'value' in r && (r.writable = !0),
      Object.defineProperty(n, r.key, r);
  }
}
var Bo = (function () {
    function n(e, t, r) {
      if (
        ((function (n, e) {
          if (!(n instanceof e))
            throw new TypeError('Cannot call a class as a function');
        })(this, n),
        !e)
      )
        throw new TypeError('`country` or `countryCallingCode` not passed');
      if (!t) throw new TypeError('`nationalNumber` not passed');
      var o = new qr(r);
      Mo(e) && ((this.country = e), o.country(e), (e = o.countryCallingCode())),
        (this.countryCallingCode = e),
        (this.nationalNumber = t),
        (this.number = '+' + this.countryCallingCode + this.nationalNumber),
        (this.metadata = r);
    }
    var e, t, r;
    return (
      (e = n),
      (t = [
        {
          key: 'isPossible',
          value: function () {
            return (function (n, e, t) {
              if ((void 0 === e && (e = {}), (t = new qr(t)), e.v2)) {
                if (!n.countryCallingCode)
                  throw new Error('Invalid phone number object passed');
                t.selectNumberingPlan(n.countryCallingCode);
              } else {
                if (!n.phone) return !1;
                if (n.country) {
                  if (!t.hasCountry(n.country))
                    throw new Error('Unknown country: '.concat(n.country));
                  t.country(n.country);
                } else {
                  if (!n.countryCallingCode)
                    throw new Error('Invalid phone number object passed');
                  t.selectNumberingPlan(n.countryCallingCode);
                }
              }
              if (t.possibleLengths())
                return go(n.phone || n.nationalNumber, t);
              if (
                n.countryCallingCode &&
                t.isNonGeographicCallingCode(n.countryCallingCode)
              )
                return !0;
              throw new Error(
                'Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.',
              );
            })(this, { v2: !0 }, this.metadata);
          },
        },
        {
          key: 'isValid',
          value: function () {
            return (function (n, e, t) {
              return (
                (e = e || {}),
                (t = new qr(t)),
                !!n.country &&
                  (t.selectNumberingPlan(n.country, n.countryCallingCode),
                  t.hasTypes()
                    ? void 0 !== xo(n, e, t.metadata)
                    : bo(
                        e.v2 ? n.nationalNumber : n.phone,
                        t.nationalNumberPattern(),
                      ))
              );
            })(this, { v2: !0 }, this.metadata);
          },
        },
        {
          key: 'isNonGeographic',
          value: function () {
            return new qr(this.metadata).isNonGeographicCallingCode(
              this.countryCallingCode,
            );
          },
        },
        {
          key: 'isEqual',
          value: function (n) {
            return this.number === n.number && this.ext === n.ext;
          },
        },
        {
          key: 'getType',
          value: function () {
            return xo(this, { v2: !0 }, this.metadata);
          },
        },
        {
          key: 'format',
          value: function (n, e) {
            return ko(
              this,
              n,
              e
                ? (function (n) {
                    for (var e = 1; e < arguments.length; e++) {
                      var t = null != arguments[e] ? arguments[e] : {},
                        r = Object.keys(t);
                      'function' == typeof Object.getOwnPropertySymbols &&
                        (r = r.concat(
                          Object.getOwnPropertySymbols(t).filter(function (n) {
                            return Object.getOwnPropertyDescriptor(
                              t,
                              n,
                            ).enumerable;
                          }),
                        )),
                        r.forEach(function (e) {
                          Ao(n, e, t[e]);
                        });
                    }
                    return n;
                  })({}, e, { v2: !0 })
                : { v2: !0 },
              this.metadata,
            );
          },
        },
        {
          key: 'formatNational',
          value: function (n) {
            return this.format('NATIONAL', n);
          },
        },
        {
          key: 'formatInternational',
          value: function (n) {
            return this.format('INTERNATIONAL', n);
          },
        },
        {
          key: 'getURI',
          value: function (n) {
            return this.format('RFC3966', n);
          },
        },
      ]) && Ro(e.prototype, t),
      r && Ro(e, r),
      n
    );
  })(),
  Mo = function (n) {
    return /^[A-Z]{2}$/.test(n);
  },
  Fo = new RegExp('([0-9０-９٠-٩۰-۹])');
function Do(n, e, t, r) {
  if (e) {
    var o = new qr(r);
    o.selectNumberingPlan(e, t);
    var a = new RegExp(o.IDDPrefix());
    if (0 === n.search(a)) {
      var i = (n = n.slice(n.match(a)[0].length)).match(Fo);
      if (!(i && null != i[1] && i[1].length > 0 && '0' === i[1])) return n;
    }
  }
}
function Lo(n, e) {
  if (n && e.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp(
        '^(?:' + e.numberingPlan.nationalPrefixForParsing() + ')',
      ),
      r = t.exec(n);
    if (r) {
      var o,
        a,
        i,
        d = r.length - 1,
        l = d > 0 && r[d];
      if (e.nationalPrefixTransformRule() && l)
        (o = n.replace(t, e.nationalPrefixTransformRule())),
          d > 1 && (a = r[1]);
      else {
        var u = r[0];
        (o = n.slice(u.length)), l && (a = r[1]);
      }
      if (l) {
        var s = n.indexOf(r[1]);
        n.slice(0, s) === e.numberingPlan.nationalPrefix() &&
          (i = e.numberingPlan.nationalPrefix());
      } else i = r[0];
      return { nationalNumber: o, nationalPrefix: i, carrierCode: a };
    }
  }
  return { nationalNumber: n };
}
function jo(n, e) {
  var t = Lo(n, e),
    r = t.nationalNumber,
    o = t.carrierCode;
  if (
    !(function (n, e, t) {
      if (bo(n, t.nationalNumberPattern()) && !bo(e, t.nationalNumberPattern()))
        return !1;
      return !0;
    })(n, r, e)
  )
    return { nationalNumber: n };
  if (n.length !== r.length + (o ? o.length : 0) && e.possibleLengths())
    switch ($o(r, e)) {
      case 'TOO_SHORT':
      case 'INVALID_LENGTH':
        return { nationalNumber: n };
    }
  return { nationalNumber: r, carrierCode: o };
}
function zo(n, e, t, r) {
  var o = e ? no(e, r) : t;
  if (0 === n.indexOf(o)) {
    (r = new qr(r)).selectNumberingPlan(e, t);
    var a = n.slice(o.length),
      i = jo(a, r).nationalNumber,
      d = jo(n, r).nationalNumber;
    if (
      (!bo(d, r.nationalNumberPattern()) && bo(i, r.nationalNumberPattern())) ||
      'TOO_LONG' === $o(d, r)
    )
      return { countryCallingCode: o, number: a };
  }
  return { number: n };
}
function Go(n, e, t, r) {
  if (!n) return {};
  if ('+' !== n[0]) {
    var o = Do(n, e, t, r);
    if (!o || o === n) {
      if (e || t) {
        var a = zo(n, e, t, r),
          i = a.countryCallingCode,
          d = a.number;
        if (i) return { countryCallingCode: i, number: d };
      }
      return { number: n };
    }
    n = '+' + o;
  }
  if ('0' === n[1]) return {};
  r = new qr(r);
  for (var l = 2; l - 1 <= 3 && l <= n.length; ) {
    var u = n.slice(1, l);
    if (r.hasCallingCode(u))
      return (
        r.selectNumberingPlan(u), { countryCallingCode: u, number: n.slice(l) }
      );
    l++;
  }
  return {};
}
function _o(n, e, t) {
  var r = t.getCountryCodesForCallingCode(n);
  if (r)
    return 1 === r.length
      ? r[0]
      : (function (n, e, t) {
          t = new qr(t);
          var r = n,
            o = Array.isArray(r),
            a = 0;
          for (r = o ? r : r[Symbol.iterator](); ; ) {
            var i;
            if (o) {
              if (a >= r.length) break;
              i = r[a++];
            } else {
              if ((a = r.next()).done) break;
              i = a.value;
            }
            var d = i;
            if ((t.country(d), t.leadingDigits())) {
              if (e && 0 === e.search(t.leadingDigits())) return d;
            } else if (xo({ phone: e, country: d }, void 0, t.metadata))
              return d;
          }
        })(r, e, t.metadata);
}
var Vo = new RegExp('[+＋0-9０-９٠-٩۰-۹]'),
  Ho = new RegExp('[^0-9０-９٠-٩۰-۹#]+$');
function Uo(n, e, t) {
  if (
    ((e = e || {}),
    (t = new qr(t)),
    e.defaultCountry && !t.hasCountry(e.defaultCountry))
  ) {
    if (e.v2) throw new Lr('INVALID_COUNTRY');
    throw new Error('Unknown country: '.concat(e.defaultCountry));
  }
  var r = (function (n, e, t) {
      if (n && 0 === n.indexOf('tel:'))
        return (function (n) {
          var e,
            t,
            r = (n = n.replace(/^tel:/, 'tel=')).split(';'),
            o = Array.isArray(r),
            a = 0;
          for (r = o ? r : r[Symbol.iterator](); ; ) {
            var i;
            if (o) {
              if (a >= r.length) break;
              i = r[a++];
            } else {
              if ((a = r.next()).done) break;
              i = a.value;
            }
            var d = yo(i.split('='), 2),
              l = d[0],
              u = d[1];
            switch (l) {
              case 'tel':
                e = u;
                break;
              case 'ext':
                t = u;
                break;
              case 'phone-context':
                '+' === u[0] && (e = u + e);
            }
          }
          if (!lo(e)) return {};
          var s = { number: e };
          return t && (s.ext = t), s;
        })(n);
      var r = (function (n, e, t) {
        if (!n) return;
        if (n.length > 250) {
          if (t) throw new Lr('TOO_LONG');
          return;
        }
        if (!1 === e) return n;
        var r = n.search(Vo);
        if (r < 0) return;
        return n.slice(r).replace(Ho, '');
      })(n, t, e);
      if (!r || !lo(r)) return {};
      var o = (function (n) {
        var e = n.search(uo);
        if (e < 0) return {};
        for (var t = n.slice(0, e), r = n.match(uo), o = 1; o < r.length; ) {
          if (r[o]) return { number: t, ext: r[o] };
          o++;
        }
      })(r);
      if (o.ext) return o;
      return { number: r };
    })(n, e.v2, e.extract),
    o = r.number,
    a = r.ext;
  if (!o) {
    if (e.v2) throw new Lr('NOT_A_NUMBER');
    return {};
  }
  var i = (function (n, e, t, r) {
      var o,
        a = Go(mo(n), e, t, r.metadata),
        i = a.countryCallingCode,
        d = a.number;
      if (i) r.selectNumberingPlan(i);
      else {
        if (!d || (!e && !t)) return {};
        r.selectNumberingPlan(e, t), e && (o = e), (i = t || no(e, r.metadata));
      }
      if (!d) return { countryCallingCode: i };
      var l = jo(mo(d), r),
        u = l.nationalNumber,
        s = l.carrierCode,
        c = _o(i, u, r);
      c && ((o = c), '001' === c || r.country(o));
      return {
        country: o,
        countryCallingCode: i,
        nationalNumber: u,
        carrierCode: s,
      };
    })(o, e.defaultCountry, e.defaultCallingCode, t),
    d = i.country,
    l = i.nationalNumber,
    u = i.countryCallingCode,
    s = i.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (e.v2) throw new Lr('INVALID_COUNTRY');
    return {};
  }
  if (!l || l.length < 2) {
    if (e.v2) throw new Lr('TOO_SHORT');
    return {};
  }
  if (l.length > 17) {
    if (e.v2) throw new Lr('TOO_LONG');
    return {};
  }
  if (e.v2) {
    var c = new Bo(u, l, t.metadata);
    return d && (c.country = d), s && (c.carrierCode = s), a && (c.ext = a), c;
  }
  var f =
    !!(e.extended ? t.hasSelectedNumberingPlan() : d) &&
    bo(l, t.nationalNumberPattern());
  return e.extended
    ? {
        country: d,
        countryCallingCode: u,
        carrierCode: s,
        valid: f,
        possible:
          !!f || !(!0 !== e.extended || !t.possibleLengths() || !go(l, t)),
        phone: l,
        ext: a,
      }
    : f
    ? (function (n, e, t) {
        var r = { country: n, phone: e };
        t && (r.ext = t);
        return r;
      })(d, l, a)
    : {};
}
function qo(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
function Wo(n, e, t) {
  return Uo(
    n,
    (function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {},
          r = Object.keys(t);
        'function' == typeof Object.getOwnPropertySymbols &&
          (r = r.concat(
            Object.getOwnPropertySymbols(t).filter(function (n) {
              return Object.getOwnPropertyDescriptor(t, n).enumerable;
            }),
          )),
          r.forEach(function (e) {
            qo(n, e, t[e]);
          });
      }
      return n;
    })({}, e, { v2: !0 }),
    t,
  );
}
function Ko(n) {
  return (Ko =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (n) {
          return typeof n;
        }
      : function (n) {
          return n &&
            'function' == typeof Symbol &&
            n.constructor === Symbol &&
            n !== Symbol.prototype
            ? 'symbol'
            : typeof n;
        })(n);
}
function Yo(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
function Zo(n, e) {
  return (
    (function (n) {
      if (Array.isArray(n)) return n;
    })(n) ||
    (function (n, e) {
      var t = [],
        r = !0,
        o = !1,
        a = void 0;
      try {
        for (
          var i, d = n[Symbol.iterator]();
          !(r = (i = d.next()).done) && (t.push(i.value), !e || t.length !== e);
          r = !0
        );
      } catch (n) {
        (o = !0), (a = n);
      } finally {
        try {
          r || null == d.return || d.return();
        } finally {
          if (o) throw a;
        }
      }
      return t;
    })(n, e) ||
    (function () {
      throw new TypeError(
        'Invalid attempt to destructure non-iterable instance',
      );
    })()
  );
}
function Jo(n) {
  var e,
    t,
    r,
    o = Zo(Array.prototype.slice.call(n), 4),
    a = o[0],
    i = o[1],
    d = o[2],
    l = o[3];
  if ('string' != typeof a)
    throw new TypeError('A text for parsing must be a string.');
  if (((e = a), i && 'string' != typeof i)) {
    if (!Xo(i)) throw new Error('Invalid second argument: '.concat(i));
    d ? ((t = i), (r = d)) : (r = i);
  } else
    l ? ((t = d), (r = l)) : ((t = void 0), (r = d)),
      i &&
        (t = (function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(t);
            'function' == typeof Object.getOwnPropertySymbols &&
              (r = r.concat(
                Object.getOwnPropertySymbols(t).filter(function (n) {
                  return Object.getOwnPropertyDescriptor(t, n).enumerable;
                }),
              )),
              r.forEach(function (e) {
                Yo(n, e, t[e]);
              });
          }
          return n;
        })({ defaultCountry: i }, t));
  return { text: e, options: t, metadata: r };
}
var Xo = function (n) {
  return 'object' === Ko(n);
};
function Qo(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
function na(n, e, t) {
  e &&
    e.defaultCountry &&
    !eo(e.defaultCountry, t) &&
    (e = (function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {},
          r = Object.keys(t);
        'function' == typeof Object.getOwnPropertySymbols &&
          (r = r.concat(
            Object.getOwnPropertySymbols(t).filter(function (n) {
              return Object.getOwnPropertyDescriptor(t, n).enumerable;
            }),
          )),
          r.forEach(function (e) {
            Qo(n, e, t[e]);
          });
      }
      return n;
    })({}, e, { defaultCountry: void 0 }));
  try {
    return Wo(n, e, t);
  } catch (n) {
    if (!(n instanceof Lr)) throw n;
  }
}
function ea(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      'value' in r && (r.writable = !0),
      Object.defineProperty(n, r.key, r);
  }
}
var ta = (function () {
    function n(e) {
      var t,
        r,
        o,
        a = this,
        i = e.onCountryChange,
        d = e.onCallingCodeChange;
      !(function (n, e) {
        if (!(n instanceof e))
          throw new TypeError('Cannot call a class as a function');
      })(this, n),
        (o = function (n) {
          for (var e = 0, t = Object.keys(n); e < t.length; e++) {
            var r = t[e];
            a[r] = n[r];
          }
        }),
        (r = 'update') in (t = this)
          ? Object.defineProperty(t, r, {
              value: o,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (t[r] = o),
        (this.onCountryChange = i),
        (this.onCallingCodeChange = d);
    }
    var e, t, r;
    return (
      (e = n),
      (t = [
        {
          key: 'reset',
          value: function (n, e) {
            (this.international = !1),
              (this.IDDPrefix = void 0),
              (this.missingPlus = void 0),
              (this.callingCode = void 0),
              (this.digits = ''),
              this.resetNationalSignificantNumber(),
              this.initCountryAndCallingCode(n, e);
          },
        },
        {
          key: 'resetNationalSignificantNumber',
          value: function () {
            (this.nationalSignificantNumber = this.getNationalDigits()),
              (this.nationalSignificantNumberMatchesInput = !0),
              (this.nationalPrefix = void 0),
              (this.carrierCode = void 0),
              (this.complexPrefixBeforeNationalSignificantNumber = void 0);
          },
        },
        {
          key: 'initCountryAndCallingCode',
          value: function (n, e) {
            this.setCountry(n), this.setCallingCode(e);
          },
        },
        {
          key: 'setCountry',
          value: function (n) {
            (this.country = n), this.onCountryChange(n);
          },
        },
        {
          key: 'setCallingCode',
          value: function (n) {
            return (
              (this.callingCode = n), this.onCallingCodeChange(this.country, n)
            );
          },
        },
        {
          key: 'startInternationalNumber',
          value: function () {
            (this.international = !0), this.initCountryAndCallingCode();
          },
        },
        {
          key: 'appendDigits',
          value: function (n) {
            this.digits += n;
          },
        },
        {
          key: 'appendNationalSignificantNumberDigits',
          value: function (n) {
            this.nationalSignificantNumber += n;
          },
        },
        {
          key: 'getNationalDigits',
          value: function () {
            return this.international
              ? this.digits.slice(
                  (this.IDDPrefix ? this.IDDPrefix.length : 0) +
                    (this.callingCode ? this.callingCode.length : 0),
                )
              : this.digits;
          },
        },
        {
          key: 'getDigitsWithoutInternationalPrefix',
          value: function () {
            return this.international && this.IDDPrefix
              ? this.digits.slice(this.IDDPrefix.length)
              : this.digits;
          },
        },
      ]) && ea(e.prototype, t),
      r && ea(e, r),
      n
    );
  })(),
  ra = new RegExp('x');
function oa(n, e) {
  if (e < 1) return '';
  for (var t = ''; e > 1; ) 1 & e && (t += n), (e >>= 1), (n += n);
  return t + n;
}
function aa(n, e) {
  return (
    ')' === n[e] && e++,
    (function (n) {
      var e = [],
        t = 0;
      for (; t < n.length; )
        '(' === n[t] ? e.push(t) : ')' === n[t] && e.pop(), t++;
      var r = 0,
        o = '';
      e.push(n.length);
      for (var a = 0, i = e; a < i.length; a++) {
        var d = i[a];
        (o += n.slice(r, d)), (r = d + 1);
      }
      return o;
    })(n.slice(0, e))
  );
}
function ia(n, e, t) {
  var r = t.metadata,
    o = t.shouldTryNationalPrefixFormattingRule,
    a = t.getSeparatorAfterNationalPrefix;
  if (
    new RegExp('^(?:'.concat(e.pattern(), ')$')).test(
      n.nationalSignificantNumber,
    )
  )
    return (function (n, e, t) {
      var r = t.metadata,
        o = t.shouldTryNationalPrefixFormattingRule,
        a = t.getSeparatorAfterNationalPrefix;
      if (
        (n.nationalSignificantNumber,
        n.international,
        n.nationalPrefix,
        n.carrierCode,
        o(e))
      ) {
        var i = da(n, e, {
          useNationalPrefixFormattingRule: !0,
          getSeparatorAfterNationalPrefix: a,
          metadata: r,
        });
        if (i) return i;
      }
      return da(n, e, {
        useNationalPrefixFormattingRule: !1,
        getSeparatorAfterNationalPrefix: a,
        metadata: r,
      });
    })(n, e, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: o,
      getSeparatorAfterNationalPrefix: a,
    });
}
function da(n, e, t) {
  var r = t.metadata,
    o = t.useNationalPrefixFormattingRule,
    a = t.getSeparatorAfterNationalPrefix,
    i = No(n.nationalSignificantNumber, e, {
      carrierCode: n.carrierCode,
      useInternationalFormat: n.international,
      withNationalPrefix: o,
      metadata: r,
    });
  if (
    (o ||
      (n.nationalPrefix
        ? (i = n.nationalPrefix + a(e) + i)
        : n.complexPrefixBeforeNationalSignificantNumber &&
          (i = n.complexPrefixBeforeNationalSignificantNumber + ' ' + i)),
    (function (n, e) {
      return fo(n) === e.getNationalDigits();
    })(i, n))
  )
    return i;
}
function la(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      'value' in r && (r.writable = !0),
      Object.defineProperty(n, r.key, r);
  }
}
function ua(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
var sa = oa('9', 15),
  ca = /[- ]/,
  fa = new RegExp('^[' + jr + ']*(\\$\\d[' + jr + ']*)+$'),
  ma = (function () {
    function n(e) {
      var t = this;
      e.state;
      var r = e.metadata;
      !(function (n, e) {
        if (!(n instanceof e))
          throw new TypeError('Cannot call a class as a function');
      })(this, n),
        ua(this, 'getSeparatorAfterNationalPrefix', function (n) {
          return t.isNANP ||
            (n &&
              n.nationalPrefixFormattingRule() &&
              ca.test(n.nationalPrefixFormattingRule()))
            ? ' '
            : '';
        }),
        ua(this, 'shouldTryNationalPrefixFormattingRule', function (n, e) {
          var t = e.international,
            r = e.nationalPrefix;
          if (n.nationalPrefixFormattingRule()) {
            var o = n.usesNationalPrefix();
            if ((o && r) || (!o && !t)) return !0;
          }
        }),
        (this.metadata = r),
        this.resetFormat();
    }
    var e, t, r;
    return (
      (e = n),
      (t = [
        {
          key: 'resetFormat',
          value: function () {
            (this.chosenFormat = void 0),
              (this.template = void 0),
              (this.nationalNumberTemplate = void 0),
              (this.populatedNationalNumberTemplate = void 0),
              (this.populatedNationalNumberTemplatePosition = -1);
          },
        },
        {
          key: 'reset',
          value: function (n, e) {
            this.resetFormat(),
              n
                ? ((this.isNANP = '1' === n.callingCode()),
                  (this.matchingFormats = n.formats()),
                  e.nationalSignificantNumber &&
                    this.narrowDownMatchingFormats(e))
                : ((this.isNANP = void 0), (this.matchingFormats = []));
          },
        },
        {
          key: 'format',
          value: function (n, e) {
            var t = this;
            if (
              (function (n, e) {
                return 'IS_POSSIBLE' === $o(n, e);
              })(e.nationalSignificantNumber, this.metadata)
            ) {
              var r = this.matchingFormats,
                o = Array.isArray(r),
                a = 0;
              for (r = o ? r : r[Symbol.iterator](); ; ) {
                var i;
                if (o) {
                  if (a >= r.length) break;
                  i = r[a++];
                } else {
                  if ((a = r.next()).done) break;
                  i = a.value;
                }
                var d = i,
                  l = ia(e, d, {
                    metadata: this.metadata,
                    shouldTryNationalPrefixFormattingRule: function (n) {
                      return t.shouldTryNationalPrefixFormattingRule(n, {
                        international: e.international,
                        nationalPrefix: e.nationalPrefix,
                      });
                    },
                    getSeparatorAfterNationalPrefix:
                      this.getSeparatorAfterNationalPrefix,
                  });
                if (l)
                  return (
                    this.resetFormat(),
                    (this.chosenFormat = d),
                    this.setNationalNumberTemplate(l.replace(/\d/g, 'x'), e),
                    (this.populatedNationalNumberTemplate = l),
                    (this.populatedNationalNumberTemplatePosition =
                      this.template.lastIndexOf('x')),
                    l
                  );
              }
            }
            return this.formatNationalNumberWithNextDigits(n, e);
          },
        },
        {
          key: 'formatNationalNumberWithNextDigits',
          value: function (n, e) {
            var t = this.chosenFormat,
              r = this.chooseFormat(e);
            if (r)
              return r === t
                ? this.formatNextNationalNumberDigits(n)
                : this.formatNextNationalNumberDigits(e.getNationalDigits());
          },
        },
        {
          key: 'narrowDownMatchingFormats',
          value: function (n) {
            var e = this,
              t = n.nationalSignificantNumber,
              r = n.nationalPrefix,
              o = n.international,
              a = t,
              i = a.length - 3;
            i < 0 && (i = 0),
              (this.matchingFormats = this.matchingFormats.filter(function (n) {
                return e.formatSuits(n, o, r) && e.formatMatches(n, a, i);
              })),
              this.chosenFormat &&
                -1 === this.matchingFormats.indexOf(this.chosenFormat) &&
                this.resetFormat();
          },
        },
        {
          key: 'formatSuits',
          value: function (n, e, t) {
            return !(
              (t &&
                !n.usesNationalPrefix() &&
                !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) ||
              (!e &&
                !t &&
                n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat())
            );
          },
        },
        {
          key: 'formatMatches',
          value: function (n, e, t) {
            var r = n.leadingDigitsPatterns().length;
            if (0 === r) return !0;
            if (e.length < 3) return !0;
            t = Math.min(t, r - 1);
            var o = n.leadingDigitsPatterns()[t];
            return new RegExp('^('.concat(o, ')')).test(e);
          },
        },
        {
          key: 'getFormatFormat',
          value: function (n, e) {
            return e ? n.internationalFormat() : n.format();
          },
        },
        {
          key: 'chooseFormat',
          value: function (n) {
            var e = this,
              t = function () {
                if (o) {
                  if (a >= r.length) return 'break';
                  i = r[a++];
                } else {
                  if ((a = r.next()).done) return 'break';
                  i = a.value;
                }
                var t = i;
                return e.chosenFormat === t
                  ? 'break'
                  : fa.test(e.getFormatFormat(t, n.international))
                  ? e.createTemplateForFormat(t, n)
                    ? ((e.chosenFormat = t), 'break')
                    : ((e.matchingFormats = e.matchingFormats.filter(function (
                        n,
                      ) {
                        return n !== t;
                      })),
                      'continue')
                  : 'continue';
              },
              r = this.matchingFormats.slice(),
              o = Array.isArray(r),
              a = 0;
            n: for (r = o ? r : r[Symbol.iterator](); ; ) {
              var i;
              switch (t()) {
                case 'break':
                  break n;
                case 'continue':
                  continue;
              }
            }
            return this.chosenFormat || this.resetFormat(), this.chosenFormat;
          },
        },
        {
          key: 'createTemplateForFormat',
          value: function (n, e) {
            if (!(n.pattern().indexOf('|') >= 0)) {
              var t = this.getTemplateForFormat(n, e);
              return t ? (this.setNationalNumberTemplate(t, e), !0) : void 0;
            }
          },
        },
        {
          key: 'getInternationalPrefixBeforeCountryCallingCode',
          value: function (n, e) {
            var t = n.IDDPrefix,
              r = n.missingPlus;
            return t ? (e && !1 === e.spacing ? t : t + ' ') : r ? '' : '+';
          },
        },
        {
          key: 'getTemplate',
          value: function (n) {
            if (this.template) {
              for (
                var e = -1,
                  t = 0,
                  r = n.international
                    ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
                        spacing: !1,
                      })
                    : '';
                t < r.length + n.getDigitsWithoutInternationalPrefix().length;

              )
                (e = this.template.indexOf('x', e + 1)), t++;
              return aa(this.template, e + 1);
            }
          },
        },
        {
          key: 'setNationalNumberTemplate',
          value: function (n, e) {
            (this.nationalNumberTemplate = n),
              (this.populatedNationalNumberTemplate = n),
              (this.populatedNationalNumberTemplatePosition = -1),
              e.international
                ? (this.template =
                    this.getInternationalPrefixBeforeCountryCallingCode(
                      e,
                    ).replace(/[\d\+]/g, 'x') +
                    oa('x', e.callingCode.length) +
                    ' ' +
                    n)
                : (this.template = n);
          },
        },
        {
          key: 'getTemplateForFormat',
          value: function (n, e) {
            var t = e.nationalSignificantNumber,
              r = e.international,
              o = e.nationalPrefix,
              a = e.complexPrefixBeforeNationalSignificantNumber,
              i = n.pattern();
            i = i
              .replace(/\[([^\[\]])*\]/g, '\\d')
              .replace(/\d(?=[^,}][^,}])/g, '\\d');
            var d = sa.match(i)[0];
            if (!(t.length > d.length)) {
              var l = new RegExp('^' + i + '$'),
                u = t.replace(/\d/g, '9');
              l.test(u) && (d = u);
              var s,
                c = this.getFormatFormat(n, r);
              if (
                this.shouldTryNationalPrefixFormattingRule(n, {
                  international: r,
                  nationalPrefix: o,
                })
              ) {
                var f = c.replace(Eo, n.nationalPrefixFormattingRule());
                if (
                  fo(n.nationalPrefixFormattingRule()) ===
                    (o || '') + fo('$1') &&
                  ((c = f), (s = !0), o)
                )
                  for (var m = o.length; m > 0; )
                    (c = c.replace(/\d/, 'x')), m--;
              }
              var p = d
                .replace(new RegExp(i), c)
                .replace(new RegExp('9', 'g'), 'x');
              return (
                s ||
                  (a
                    ? (p = oa('x', a.length) + ' ' + p)
                    : o &&
                      (p =
                        oa('x', o.length) +
                        this.getSeparatorAfterNationalPrefix(n) +
                        p)),
                r && (p = wo(p)),
                p
              );
            }
          },
        },
        {
          key: 'formatNextNationalNumberDigits',
          value: function (n) {
            var e = (function (n, e, t) {
              var r = t.split(''),
                o = Array.isArray(r),
                a = 0;
              for (r = o ? r : r[Symbol.iterator](); ; ) {
                var i;
                if (o) {
                  if (a >= r.length) break;
                  i = r[a++];
                } else {
                  if ((a = r.next()).done) break;
                  i = a.value;
                }
                var d = i;
                if (n.slice(e + 1).search(ra) < 0) return;
                (e = n.search(ra)), (n = n.replace(ra, d));
              }
              return [n, e];
            })(
              this.populatedNationalNumberTemplate,
              this.populatedNationalNumberTemplatePosition,
              n,
            );
            if (e)
              return (
                (this.populatedNationalNumberTemplate = e[0]),
                (this.populatedNationalNumberTemplatePosition = e[1]),
                aa(
                  this.populatedNationalNumberTemplate,
                  this.populatedNationalNumberTemplatePosition + 1,
                )
              );
            this.resetFormat();
          },
        },
      ]) && la(e.prototype, t),
      r && la(e, r),
      n
    );
  })();
function pa(n, e) {
  return (
    (function (n) {
      if (Array.isArray(n)) return n;
    })(n) ||
    (function (n, e) {
      var t = [],
        r = !0,
        o = !1,
        a = void 0;
      try {
        for (
          var i, d = n[Symbol.iterator]();
          !(r = (i = d.next()).done) && (t.push(i.value), !e || t.length !== e);
          r = !0
        );
      } catch (n) {
        (o = !0), (a = n);
      } finally {
        try {
          r || null == d.return || d.return();
        } finally {
          if (o) throw a;
        }
      }
      return t;
    })(n, e) ||
    (function () {
      throw new TypeError(
        'Invalid attempt to destructure non-iterable instance',
      );
    })()
  );
}
function $a(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      'value' in r && (r.writable = !0),
      Object.defineProperty(n, r.key, r);
  }
}
var ha = new RegExp('^' + ('[' + jr + '0-9０-９٠-٩۰-۹]+') + '$', 'i'),
  ga = '(?:[+＋][' + jr + '0-9０-９٠-٩۰-۹]*|[' + jr + '0-9０-９٠-٩۰-۹]+)',
  ya = new RegExp('[^' + jr + '0-9０-９٠-٩۰-۹]+.*$'),
  ba = /[^\d\[\]]/,
  va = (function () {
    function n(e) {
      var t = e.defaultCountry,
        r = e.defaultCallingCode,
        o = e.metadata,
        a = e.onNationalSignificantNumberChange;
      !(function (n, e) {
        if (!(n instanceof e))
          throw new TypeError('Cannot call a class as a function');
      })(this, n),
        (this.defaultCountry = t),
        (this.defaultCallingCode = r),
        (this.metadata = o),
        (this.onNationalSignificantNumberChange = a);
    }
    var e, t, r;
    return (
      (e = n),
      (t = [
        {
          key: 'input',
          value: function (n, e) {
            var t,
              r = (function (n) {
                var e = pa(
                    (function (n) {
                      var e =
                        (function (n) {
                          var e,
                            t = n.search(ga);
                          if (!(t < 0))
                            return (
                              '+' === (n = n.slice(t))[0] &&
                                ((e = !0), (n = n.slice('+'.length))),
                              (n = n.replace(ya, '')),
                              e && (n = '+' + n),
                              n
                            );
                        })(n) || '';
                      return '+' === e[0] ? [e.slice('+'.length), !0] : [e];
                    })(n),
                    2,
                  ),
                  t = e[0],
                  r = e[1];
                return ha.test(t) || (t = ''), [t, r];
              })(n),
              o = pa(r, 2),
              a = o[0],
              i = o[1],
              d = fo(a);
            return (
              i && (e.digits || (e.startInternationalNumber(), d || (t = !0))),
              d && this.inputDigits(d, e),
              { digits: d, justLeadingPlus: t }
            );
          },
        },
        {
          key: 'inputDigits',
          value: function (n, e) {
            var t = e.digits,
              r = t.length < 3 && t.length + n.length >= 3;
            if (
              (e.appendDigits(n),
              r && this.extractIddPrefix(e),
              this.isWaitingForCountryCallingCode(e))
            ) {
              if (!this.extractCountryCallingCode(e)) return;
            } else e.appendNationalSignificantNumberDigits(n);
            e.international ||
              this.hasExtractedNationalSignificantNumber ||
              this.extractNationalSignificantNumber(
                e.getNationalDigits(),
                e.update,
              );
          },
        },
        {
          key: 'isWaitingForCountryCallingCode',
          value: function (n) {
            var e = n.international,
              t = n.callingCode;
            return e && !t;
          },
        },
        {
          key: 'extractCountryCallingCode',
          value: function (n) {
            var e = Go(
                '+' + n.getDigitsWithoutInternationalPrefix(),
                this.defaultCountry,
                this.defaultCallingCode,
                this.metadata.metadata,
              ),
              t = e.countryCallingCode,
              r = e.number;
            if (t)
              return (
                n.setCallingCode(t),
                n.update({ nationalSignificantNumber: r }),
                !0
              );
          },
        },
        {
          key: 'reset',
          value: function (n) {
            if (n) {
              this.hasSelectedNumberingPlan = !0;
              var e = n._nationalPrefixForParsing();
              this.couldPossiblyExtractAnotherNationalSignificantNumber =
                e && ba.test(e);
            } else
              (this.hasSelectedNumberingPlan = void 0),
                (this.couldPossiblyExtractAnotherNationalSignificantNumber =
                  void 0);
          },
        },
        {
          key: 'extractNationalSignificantNumber',
          value: function (n, e) {
            if (this.hasSelectedNumberingPlan) {
              var t = Lo(n, this.metadata),
                r = t.nationalPrefix,
                o = t.nationalNumber,
                a = t.carrierCode;
              if (o !== n)
                return this.onExtractedNationalNumber(r, a, o, n, e), !0;
            }
          },
        },
        {
          key: 'extractAnotherNationalSignificantNumber',
          value: function (n, e, t) {
            if (!this.hasExtractedNationalSignificantNumber)
              return this.extractNationalSignificantNumber(n, t);
            if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
              var r = Lo(n, this.metadata),
                o = r.nationalPrefix,
                a = r.nationalNumber,
                i = r.carrierCode;
              if (a !== e)
                return this.onExtractedNationalNumber(o, i, a, n, t), !0;
            }
          },
        },
        {
          key: 'onExtractedNationalNumber',
          value: function (n, e, t, r, o) {
            var a,
              i,
              d = r.lastIndexOf(t);
            if (d >= 0 && d === r.length - t.length) {
              i = !0;
              var l = r.slice(0, d);
              l !== n && (a = l);
            }
            o({
              nationalPrefix: n,
              carrierCode: e,
              nationalSignificantNumber: t,
              nationalSignificantNumberMatchesInput: i,
              complexPrefixBeforeNationalSignificantNumber: a,
            }),
              (this.hasExtractedNationalSignificantNumber = !0),
              this.onNationalSignificantNumberChange();
          },
        },
        {
          key: 'reExtractNationalSignificantNumber',
          value: function (n) {
            return (
              !!this.extractAnotherNationalSignificantNumber(
                n.getNationalDigits(),
                n.nationalSignificantNumber,
                n.update,
              ) ||
              (this.extractIddPrefix(n) || this.fixMissingPlus(n)
                ? (this.extractCallingCodeAndNationalSignificantNumber(n), !0)
                : void 0)
            );
          },
        },
        {
          key: 'extractIddPrefix',
          value: function (n) {
            var e = n.international,
              t = n.IDDPrefix,
              r = n.digits;
            if ((n.nationalSignificantNumber, !e && !t)) {
              var o = Do(
                r,
                this.defaultCountry,
                this.defaultCallingCode,
                this.metadata.metadata,
              );
              return void 0 !== o && o !== r
                ? (n.update({ IDDPrefix: r.slice(0, r.length - o.length) }),
                  this.startInternationalNumber(n),
                  !0)
                : void 0;
            }
          },
        },
        {
          key: 'fixMissingPlus',
          value: function (n) {
            if (!n.international) {
              var e = zo(
                  n.digits,
                  this.defaultCountry,
                  this.defaultCallingCode,
                  this.metadata.metadata,
                ),
                t = e.countryCallingCode;
              if ((e.number, t))
                return (
                  n.update({ missingPlus: !0 }),
                  this.startInternationalNumber(n),
                  !0
                );
            }
          },
        },
        {
          key: 'startInternationalNumber',
          value: function (n) {
            n.startInternationalNumber(),
              n.nationalSignificantNumber &&
                (n.resetNationalSignificantNumber(),
                this.onNationalSignificantNumberChange(),
                (this.hasExtractedNationalSignificantNumber = void 0));
          },
        },
        {
          key: 'extractCallingCodeAndNationalSignificantNumber',
          value: function (n) {
            this.extractCountryCallingCode(n) &&
              this.extractNationalSignificantNumber(
                n.getNationalDigits(),
                n.update,
              );
          },
        },
      ]) && $a(e.prototype, t),
      r && $a(e, r),
      n
    );
  })();
function xa(n) {
  return (xa =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (n) {
          return typeof n;
        }
      : function (n) {
          return n &&
            'function' == typeof Symbol &&
            n.constructor === Symbol &&
            n !== Symbol.prototype
            ? 'symbol'
            : typeof n;
        })(n);
}
function Ca(n, e) {
  return (
    (function (n) {
      if (Array.isArray(n)) return n;
    })(n) ||
    (function (n, e) {
      var t = [],
        r = !0,
        o = !1,
        a = void 0;
      try {
        for (
          var i, d = n[Symbol.iterator]();
          !(r = (i = d.next()).done) && (t.push(i.value), !e || t.length !== e);
          r = !0
        );
      } catch (n) {
        (o = !0), (a = n);
      } finally {
        try {
          r || null == d.return || d.return();
        } finally {
          if (o) throw a;
        }
      }
      return t;
    })(n, e) ||
    (function () {
      throw new TypeError(
        'Invalid attempt to destructure non-iterable instance',
      );
    })()
  );
}
function wa(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      'value' in r && (r.writable = !0),
      Object.defineProperty(n, r.key, r);
  }
}
var Ea = (function () {
  function n(e, t) {
    !(function (n, e) {
      if (!(n instanceof e))
        throw new TypeError('Cannot call a class as a function');
    })(this, n),
      (this.metadata = new qr(t));
    var r = Ca(this.getCountryAndCallingCode(e), 2),
      o = r[0],
      a = r[1];
    (this.defaultCountry = o), (this.defaultCallingCode = a), this.reset();
  }
  var e, t, r;
  return (
    (e = n),
    (t = [
      {
        key: 'getCountryAndCallingCode',
        value: function (n) {
          var e, t;
          return (
            n &&
              ('object' === xa(n)
                ? ((e = n.defaultCountry), (t = n.defaultCallingCode))
                : (e = n)),
            e && !this.metadata.hasCountry(e) && (e = void 0),
            [e, t]
          );
        },
      },
      {
        key: 'input',
        value: function (n) {
          var e = this.parser.input(n, this.state),
            t = e.digits;
          if (e.justLeadingPlus) this.formattedOutput = '+';
          else if (t) {
            var r;
            if (
              (this.determineTheCountryIfNeeded(),
              this.state.nationalSignificantNumber &&
                this.formatter.narrowDownMatchingFormats(this.state),
              this.metadata.hasSelectedNumberingPlan() &&
                (r = this.formatter.format(t, this.state)),
              void 0 === r &&
                this.parser.reExtractNationalSignificantNumber(this.state))
            ) {
              this.determineTheCountryIfNeeded();
              var o = this.state.getNationalDigits();
              o && (r = this.formatter.format(o, this.state));
            }
            this.formattedOutput = r
              ? this.getFullNumber(r)
              : this.getNonFormattedNumber();
          }
          return this.formattedOutput;
        },
      },
      {
        key: 'reset',
        value: function () {
          var n = this;
          return (
            (this.state = new ta({
              onCountryChange: function (e) {
                n.country = e;
              },
              onCallingCodeChange: function (e, t) {
                n.metadata.selectNumberingPlan(e, t),
                  n.formatter.reset(n.metadata.numberingPlan, n.state),
                  n.parser.reset(n.metadata.numberingPlan);
              },
            })),
            (this.formatter = new ma({
              state: this.state,
              metadata: this.metadata,
            })),
            (this.parser = new va({
              defaultCountry: this.defaultCountry,
              defaultCallingCode: this.defaultCallingCode,
              metadata: this.metadata,
              state: this.state,
              onNationalSignificantNumberChange: function () {
                n.determineTheCountryIfNeeded(),
                  n.formatter.reset(n.metadata.numberingPlan, n.state);
              },
            })),
            this.state.reset(this.defaultCountry, this.defaultCallingCode),
            (this.formattedOutput = ''),
            this
          );
        },
      },
      {
        key: 'isInternational',
        value: function () {
          return this.state.international;
        },
      },
      {
        key: 'getCallingCode',
        value: function () {
          return this.state.callingCode;
        },
      },
      {
        key: 'getCountryCallingCode',
        value: function () {
          return this.getCallingCode();
        },
      },
      {
        key: 'getCountry',
        value: function () {
          var n = this.state,
            e = n.digits,
            t = n.country;
          if (e) return t;
        },
      },
      {
        key: 'determineTheCountryIfNeeded',
        value: function () {
          (this.state.country && !this.isCountryCallingCodeAmbiguous()) ||
            this.determineTheCountry();
        },
      },
      {
        key: 'getFullNumber',
        value: function (n) {
          var e = this;
          if (this.isInternational()) {
            var t = function (n) {
                return (
                  e.formatter.getInternationalPrefixBeforeCountryCallingCode(
                    e.state,
                    { spacing: !!n },
                  ) + n
                );
              },
              r = this.state.callingCode;
            return t(
              r
                ? n
                  ? ''.concat(r, ' ').concat(n)
                  : r
                : ''.concat(this.state.getDigitsWithoutInternationalPrefix()),
            );
          }
          return n;
        },
      },
      {
        key: 'getNonFormattedNationalNumberWithPrefix',
        value: function () {
          var n = this.state,
            e = n.nationalSignificantNumber,
            t = n.complexPrefixBeforeNationalSignificantNumber,
            r = n.nationalPrefix,
            o = e,
            a = t || r;
          return a && (o = a + o), o;
        },
      },
      {
        key: 'getNonFormattedNumber',
        value: function () {
          var n = this.state.nationalSignificantNumberMatchesInput;
          return this.getFullNumber(
            n
              ? this.getNonFormattedNationalNumberWithPrefix()
              : this.state.getNationalDigits(),
          );
        },
      },
      {
        key: 'getNonFormattedTemplate',
        value: function () {
          var n = this.getNonFormattedNumber();
          if (n) return n.replace(/[\+\d]/g, 'x');
        },
      },
      {
        key: 'isCountryCallingCodeAmbiguous',
        value: function () {
          var n = this.state.callingCode,
            e = this.metadata.getCountryCodesForCallingCode(n);
          return e && e.length > 1;
        },
      },
      {
        key: 'determineTheCountry',
        value: function () {
          this.state.setCountry(
            _o(
              this.isInternational()
                ? this.state.callingCode
                : this.defaultCallingCode,
              this.state.nationalSignificantNumber,
              this.metadata,
            ),
          );
        },
      },
      {
        key: 'getNumber',
        value: function () {
          var n = this.state,
            e = n.nationalSignificantNumber,
            t = n.carrierCode;
          if (this.isInternational()) {
            if (!this.state.callingCode) return;
          } else if (!this.state.country && !this.defaultCallingCode) return;
          if (e) {
            var r = this.getCountry(),
              o = this.getCountryCallingCode() || this.defaultCallingCode,
              a = new Bo(r || o, e, this.metadata.metadata);
            return t && (a.carrierCode = t), a;
          }
        },
      },
      {
        key: 'isPossible',
        value: function () {
          var n = this.getNumber();
          return !!n && n.isPossible();
        },
      },
      {
        key: 'isValid',
        value: function () {
          var n = this.getNumber();
          return !!n && n.isValid();
        },
      },
      {
        key: 'getNationalNumber',
        value: function () {
          return this.state.nationalSignificantNumber;
        },
      },
      {
        key: 'getChars',
        value: function () {
          return (this.state.international ? '+' : '') + this.state.digits;
        },
      },
      {
        key: 'getTemplate',
        value: function () {
          return (
            this.formatter.getTemplate(this.state) ||
            this.getNonFormattedTemplate() ||
            ''
          );
        },
      },
    ]) && wa(e.prototype, t),
    r && wa(e, r),
    n
  );
})();
function Na(n) {
  return new qr(n).getCountries();
}
function Pa(n) {
  var e = n.country,
    t = n.international,
    r = n.withCountryCallingCode,
    o = n.metadata;
  return e && t && !r ? '+'.concat(no(e, o)) : '';
}
function Sa(n, e) {
  return e && ' ' === (n = n.slice(e.length))[0] && (n = n.slice(1)), n;
}
function Oa() {
  return (Oa =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function ka(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = (function (n, e) {
      if (null == n) return {};
      var t,
        r,
        o = {},
        a = Object.keys(n);
      for (r = 0; r < a.length; r++)
        (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
      return o;
    })(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (r = 0; r < a.length; r++)
      (t = a[r]),
        e.indexOf(t) >= 0 ||
          (Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]));
  }
  return o;
}
var Ia = (function (e) {
  function t(e, t) {
    var r = e.country,
      o = e.international,
      a = e.withCountryCallingCode,
      i = e.metadata,
      l = ka(e, [
        'country',
        'international',
        'withCountryCallingCode',
        'metadata',
      ]),
      u = d(
        function (n) {
          var e = new Ea(r, i),
            t = Pa({
              country: r,
              international: o,
              withCountryCallingCode: a,
              metadata: i,
            }),
            d = e.input(t + n),
            l = e.getTemplate();
          return (
            t && ((d = Sa(d, t)), l && (l = Sa(l, t))), { text: d, template: l }
          );
        },
        [r, i],
      );
    return n.createElement(Fr, Oa({}, l, { ref: t, parse: po, format: u }));
  }
  return (
    ((t = n.forwardRef(t)).propTypes = {
      country: je.string,
      international: je.bool,
      withCountryCallingCode: je.bool,
      metadata: je.object.isRequired,
    }),
    (t.defaultProps = { metadata: e }),
    t
  );
})();
function Ta() {
  return (Ta =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function Aa(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = (function (n, e) {
      if (null == n) return {};
      var t,
        r,
        o = {},
        a = Object.keys(n);
      for (r = 0; r < a.length; r++)
        (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
      return o;
    })(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (r = 0; r < a.length; r++)
      (t = a[r]),
        e.indexOf(t) >= 0 ||
          (Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]));
  }
  return o;
}
var Ra = (function (e) {
  function t(e, t) {
    var r = e.value,
      o = e.onChange,
      a = e.country,
      i = e.international,
      l = e.withCountryCallingCode,
      u = e.metadata,
      s = e.inputComponent,
      c = Aa(e, [
        'value',
        'onChange',
        'country',
        'international',
        'withCountryCallingCode',
        'metadata',
        'inputComponent',
      ]),
      f = Pa({
        country: a,
        international: i,
        withCountryCallingCode: l,
        metadata: u,
      }),
      m = d(
        function (n) {
          var e = mo(n.target.value);
          e === r &&
            0 === Ba(f, e, a, u).indexOf(n.target.value) &&
            (e = e.slice(0, -1));
          o(e);
        },
        [f, r, o, a, u],
      );
    return n.createElement(
      s,
      Ta({}, c, { ref: t, value: Ba(f, r, a, u), onChange: m }),
    );
  }
  return (
    ((t = n.forwardRef(t)).propTypes = {
      value: je.string.isRequired,
      onChange: je.func.isRequired,
      country: je.string,
      international: je.bool,
      withCountryCallingCode: je.bool,
      metadata: je.object.isRequired,
      inputComponent: je.elementType.isRequired,
    }),
    (t.defaultProps = { metadata: e, inputComponent: 'input' }),
    t
  );
})();
function Ba(n, e, t, r) {
  return Sa(
    (function (n, e, t) {
      return t || ((t = e), (e = void 0)), new Ea(e, t).input(n);
    })(n + e, t, r),
    n,
  );
}
function Ma() {
  return (Ma =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function Fa(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = (function (n, e) {
      if (null == n) return {};
      var t,
        r,
        o = {},
        a = Object.keys(n);
      for (r = 0; r < a.length; r++)
        (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
      return o;
    })(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (r = 0; r < a.length; r++)
      (t = a[r]),
        e.indexOf(t) >= 0 ||
          (Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]));
  }
  return o;
}
function Da(e) {
  var t = e.country,
    r = e.countryName,
    o = e.flags,
    a = e.flagUrl,
    i = Fa(e, ['country', 'countryName', 'flags', 'flagUrl']);
  return o && o[t]
    ? o[t]({ title: r })
    : n.createElement(
        'img',
        Ma({}, i, {
          alt: r,
          role: r ? void 0 : 'presentation',
          src: a.replace('{XX}', t).replace('{xx}', t.toLowerCase()),
        }),
      );
}
function La() {
  return (La =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function ja(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = (function (n, e) {
      if (null == n) return {};
      var t,
        r,
        o = {},
        a = Object.keys(n);
      for (r = 0; r < a.length; r++)
        (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
      return o;
    })(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (r = 0; r < a.length; r++)
      (t = a[r]),
        e.indexOf(t) >= 0 ||
          (Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]));
  }
  return o;
}
function za(e) {
  var t = e.aspectRatio,
    r = ja(e, ['aspectRatio']);
  return 1 === t ? n.createElement(_a, r) : n.createElement(Ga, r);
}
function Ga(e) {
  var t = e.title,
    r = ja(e, ['title']);
  return n.createElement(
    'svg',
    La({}, r, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 75 50' }),
    n.createElement('title', null, t),
    n.createElement(
      'g',
      {
        className: 'PhoneInputInternationalIconGlobe',
        stroke: 'currentColor',
        fill: 'none',
        strokeWidth: '2',
        strokeMiterlimit: '10',
      },
      n.createElement('path', {
        strokeLinecap: 'round',
        d: 'M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3',
      }),
      n.createElement('path', {
        d: 'M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3',
      }),
      n.createElement('line', { x1: '26', y1: '25', x2: '74', y2: '25' }),
      n.createElement('line', { x1: '50', y1: '1', x2: '50', y2: '49' }),
      n.createElement('path', {
        strokeLinecap: 'round',
        d: 'M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8',
      }),
      n.createElement('path', {
        strokeLinecap: 'round',
        d: 'M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2',
      }),
    ),
    n.createElement('path', {
      className: 'PhoneInputInternationalIconPhone',
      stroke: 'none',
      fill: 'currentColor',
      d: 'M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z',
    }),
  );
}
function _a(e) {
  var t = e.title,
    r = ja(e, ['title']);
  return n.createElement(
    'svg',
    La({}, r, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50' }),
    n.createElement('title', null, t),
    n.createElement(
      'g',
      {
        className: 'PhoneInputInternationalIconGlobe',
        stroke: 'currentColor',
        fill: 'none',
        strokeWidth: '2',
        strokeLinecap: 'round',
      },
      n.createElement('path', { d: 'M8.45,13A21.44,21.44,0,1,1,37.08,41.56' }),
      n.createElement('path', {
        d: 'M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21',
      }),
      n.createElement('path', {
        d: 'M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86',
      }),
      n.createElement('path', {
        d: 'M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54',
      }),
      n.createElement('line', {
        x1: '27.8',
        y1: '0.85',
        x2: '27.8',
        y2: '34.61',
      }),
      n.createElement('line', {
        x1: '15.2',
        y1: '22.23',
        x2: '49.15',
        y2: '22.23',
      }),
    ),
    n.createElement('path', {
      className: 'PhoneInputInternationalIconPhone',
      stroke: 'transparent',
      fill: 'currentColor',
      d: 'M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z',
    }),
  );
}
function Va(n, e) {
  return !!eo(n, e) || (console.error('Country not found: '.concat(n)), !1);
}
function Ha(n, e) {
  return (
    n &&
      0 ===
        (n = n.filter(function (n) {
          return Va(n, e);
        })).length &&
      (n = void 0),
    n
  );
}
function Ua(e) {
  var t = e.flags,
    r = e.flagUrl,
    o = e.flagComponent,
    a = e.internationalIcon;
  function i(e) {
    var i = e.country,
      d = e.label,
      l = e.aspectRatio,
      u = a === za ? l : void 0;
    return n.createElement(
      'div',
      {
        className: wr('PhoneInputCountryIcon', {
          'PhoneInputCountryIcon--square': 1 === u,
          'PhoneInputCountryIcon--border': i,
        }),
      },
      i
        ? n.createElement(o, {
            country: i,
            countryName: d,
            flags: t,
            flagUrl: r,
            className: 'PhoneInputCountryIconImg',
          })
        : n.createElement(a, {
            title: d,
            aspectRatio: u,
            className: 'PhoneInputCountryIconImg',
          }),
    );
  }
  return (
    (i.propTypes = {
      country: je.string,
      label: je.string.isRequired,
      aspectRatio: je.number,
    }),
    i
  );
}
(Da.propTypes = {
  country: je.string.isRequired,
  countryName: je.string.isRequired,
  flags: je.objectOf(je.elementType),
  flagUrl: je.string.isRequired,
}),
  (za.propTypes = { title: je.string.isRequired, aspectRatio: je.number }),
  (Ga.propTypes = { title: je.string.isRequired }),
  (_a.propTypes = { title: je.string.isRequired }),
  Ua({
    flagUrl:
      'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    flagComponent: Da,
    internationalIcon: za,
  });
var qa = je.shape({
    country_calling_codes: je.object.isRequired,
    countries: je.object.isRequired,
  }),
  Wa = je.objectOf(je.string),
  Ka = /^\d+$/;
function Ya(n, e) {
  var t = '+' + no(n, e);
  return (
    (e = new qr(e)).country(n),
    e.numberingPlan.leadingDigits() &&
      Ka.test(e.numberingPlan.leadingDigits()) &&
      (t += e.numberingPlan.leadingDigits()),
    t
  );
}
function Za(n) {
  var e = n.phoneNumber,
    t = n.defaultCountry,
    r = n.countries,
    o = n.required;
  n.metadata;
  var a = t;
  return (
    e && e.country && (a = e.country),
    r && r.indexOf(a) < 0 && (a = void 0),
    !a && o && r && r.length > 0 && (a = r[0]),
    a
  );
}
function Ja(n, e) {
  return (function () {
    var n = Jo(arguments),
      e = n.text,
      t = n.options,
      r = n.metadata;
    return na(e, t, r);
  })(n || '', e);
}
function Xa(n, e) {
  var t = e.prevCountry,
    r = e.newCountry,
    o = e.metadata,
    a = e.useNationalFormat;
  if (!n) return a ? '' : Ya(r, o);
  if (r) {
    if ('+' === n[0]) {
      if (a)
        return 0 === n.indexOf('+' + no(r, o))
          ? (function (n, e, t) {
              if (e) {
                var r = '+' + no(e, t);
                if (n.length < r.length) {
                  if (0 === r.indexOf(n)) return '';
                } else if (0 === n.indexOf(r)) return n.slice(r.length);
              }
              for (
                var o = 0, a = Object.keys(t.country_calling_codes);
                o < a.length;
                o++
              ) {
                var i = a[o];
                if (n.indexOf(i) === '+'.length)
                  return n.slice('+'.length + i.length);
              }
              return '';
            })(n, r, o)
          : '';
      if (t) {
        var i = Ya(r, o);
        return 0 === n.indexOf(i) ? n : i;
      }
      var d = Ya(r, o);
      return 0 === n.indexOf(d) ? n : d;
    }
  } else if ('+' !== n[0]) return Qa(n, t, o) || '';
  return n;
}
function Qa(n, e, t) {
  if (n) {
    if ('+' === n[0]) {
      if ('+' === n) return;
      return n;
    }
    if (e) {
      var r = oi(n, e, t);
      return r ? '+'.concat(no(e, t)).concat(r) : void 0;
    }
  }
}
function ni(n, e, t) {
  var r = oi(n, e, t);
  if (r) {
    var o =
      r.length -
      (function (n, e) {
        return (
          (e = new qr(e)).country(n),
          e.numberingPlan.possibleLengths()[
            e.numberingPlan.possibleLengths().length - 1
          ]
        );
      })(e, t);
    if (o > 0) return n.slice(0, n.length - o);
  }
  return n;
}
function ei(n, e) {
  var t = e.country,
    r = e.countries,
    o = e.required,
    a = e.metadata;
  if ('+' === n) return t;
  var i = (function (n, e) {
    var t = new Ea(null, e);
    return t.input(n), t.getCountry();
  })(n, a);
  return i && (!r || r.indexOf(i) >= 0)
    ? i
    : !t ||
      o ||
      (function (n, e, t) {
        var r = Ya(e, t),
          o = 0;
        for (; o < n.length && o < r.length; ) {
          if (n[o] !== r[o]) return !1;
          o++;
        }
        return !0;
      })(n, t, a)
    ? t
    : void 0;
}
function ti(n, e, t) {
  if (0 === n.indexOf(Ya(e, t))) {
    var r = new Ea(e, t);
    r.input(n);
    var o = r.getNumber();
    return o ? o.formatNational().replace(/\D/g, '') : '';
  }
  return n.replace(/\D/g, '');
}
function ri(n, e, t) {
  return String.prototype.localeCompare
    ? n.localeCompare(e, t)
    : n < e
    ? -1
    : n > e
    ? 1
    : 0;
}
function oi(n, e, t) {
  var r = new Ea(e, t);
  r.input(n);
  var o = r.getNumber();
  return o && o.nationalNumber;
}
function ai(n) {
  var e = n.value,
    t = n.phoneNumber,
    r = n.defaultCountry,
    o = n.international,
    a = n.useNationalFormat,
    i = n.metadata;
  return (!1 === o || a) && t && t.country
    ? (function (n) {
        return n.formatNational().replace(/\D/g, '');
      })(t)
    : !e && o && r
    ? Ya(r, i)
    : e;
}
function ii(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e &&
      (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function di(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = null != arguments[e] ? arguments[e] : {};
    e % 2
      ? ii(Object(t), !0).forEach(function (e) {
          li(n, e, t[e]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t))
      : ii(Object(t)).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
        });
  }
  return n;
}
function li(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
function ui(n) {
  return (ui =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (n) {
          return typeof n;
        }
      : function (n) {
          return n &&
            'function' == typeof Symbol &&
            n.constructor === Symbol &&
            n !== Symbol.prototype
            ? 'symbol'
            : typeof n;
        })(n);
}
function si(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e &&
      (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function ci() {
  return (ci =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function fi(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = (function (n, e) {
      if (null == n) return {};
      var t,
        r,
        o = {},
        a = Object.keys(n);
      for (r = 0; r < a.length; r++)
        (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
      return o;
    })(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (r = 0; r < a.length; r++)
      (t = a[r]),
        e.indexOf(t) >= 0 ||
          (Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]));
  }
  return o;
}
function mi(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      'value' in r && (r.writable = !0),
      Object.defineProperty(n, r.key, r);
  }
}
function pi(n) {
  return (pi = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
}
function $i(n) {
  if (void 0 === n)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called",
    );
  return n;
}
function hi(n, e) {
  return (hi =
    Object.setPrototypeOf ||
    function (n, e) {
      return (n.__proto__ = e), n;
    })(n, e);
}
function gi(n, e, t) {
  return (
    e in n
      ? Object.defineProperty(n, e, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (n[e] = t),
    n
  );
}
var yi,
  bi,
  vi = (function (e) {
    function t(e) {
      var r, o, a;
      !(function (n, e) {
        if (!(n instanceof e))
          throw new TypeError('Cannot call a class as a function');
      })(this, t),
        (o = this),
        (a = pi(t).call(this, e)),
        (r = !a || ('object' !== ui(a) && 'function' != typeof a) ? $i(o) : a),
        gi($i(r), 'inputRef', n.createRef()),
        gi($i(r), 'setInputRef', function (n) {
          r.inputRef.current = n;
          var e = r.props.inputRef;
          e && ('function' == typeof e ? e(n) : (e.current = n));
        }),
        gi($i(r), 'isCountrySupportedWithError', function (n) {
          return Va(n, r.props.metadata);
        }),
        gi($i(r), 'onCountryChange', function (n) {
          var e = r.props,
            t = e.international,
            o = e.metadata,
            a = e.onChange,
            i = e.focusInputOnCountrySelection,
            d = r.state,
            l = Xa(d.phoneDigits, {
              prevCountry: d.country,
              newCountry: n,
              metadata: o,
              useNationalFormat: !t,
            }),
            u = Qa(l, n, o);
          i && r.inputRef.current.focus(),
            r.setState(
              {
                country: n,
                hasUserSelectedACountry: !0,
                phoneDigits: l,
                value: u,
              },
              function () {
                a(u);
              },
            );
        }),
        gi($i(r), 'onChange', function (n) {
          var e = r.props,
            t = e.defaultCountry,
            o = e.onChange;
          e.addInternationalOption;
          var a = e.international,
            i = e.limitMaxLength,
            d = e.countryCallingCodeEditable,
            l = e.metadata,
            u = r.state,
            s = u.countries,
            c = (function (n, e) {
              var t,
                r = e.prevPhoneDigits,
                o = e.country,
                a = e.defaultCountry,
                i = e.countries,
                d = e.international,
                l = e.limitMaxLength,
                u = e.countryCallingCodeEditable,
                s = e.metadata;
              if (d && !1 === u) {
                var c = Ya(o, s);
                if (0 !== n.indexOf(c))
                  return {
                    phoneDigits: (n = n && '+' !== n[0] ? c + n : c),
                    value: void 0,
                    country: o,
                  };
              }
              return (
                !1 === d && o && n && '+' === n[0] && (n = ti(n, o, s)),
                n && o && l && (n = ni(n, o, s)),
                !n || '+' === n[0] || (o && !d) || (n = '+' + n),
                !n && r && '+' === r[0] && (o = d ? void 0 : a),
                '+' === n &&
                  r &&
                  '+' === r[0] &&
                  r.length > '+'.length &&
                  (o = void 0),
                n &&
                  (t =
                    '+' === n[0]
                      ? '+' === n || (o && 0 === Ya(o, s).indexOf(n))
                        ? void 0
                        : n
                      : Qa(n, o, s)),
                t &&
                  ((o = ei(t, { country: o, countries: i, metadata: s })),
                  !1 === d &&
                    o &&
                    n &&
                    '+' === n[0] &&
                    (t = Qa((n = ti(n, o, s)), o, s))),
                { phoneDigits: n, country: o, value: t }
              );
            })(n, {
              prevPhoneDigits: u.phoneDigits,
              country: u.country,
              defaultCountry: t,
              countries: s,
              international: a,
              limitMaxLength: i,
              countryCallingCodeEditable: d,
              metadata: l,
            }),
            f = c.phoneDigits,
            m = c.country,
            p = c.value,
            $ = { phoneDigits: f, value: p, country: m };
          !1 === d &&
            (p || f !== r.state.phoneDigits || ($.forceRerender = {})),
            r.setState($, function () {
              return o(p);
            });
        }),
        gi($i(r), '_onFocus', function () {
          return r.setState({ isFocused: !0 });
        }),
        gi($i(r), '_onBlur', function () {
          return r.setState({ isFocused: !1 });
        }),
        gi($i(r), 'onFocus', function (n) {
          r._onFocus();
          var e = r.props.onFocus;
          e && e(n);
        }),
        gi($i(r), 'onBlur', function (n) {
          var e = r.props.onBlur;
          r._onBlur(), e && e(n);
        }),
        gi($i(r), 'onCountryFocus', function (n) {
          r._onFocus();
          var e = r.props.countrySelectProps;
          if (e) {
            var t = e.onFocus;
            t && t(n);
          }
        }),
        gi($i(r), 'onCountryBlur', function (n) {
          r._onBlur();
          var e = r.props.countrySelectProps;
          if (e) {
            var t = e.onBlur;
            t && t(n);
          }
        });
      var i = r.props,
        d = i.value;
      i.labels;
      var l = i.international,
        u = i.addInternationalOption,
        s = i.displayInitialValueAsLocalNumber,
        c = i.initialValueFormat,
        f = i.metadata,
        m = r.props,
        p = m.defaultCountry,
        $ = m.countries;
      p && (r.isCountrySupportedWithError(p) || (p = void 0)), ($ = Ha($, f));
      var h = Ja(d, f);
      return (
        (r.CountryIcon = Ua(r.props)),
        (r.state = {
          props: r.props,
          country: Za({
            phoneNumber: h,
            defaultCountry: p,
            countries: $ || Na(f),
            required: !u,
            metadata: f,
          }),
          countries: $,
          phoneDigits: ai({
            value: d,
            phoneNumber: h,
            defaultCountry: p,
            international: l,
            useNationalFormat: s || 'national' === c,
            metadata: f,
          }),
          value: d,
        }),
        r
      );
    }
    var r, o, a;
    return (
      (function (n, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError(
            'Super expression must either be null or a function',
          );
        (n.prototype = Object.create(e && e.prototype, {
          constructor: { value: n, writable: !0, configurable: !0 },
        })),
          e && hi(n, e);
      })(t, n.PureComponent),
      (r = t),
      (a = [
        {
          key: 'getDerivedStateFromProps',
          value: function (n, e) {
            return (function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = null != arguments[e] ? arguments[e] : {};
                e % 2
                  ? si(Object(t), !0).forEach(function (e) {
                      gi(n, e, t[e]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      n,
                      Object.getOwnPropertyDescriptors(t),
                    )
                  : si(Object(t)).forEach(function (e) {
                      Object.defineProperty(
                        n,
                        e,
                        Object.getOwnPropertyDescriptor(t, e),
                      );
                    });
              }
              return n;
            })(
              { props: n },
              (function (n, e, t) {
                var r = n.metadata,
                  o = n.countries,
                  a = n.defaultCountry,
                  i = n.value,
                  d = n.reset,
                  l = n.international,
                  u = n.displayInitialValueAsLocalNumber,
                  s = n.initialValueFormat,
                  c = e.defaultCountry,
                  f = e.value,
                  m = e.reset;
                t.country;
                var p = t.value,
                  $ = t.hasUserSelectedACountry,
                  h = function (n) {
                    return ai(
                      di({}, n, {
                        international: l,
                        useNationalFormat: u || 'national' === s,
                        metadata: r,
                      }),
                    );
                  };
                if (d !== m)
                  return {
                    phoneDigits: h({ value: void 0, defaultCountry: a }),
                    value: void 0,
                    country: a,
                    hasUserSelectedACountry: void 0,
                  };
                if (a !== c) {
                  var g = !a || Va(a, r),
                    y =
                      !p ||
                      (l && p === h({ value: void 0, defaultCountry: c }));
                  if (!$ && g && !i && y)
                    return {
                      country: a,
                      phoneDigits: h({ value: void 0, defaultCountry: a }),
                      value: void 0,
                    };
                }
                if (i !== f && i !== p) {
                  var b, v, x;
                  if (i) {
                    b = Ja(i, r);
                    var C = Ha(o, r);
                    b && b.country
                      ? (!C || C.indexOf(b.country) >= 0) && (v = b.country)
                      : (v = ei(i, {
                          country: void 0,
                          countries: C,
                          metadata: r,
                        }));
                  }
                  return (
                    i || (x = { hasUserSelectedACountry: void 0 }),
                    di({}, x, {
                      phoneDigits: h({
                        phoneNumber: b,
                        value: i,
                        defaultCountry: a,
                      }),
                      value: i,
                      country: i ? v : a,
                    })
                  );
                }
              })(n, e.props, e),
            );
          },
        },
      ]),
      (o = [
        {
          key: 'componentDidMount',
          value: function () {
            var n = this.props.onCountryChange,
              e = this.props.defaultCountry,
              t = this.state.country;
            n &&
              (e && (this.isCountrySupportedWithError(e) || (e = void 0)),
              t !== e && n(t));
          },
        },
        {
          key: 'componentDidUpdate',
          value: function (n, e) {
            var t = this.props.onCountryChange,
              r = this.state.country;
            t && r !== e.country && t(r);
          },
        },
        {
          key: 'render',
          value: function () {
            var e = this.props,
              t = e.name,
              r = e.disabled,
              o = e.autoComplete,
              a = e.style,
              i = e.className;
            e.inputRef;
            var d = e.inputComponent,
              l = e.numberInputProps,
              u = e.smartCaret,
              s = e.countrySelectComponent,
              c = e.countrySelectProps,
              f = e.containerComponent;
            e.defaultCountry;
            var m = e.countries,
              p = e.countryOptionsOrder,
              $ = e.labels;
            e.flags, e.flagComponent, e.flagUrl;
            var h = e.addInternationalOption;
            e.internationalIcon,
              e.displayInitialValueAsLocalNumber,
              e.initialValueFormat,
              e.onCountryChange,
              e.limitMaxLength;
            var g = e.countryCallingCodeEditable;
            e.focusInputOnCountrySelection, e.reset;
            var y,
              b,
              v = e.metadata,
              x = e.international,
              C = e.locales,
              w = fi(e, [
                'name',
                'disabled',
                'autoComplete',
                'style',
                'className',
                'inputRef',
                'inputComponent',
                'numberInputProps',
                'smartCaret',
                'countrySelectComponent',
                'countrySelectProps',
                'containerComponent',
                'defaultCountry',
                'countries',
                'countryOptionsOrder',
                'labels',
                'flags',
                'flagComponent',
                'flagUrl',
                'addInternationalOption',
                'internationalIcon',
                'displayInitialValueAsLocalNumber',
                'initialValueFormat',
                'onCountryChange',
                'limitMaxLength',
                'countryCallingCodeEditable',
                'focusInputOnCountrySelection',
                'reset',
                'metadata',
                'international',
                'locales',
              ]),
              E = this.state,
              N = E.country,
              P = E.phoneDigits,
              S = E.isFocused,
              O = u ? Ia : Ra,
              k =
                ((y = function () {
                  return (function (n, e) {
                    if (!e) return n;
                    var t = [],
                      r = [],
                      o = t,
                      a = e,
                      i = Array.isArray(a),
                      d = 0;
                    for (a = i ? a : a[Symbol.iterator](); ; ) {
                      var l;
                      if (i) {
                        if (d >= a.length) break;
                        l = a[d++];
                      } else {
                        if ((d = a.next()).done) break;
                        l = d.value;
                      }
                      var u = l;
                      '|' === u
                        ? o.push({ divider: !0 })
                        : '...' === u || '…' === u
                        ? (o = r)
                        : (function () {
                            var e = void 0;
                            e = '🌐' === u ? void 0 : u;
                            var t = n.indexOf(
                                n.filter(function (n) {
                                  return n.value === e;
                                })[0],
                              ),
                              r = n[t];
                            n.splice(t, 1), o.push(r);
                          })();
                    }
                    return t.concat(n).concat(r);
                  })(
                    (function (n) {
                      var e = n.countries,
                        t = n.countryNames,
                        r = n.addInternationalOption,
                        o = n.compareStringsLocales,
                        a = n.compareStrings;
                      a || (a = ri);
                      var i = e.map(function (n) {
                        return { value: n, label: t[n] || n };
                      });
                      return (
                        i.sort(function (n, e) {
                          return a(n.label, e.label, o);
                        }),
                        r && i.unshift({ label: t.ZZ }),
                        i
                      );
                    })({
                      countries: m || Na(v),
                      countryNames: $,
                      addInternationalOption: (!x || !1 !== g) && h,
                      compareStringsLocales: C,
                    }),
                    (function (n, e) {
                      if (
                        n &&
                        (n = n.filter(function (n) {
                          switch (n) {
                            case '🌐':
                            case '|':
                            case '...':
                            case '…':
                              return !0;
                            default:
                              return Va(n, e);
                          }
                        })).length > 0
                      )
                        return n;
                    })(p, v),
                  );
                }),
                (b = [m, p, h, $, v]),
                (bi &&
                  (function (n, e) {
                    if (n.length !== e.length) return !1;
                    for (var t = 0; t < n.length; ) {
                      if (n[t] !== e[t]) return !1;
                      t++;
                    }
                    return !0;
                  })(b, bi)) ||
                  ((yi = y()), (bi = b)),
                yi);
            return n.createElement(
              f,
              {
                style: a,
                className: wr(i, 'PhoneInput', { 'PhoneInput--focus': S }),
              },
              n.createElement(
                s,
                ci(
                  {
                    name: t ? ''.concat(t, 'Country') : void 0,
                    'aria-label': $.country,
                  },
                  c,
                  {
                    value: N,
                    options: k,
                    onChange: this.onCountryChange,
                    onFocus: this.onCountryFocus,
                    onBlur: this.onCountryBlur,
                    disabled: r || (c && c.disabled),
                    iconComponent: this.CountryIcon,
                  },
                ),
              ),
              n.createElement(
                O,
                ci(
                  { ref: this.setInputRef, type: 'tel', autoComplete: o },
                  l,
                  w,
                  {
                    name: t,
                    metadata: v,
                    country: N,
                    value: P || '',
                    onChange: this.onChange,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    disabled: r,
                    inputComponent: d,
                    className: wr(
                      'PhoneInputInput',
                      l && l.className,
                      w.className,
                    ),
                  },
                ),
              ),
            );
          },
        },
      ]) && mi(r.prototype, o),
      a && mi(r, a),
      t
    );
  })(),
  xi = n.forwardRef(function (e, t) {
    return n.createElement(vi, ci({}, e, { inputRef: t }));
  });
(xi.propTypes = {
  value: je.string,
  onChange: je.func.isRequired,
  onFocus: je.func,
  onBlur: je.func,
  onKeyDown: je.func,
  disabled: je.bool,
  autoComplete: je.string.isRequired,
  initialValueFormat: je.oneOf(['national']),
  displayInitialValueAsLocalNumber: je.bool,
  defaultCountry: je.string,
  countries: je.arrayOf(je.string),
  labels: Wa.isRequired,
  locales: je.oneOfType([je.string, je.arrayOf(je.string)]),
  flagUrl: je.string.isRequired,
  flags: je.objectOf(je.elementType),
  flagComponent: je.elementType.isRequired,
  addInternationalOption: je.bool.isRequired,
  internationalIcon: je.elementType.isRequired,
  countryOptionsOrder: je.arrayOf(je.string),
  style: je.object,
  className: je.string,
  countrySelectComponent: je.elementType.isRequired,
  countrySelectProps: je.object,
  inputComponent: je.elementType.isRequired,
  containerComponent: je.elementType.isRequired,
  numberInputProps: je.object,
  smartCaret: je.bool.isRequired,
  international: je.bool,
  limitMaxLength: je.bool.isRequired,
  countryCallingCodeEditable: je.bool.isRequired,
  metadata: qa.isRequired,
  onCountryChange: je.func,
  focusInputOnCountrySelection: je.bool.isRequired,
}),
  (xi.defaultProps = {
    autoComplete: 'tel',
    flagComponent: Da,
    flagUrl:
      'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    internationalIcon: za,
    inputComponent: 'input',
    containerComponent: 'div',
    reset: je.any,
    smartCaret: !0,
    addInternationalOption: !0,
    limitMaxLength: !1,
    countryCallingCodeEditable: !0,
    focusInputOnCountrySelection: !0,
  });
var Ci = {
  ext: 'ext.',
  country: 'Phone number country',
  phone: 'Phone',
  AB: 'Abkhazia',
  AC: 'Ascension Island',
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AQ: 'Antarctica',
  AR: 'Argentina',
  AS: 'American Samoa',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Åland Islands',
  AZ: 'Azerbaijan',
  BA: 'Bosnia and Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CD: 'Congo, Democratic Republic of the',
  CF: 'Central African Republic',
  CG: 'Congo',
  CH: 'Switzerland',
  CI: "Cote d'Ivoire",
  CK: 'Cook Islands',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CW: 'Curaçao',
  CX: 'Christmas Island',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  EH: 'Western Sahara',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FM: 'Federated States of Micronesia',
  FO: 'Faroe Islands',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GS: 'South Georgia and the South Sandwich Islands',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard Island and McDonald Islands',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IM: 'Isle of Man',
  IN: 'India',
  IO: 'British Indian Ocean Territory',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KI: 'Kiribati',
  KM: 'Comoros',
  KN: 'Saint Kitts and Nevis',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Montenegro',
  MF: 'Saint Martin (French Part)',
  MG: 'Madagascar',
  MH: 'Marshall Islands',
  MK: 'North Macedonia',
  ML: 'Mali',
  MM: 'Burma',
  MN: 'Mongolia',
  MO: 'Macao',
  MP: 'Northern Mariana Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'New Zealand',
  OM: 'Oman',
  OS: 'South Ossetia',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PM: 'Saint Pierre and Miquelon',
  PN: 'Pitcairn',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russia',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'Saint Helena',
  SI: 'Slovenia',
  SJ: 'Svalbard and Jan Mayen',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  SS: 'South Sudan',
  ST: 'Sao Tome and Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Syria',
  SZ: 'Swaziland',
  TA: 'Tristan da Cunha',
  TC: 'Turks and Caicos Islands',
  TD: 'Chad',
  TF: 'French Southern Territories',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Turkey',
  TT: 'Trinidad and Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'United States Minor Outlying Islands',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VA: 'Holy See (Vatican City State)',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WF: 'Wallis and Futuna',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  ZZ: 'International',
};
function wi(n) {
  return String.fromCodePoint(127397 + n.toUpperCase().charCodeAt(0));
}
function Ei() {
  return (Ei =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function Ni(n, e) {
  if (null == n) return {};
  var t,
    r,
    o = (function (n, e) {
      if (null == n) return {};
      var t,
        r,
        o = {},
        a = Object.keys(n);
      for (r = 0; r < a.length; r++)
        (t = a[r]), e.indexOf(t) >= 0 || (o[t] = n[t]);
      return o;
    })(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (r = 0; r < a.length; r++)
      (t = a[r]),
        e.indexOf(t) >= 0 ||
          (Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]));
  }
  return o;
}
function Pi(e) {
  var t = e.value,
    r = e.onChange,
    o = e.options,
    a = Ni(e, ['value', 'onChange', 'options']),
    i = d(
      function (n) {
        var e = n.target.value;
        r('ZZ' === e ? void 0 : e);
      },
      [r],
    );
  return (
    l(
      function () {
        return ki(o, t);
      },
      [o, t],
    ),
    n.createElement(
      'select',
      Ei({}, a, { value: t || 'ZZ', onChange: i }),
      o.map(function (e) {
        var t = e.value,
          r = e.label,
          o = e.divider;
        return n.createElement(
          'option',
          {
            key: o ? '|' : t || 'ZZ',
            value: o ? '|' : t || 'ZZ',
            disabled: !!o,
            style: o ? Si : void 0,
          },
          r,
        );
      }),
    )
  );
}
Pi.propTypes = {
  value: je.string,
  onChange: je.func.isRequired,
  options: je.arrayOf(
    je.shape({ value: je.string, label: je.string, divider: je.bool }),
  ).isRequired,
};
var Si = { fontSize: '1px', backgroundColor: 'currentColor', color: 'inherit' };
function Oi(e) {
  var t = e.value,
    r = e.options,
    o = e.className,
    a = e.iconComponent;
  e.getIconAspectRatio;
  var i = e.arrowComponent,
    d = e.unicodeFlags,
    u = Ni(e, [
      'value',
      'options',
      'className',
      'iconComponent',
      'getIconAspectRatio',
      'arrowComponent',
      'unicodeFlags',
    ]),
    s = l(
      function () {
        return ki(r, t);
      },
      [r, t],
    );
  return n.createElement(
    'div',
    { className: 'PhoneInputCountry' },
    n.createElement(
      Pi,
      Ei({}, u, {
        value: t,
        options: r,
        className: wr('PhoneInputCountrySelect', o),
      }),
    ),
    d &&
      t &&
      n.createElement(
        'div',
        { className: 'PhoneInputCountryIconUnicode' },
        (function (n) {
          return wi(n[0]) + wi(n[1]);
        })(t),
      ),
    !(d && t) &&
      n.createElement(a, {
        country: t,
        label: s && s.label,
        aspectRatio: d ? 1 : void 0,
      }),
    n.createElement(i, null),
  );
}
function ki(n, e) {
  var t = n,
    r = Array.isArray(t),
    o = 0;
  for (t = r ? t : t[Symbol.iterator](); ; ) {
    var a;
    if (r) {
      if (o >= t.length) break;
      a = t[o++];
    } else {
      if ((o = t.next()).done) break;
      a = o.value;
    }
    var i = a;
    if (!i.divider && i.value === e) return i;
  }
}
function Ii() {
  return (Ii =
    Object.assign ||
    function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t)
          Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }).apply(this, arguments);
}
function Ti(e) {
  var t = n.forwardRef(function (e, t) {
    return n.createElement(xi, Ii({ ref: t }, e));
  });
  return (
    (t.propTypes = {
      metadata: qa.isRequired,
      labels: Wa.isRequired,
      countrySelectComponent: je.elementType.isRequired,
    }),
    (t.defaultProps = { metadata: e, labels: Ci, countrySelectComponent: Oi }),
    t
  );
}
(Oi.propTypes = {
  iconComponent: je.elementType,
  arrowComponent: je.elementType.isRequired,
  unicodeFlags: je.bool,
}),
  (Oi.defaultProps = {
    arrowComponent: function () {
      return n.createElement('div', {
        className: 'PhoneInputCountrySelectArrow',
      });
    },
  }),
  Ti();
var Ai,
  Ri,
  Bi,
  Mi,
  Fi = Ti(Cr),
  Di = u.div(
    Ai ||
      (Ai = x(
        [
          '\n  background-color: ',
          ';\n  border: 1px solid\n    ',
          ';\n  border-radius: ',
          ';\n\n  padding: 1.5em 0.75em 0.5em 0.7em;\n  position: relative;\n\n  .PhoneInput {\n    /* This is done to stretch the contents of this component. */\n    display: flex;\n    align-items: center;\n  }\n\n  .PhoneInputInput {\n    background: none;\n    border: none;\n    color: ',
          ';\n    font-family: ',
          ';\n    font-size: ',
          ";\n    flex: 1;\n    min-width: 0;\n    padding: 0.5rem;\n    outline: none;\n  }\n\n  .PhoneInputCountryIcon {\n    width: calc(1rem * 1.5);\n    height: 1rem;\n  }\n\n  .PhoneInputCountryIcon--square {\n    width: 1rem;\n  }\n\n  .PhoneInputCountryIcon--border {\n    background-color: rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 0 1px rgba(0, 0, 0, 0.5);\n  }\n\n  .PhoneInputCountryIconImg {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .PhoneInputInternationalIconPhone {\n    opacity: 0.8;\n  }\n\n  .PhoneInputInternationalIconGlobe {\n    opacity: var(0.65);\n  }\n\n  .PhoneInputCountry {\n    position: relative;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    margin-right: 0.35rem;\n  }\n\n  .PhoneInputCountrySelect {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    border: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .PhoneInputCountrySelect[disabled] {\n    cursor: default;\n  }\n\n  .PhoneInputCountrySelectArrow {\n    display: block;\n    content: '';\n    width: 0.3rem;\n    height: 0.3rem;\n    margin-left: 0.35rem;\n    border-style: solid;\n    border-color: inherit;\n    border-top-width: 0;\n    border-bottom-width: 1px;\n    border-left-width: 0;\n    border-right-width: 1px;\n    transform: rotate(45deg);\n    opacity: 0.45;\n  }\n\n  .PhoneInputCountrySelect:focus\n    + .PhoneInputCountryIcon\n    + .PhoneInputCountrySelectArrow {\n    opacity: 1;\n    color: #03b2cb;\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {\n    box-shadow: 0 0 0 1px #03b2cb, inset 0 0 0 1px #03b2cb;\n  }\n\n  .PhoneInputCountrySelect:focus\n    + .PhoneInputCountryIcon\n    .PhoneInputInternationalIconGlobe {\n    opacity: 1;\n    color: #03b2cb;\n  }\n",
        ],
        [
          '\n  background-color: ',
          ';\n  border: 1px solid\n    ',
          ';\n  border-radius: ',
          ';\n\n  padding: 1.5em 0.75em 0.5em 0.7em;\n  position: relative;\n\n  .PhoneInput {\n    /* This is done to stretch the contents of this component. */\n    display: flex;\n    align-items: center;\n  }\n\n  .PhoneInputInput {\n    background: none;\n    border: none;\n    color: ',
          ';\n    font-family: ',
          ';\n    font-size: ',
          ";\n    flex: 1;\n    min-width: 0;\n    padding: 0.5rem;\n    outline: none;\n  }\n\n  .PhoneInputCountryIcon {\n    width: calc(1rem * 1.5);\n    height: 1rem;\n  }\n\n  .PhoneInputCountryIcon--square {\n    width: 1rem;\n  }\n\n  .PhoneInputCountryIcon--border {\n    background-color: rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 0 1px rgba(0, 0, 0, 0.5);\n  }\n\n  .PhoneInputCountryIconImg {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .PhoneInputInternationalIconPhone {\n    opacity: 0.8;\n  }\n\n  .PhoneInputInternationalIconGlobe {\n    opacity: var(0.65);\n  }\n\n  .PhoneInputCountry {\n    position: relative;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    margin-right: 0.35rem;\n  }\n\n  .PhoneInputCountrySelect {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    border: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .PhoneInputCountrySelect[disabled] {\n    cursor: default;\n  }\n\n  .PhoneInputCountrySelectArrow {\n    display: block;\n    content: '';\n    width: 0.3rem;\n    height: 0.3rem;\n    margin-left: 0.35rem;\n    border-style: solid;\n    border-color: inherit;\n    border-top-width: 0;\n    border-bottom-width: 1px;\n    border-left-width: 0;\n    border-right-width: 1px;\n    transform: rotate(45deg);\n    opacity: 0.45;\n  }\n\n  .PhoneInputCountrySelect:focus\n    + .PhoneInputCountryIcon\n    + .PhoneInputCountrySelectArrow {\n    opacity: 1;\n    color: #03b2cb;\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {\n    box-shadow: 0 0 0 1px #03b2cb, inset 0 0 0 1px #03b2cb;\n  }\n\n  .PhoneInputCountrySelect:focus\n    + .PhoneInputCountryIcon\n    .PhoneInputInternationalIconGlobe {\n    opacity: 1;\n    color: #03b2cb;\n  }\n",
        ],
      )),
    function (n) {
      var e = n.theme;
      return n.disabled ? e.formGroupBgDisabled : e.formGroupBg;
    },
    function (n) {
      return n.theme.formGroupBorder;
    },
    '3px',
    function (n) {
      return n.theme.phoneInputText;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
  ),
  Li = u.label(
    Ri ||
      (Ri = x(
        [
          '\n  color: ',
          ';\n  display: block;\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  padding-bottom: 0.35em;\n  top: 0.25em;\n  transform: translateY(0);\n\n  left: 0.75em;\n  position: absolute;\n',
        ],
        [
          '\n  color: ',
          ';\n  display: block;\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n\n  padding-bottom: 0.35em;\n  top: 0.25em;\n  transform: translateY(0);\n\n  left: 0.75em;\n  position: absolute;\n',
        ],
      )),
    function (n) {
      return n.theme.formGroupText;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
  ),
  ji = u.span(
    Bi ||
      (Bi = x(
        ['\n  color: grey;\n  font-family: ', ';\n  padding-left: 0.25em;\n'],
        ['\n  color: grey;\n  font-family: ', ';\n  padding-left: 0.25em;\n'],
      )),
    function (n) {
      return n.theme.fontBody;
    },
  ),
  zi = u.div(
    Mi ||
      (Mi = x(
        [
          '\n  color: ',
          ';\n\n  display: flex;\n  align-items: center;\n\n  font-family: ',
          ';\n  font-size: ',
          ";\n\n  height: 20px;\n  padding: 0.5em 0;\n  overflow: hidden;\n  transition: all 0.1s ease-out;\n  opacity: 1;\n\n  &[data-hidden='true'] {\n    opacity: 0;\n  }\n",
        ],
        [
          '\n  color: ',
          ';\n\n  display: flex;\n  align-items: center;\n\n  font-family: ',
          ';\n  font-size: ',
          ";\n\n  height: 20px;\n  padding: 0.5em 0;\n  overflow: hidden;\n  transition: all 0.1s ease-out;\n  opacity: 1;\n\n  &[data-hidden='true'] {\n    opacity: 0;\n  }\n",
        ],
      )),
    function (n) {
      return n.theme.formGroupTextError;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeSmall;
    },
  );
function Gi(t) {
  var r = t.error,
    o = t.errorMessage,
    a = t.label,
    i = t.name,
    d = t.required,
    l = t.disabled,
    u = t.onBlur,
    s = t.updateValue,
    c = y(t, [
      'error',
      'errorMessage',
      'label',
      'name',
      'required',
      'disabled',
      'onBlur',
      'updateValue',
    ]),
    f = e(''),
    m = f[0],
    p = f[1];
  var $ = d ? '' : n.createElement(ji, null, '(Optional)'),
    h = null;
  return (
    a && (h = n.createElement(Li, { htmlFor: i }, a, $)),
    (c.loading = void 0),
    n.createElement(
      n.Fragment,
      null,
      n.createElement(
        Di,
        { disabled: l },
        h,
        n.createElement(
          Fi,
          g(
            {
              disabled: l,
              onBlur: u,
              onChange: function (n) {
                p(n), s && !l && s(n);
              },
            },
            c,
            { value: m },
          ),
        ),
      ),
      n.createElement(
        zi,
        { 'data-hidden': !r },
        n.createElement(T, null),
        ' ',
        o,
      ),
    )
  );
}
(Di.defaultProps = { theme: J }),
  (Li.defaultProps = { theme: J }),
  (ji.defaultProps = { theme: J }),
  (zi.defaultProps = { theme: J }),
  (Gi.defaultProps = {
    error: !1,
    errorMessage: null,
    label: '',
    name: '',
    required: !1,
    disabled: !1,
  });
var _i = function (e) {
  var t = e.className,
    r = e.message,
    o = e.size;
  return n.createElement(
    ln,
    { className: t },
    n.createElement(un, { size: o || '4em' }),
    n.createElement(sn, null, r),
  );
};
(_i.propTypes = { message: je.string }), (_i.defaultProps = { message: '' });
var Vi,
  Hi,
  Ui,
  qi = u.div(
    Vi ||
      (Vi = x(
        [
          '\n  border-bottom: 2px solid\n    ',
          ';\n  padding-bottom: 0.5em;\n\n  cursor: ',
          ';\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n\n  overflow: hidden;\n\n  margin-right: ',
          ';\n',
        ],
        [
          '\n  border-bottom: 2px solid\n    ',
          ';\n  padding-bottom: 0.5em;\n\n  cursor: ',
          ';\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n\n  overflow: hidden;\n\n  margin-right: ',
          ';\n',
        ],
      )),
    function (n) {
      var e = n.disabled,
        t = n.error,
        r = n.theme;
      return t ? r.error400 : e ? r.stepsDisabledColour : r.stepsColour;
    },
    function (n) {
      var e = n.disabled,
        t = n.progress;
      return e || t ? 'default' : 'pointer';
    },
    function (n) {
      return n.showBorder ? '0.5em' : '';
    },
  ),
  Wi = u.div(
    Hi ||
      (Hi = x(
        [
          '\n  border-radius: 50%;\n\n  color: white;\n\n  width: ',
          ';\n  height: ',
          ';\n  min-width: ',
          ';\n  min-height: ',
          ';\n\n  font-family: ',
          ';\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin-right: 0.5em;\n\n  background-color: ',
          ';\n  color: ',
          ';\n  border: 2px solid\n    ',
          ';\n',
        ],
        [
          '\n  border-radius: 50%;\n\n  color: white;\n\n  width: ',
          ';\n  height: ',
          ';\n  min-width: ',
          ';\n  min-height: ',
          ';\n\n  font-family: ',
          ';\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin-right: 0.5em;\n\n  background-color: ',
          ';\n  color: ',
          ';\n  border: 2px solid\n    ',
          ';\n',
        ],
      )),
    '32px',
    '32px',
    '32px',
    '32px',
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      var e = n.completed,
        t = n.error,
        r = n.theme;
      return e ? r.stepsColour : t ? r.error100 : 'transparent';
    },
    function (n) {
      var e = n.completed,
        t = n.disabled,
        r = n.error,
        o = n.theme;
      return e
        ? 'white'
        : r
        ? o.error400
        : t
        ? o.stepsDisabledColour
        : o.stepsTextColour;
    },
    function (n) {
      var e = n.disabled,
        t = n.error,
        r = n.theme;
      return t ? r.error : e ? r.stepsDisabledColour : r.stepsColour;
    },
  ),
  Ki = u.div(
    Ui ||
      (Ui = x(
        [
          '\n  display: inline-block;\n  position: relative;\n\n  font-family: ',
          ';\n\n  color: ',
          ';\n\n  padding-right: ',
          ';\n',
        ],
        [
          '\n  display: inline-block;\n  position: relative;\n\n  font-family: ',
          ';\n\n  color: ',
          ';\n\n  padding-right: ',
          ';\n',
        ],
      )),
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      var e = n.completed,
        t = n.disabled,
        r = n.error,
        o = n.theme;
      return e
        ? o.stepsColour
        : r
        ? o.error400
        : t
        ? o.stepsDisabledColour
        : o.stepsTextColour;
    },
    function (n) {
      return n.showBorder ? '0.5em' : '';
    },
  );
(qi.defaultProps = { theme: J }),
  (Wi.defaultProps = { theme: J }),
  (Ki.defaultProps = { theme: J });
var Yi = function (e) {
  var t = e.index,
    r = e.completed,
    o = e.description,
    a = e.disabled,
    i = e.error,
    d = e.icon,
    l = e.onClick,
    u = e.progress,
    s = e.showBorder,
    c = t;
  i
    ? (c = n.createElement(M, null))
    : r
    ? (c = n.createElement(I, null))
    : d && (c = d);
  var f = { completed: r, error: i, progress: u, disabled: a };
  return n.createElement(
    qi,
    g(
      {
        onClick: function () {
          l && !a && l();
        },
        showBorder: s,
      },
      f,
    ),
    n.createElement(Wi, g({}, f), c),
    n.createElement(Ki, g({}, f), o),
  );
};
Yi.defaultProps = {
  index: -1,
  completed: !1,
  description: '',
  disabled: !1,
  error: !1,
  icon: null,
  onClick: void 0,
  progress: !1,
  showBorder: !0,
};
var Zi,
  Ji = u.div(
    Zi || (Zi = x(['\n  display: flex;\n'], ['\n  display: flex;\n'])),
  ),
  Xi = function (e) {
    var t = e.children,
      r = e.progress;
    if (t) {
      var o = n.Children.count(t),
        a = n.Children.map(t, function (e, t) {
          return n.cloneElement(e, {
            index: t + 1,
            showBorder: t + 1 !== o,
            progress: r === t,
            completed: r >= t + 1,
            disabled: t > r,
          });
        });
      return n.createElement(Ji, null, a);
    }
    return null;
  };
(Xi.Item = Yi), (Xi.defaultProps = { progress: 0, children: null });
var Qi,
  nd,
  ed,
  td,
  rd,
  od = u.table(
    Qi ||
      (Qi = x(
        [
          '\n  border-collapse: collapse;\n  font-family: ',
          ';\n\n  text-align: left;\n  width: 100%;\n\n  thead {\n    color: ',
          ';\n\n    th {\n      font-weight: 500;\n      text-transform: uppercase;\n    }\n  }\n\n  tbody {\n    background-color: ',
          ';\n  }\n\n  td,\n  th {\n    white-space: nowrap;\n    padding: 1.2em 1em;\n  }\n',
        ],
        [
          '\n  border-collapse: collapse;\n  font-family: ',
          ';\n\n  text-align: left;\n  width: 100%;\n\n  thead {\n    color: ',
          ';\n\n    th {\n      font-weight: 500;\n      text-transform: uppercase;\n    }\n  }\n\n  tbody {\n    background-color: ',
          ';\n  }\n\n  td,\n  th {\n    white-space: nowrap;\n    padding: 1.2em 1em;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.fontHeader;
    },
    function (n) {
      return n.theme.tableHeaderText;
    },
    function (n) {
      return n.theme.tableBodyBg;
    },
  ),
  ad = u.div(
    ed ||
      (ed = x(
        [
          '\n  box-shadow: 0 3px 6px 3px rgba(0, 0, 0, 0.1);\n\n  overflow-x: scroll;\n\n  ',
          '\n',
        ],
        [
          '\n  box-shadow: 0 3px 6px 3px rgba(0, 0, 0, 0.1);\n\n  overflow-x: scroll;\n\n  ',
          '\n',
        ],
      )),
    Rn('tablet')(
      nd ||
        (nd = x(
          ['\n    overflow-x: auto;\n  '],
          ['\n    overflow-x: auto;\n  '],
        )),
    ),
  ),
  id = u.div(
    td ||
      (td = x(
        [
          '\n  display: flex;\n\n  &.selected-up {\n    transform: rotate(-90deg);\n  }\n\n  &.selected-down {\n    transform: rotate(90deg);\n  }\n',
        ],
        [
          '\n  display: flex;\n\n  &.selected-up {\n    transform: rotate(-90deg);\n  }\n\n  &.selected-down {\n    transform: rotate(90deg);\n  }\n',
        ],
      )),
  ),
  dd = u.div(
    rd ||
      (rd = x(
        ['\n  display: flex;\n  align-items: center;\n'],
        ['\n  display: flex;\n  align-items: center;\n'],
      )),
  );
od.defaultProps = { theme: J };
var ld = { cursor: 'pointer' };
function ud(t) {
  t.children;
  var r = t.columns,
    o = t.data,
    a = y(t, ['children', 'columns', 'data']),
    i = e(''),
    d = i[0],
    l = i[1],
    u = e(!1),
    s = u[0],
    c = u[1];
  if (!r || !o) return null;
  var f = n.createElement(
      'thead',
      null,
      n.createElement(
        'tr',
        null,
        r.map(function (e) {
          var t = n.createElement(
            id,
            {
              className:
                d === e.id ? (s ? 'selected-up' : 'selected-down') : void 0,
              id: e.id,
              key: e.id,
            },
            n.createElement(Xt, null),
          );
          return n.createElement(
            'th',
            { key: e.id, style: { width: e.width || 'auto' } },
            n.createElement(
              dd,
              {
                style: e.sorted ? ld : void 0,
                onClick: e.sorted
                  ? function () {
                      var n;
                      (n = e.id) === d ? c(!s) : (c(!1), l(n));
                    }
                  : void 0,
                'data-testid': 'column-' + e.id,
              },
              e.text,
              e.sorted ? t : void 0,
            ),
          );
        }),
      ),
    ),
    m = [],
    p = (function (n, e) {
      for (var t = 0, r = e.length, o = n.length; t < r; t++, o++) n[o] = e[t];
      return n;
    })([], o),
    $ = r.find(function (n) {
      return n.id === d;
    });
  p.sort(function (n, e) {
    var t = s ? -1 : 1,
      r = n[d],
      o = e[d];
    return (null == $ ? void 0 : $.sorter)
      ? $.sorter(r, o) * t
      : r < o
      ? -1 * t
      : r > o
      ? 1 * t
      : 0;
  }),
    p.forEach(function (e) {
      var t = r.map(function (t) {
        return t.render
          ? n.createElement('td', { key: t.id }, t.render(e[t.id]))
          : n.createElement('td', { key: t.id }, e[t.id]);
      });
      m.push(n.createElement('tr', { key: e.id, style: e.style }, t));
    });
  var h = n.createElement('tbody', null, m);
  return n.createElement(ad, g({}, a), n.createElement(od, null, f, h));
}
var sd,
  cd = { saberLight: J },
  fd = u.span(
    sd ||
      (sd = x(
        ['\n  color: ', ';\n\n  font-family: ', ';\n  font-size: ', ';\n'],
        ['\n  color: ', ';\n\n  font-family: ', ';\n  font-size: ', ';\n'],
      )),
    function (n) {
      return n.theme.fontColour;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
  );
fd.defaultProps = { theme: J };
var md,
  pd,
  $d = u.div(
    md ||
      (md = x(
        [
          '\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n\n  ',
          ' {\n    white-space: nowrap;\n    padding: 0.5em 1em;\n  }\n',
        ],
        [
          '\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n\n  ',
          ' {\n    white-space: nowrap;\n    padding: 0.5em 1em;\n  }\n',
        ],
      )),
    yn,
  ),
  hd = u.div(
    pd ||
      (pd = x(
        ['\n  color: ', ';\n  font-family: ', ';\n  flex-grow: 1;\n'],
        ['\n  color: ', ';\n  font-family: ', ';\n  flex-grow: 1;\n'],
      )),
    function (n) {
      return n.theme.editText;
    },
    function (n) {
      return n.theme.fontBody;
    },
  );
function gd(e) {
  var t = e.children,
    r = e.onClick,
    o = e.editLabel,
    a = e.disabled,
    i = y(e, ['children', 'onClick', 'editLabel', 'disabled']),
    d =
      o ||
      n.createElement(n.Fragment, null, n.createElement(R, null), '  Edit');
  return n.createElement(
    $d,
    g({}, i),
    n.createElement(hd, null, t),
    n.createElement(yn, { type: 'button', onClick: r, disabled: a }, d),
  );
}
(hd.defaultProps = { theme: J }),
  (gd.defaultProps = { disabled: !1, editLabel: '', onClick: void 0 });
var yd,
  bd,
  vd,
  xd,
  Cd,
  wd,
  Ed = ['2.1rem', '1.9rem', '1.5rem', '1.25rem', '1.125rem'],
  Nd = c(
    yd ||
      (yd = x(
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  font-weight: normal;\n  margin: 0.5rem 0 1.5rem;\n',
        ],
        [
          '\n  color: ',
          ';\n  font-family: ',
          ';\n  font-weight: normal;\n  margin: 0.5rem 0 1.5rem;\n',
        ],
      )),
    function (n) {
      return n.theme.fontColour;
    },
    function (n) {
      return n.theme.fontHeader;
    },
  ),
  Pd = u.h1(
    bd ||
      (bd = x(
        ['\n  ', '\n  font-size: ', ';\n'],
        ['\n  ', '\n  font-size: ', ';\n'],
      )),
    Nd,
    Ed[0],
  ),
  Sd = u.h2(
    vd ||
      (vd = x(
        ['\n  ', '\n  font-size: ', ';\n'],
        ['\n  ', '\n  font-size: ', ';\n'],
      )),
    Nd,
    Ed[1],
  ),
  Od = u.h3(
    xd ||
      (xd = x(
        ['\n  ', '\n  font-size: ', ';\n'],
        ['\n  ', '\n  font-size: ', ';\n'],
      )),
    Nd,
    Ed[2],
  ),
  kd = u.h4(
    Cd ||
      (Cd = x(
        ['\n  ', '\n  font-size: ', ';\n'],
        ['\n  ', '\n  font-size: ', ';\n'],
      )),
    Nd,
    Ed[3],
  ),
  Id = u.h5(
    wd ||
      (wd = x(
        ['\n  ', '\n  font-size: ', ';\n'],
        ['\n  ', '\n  font-size: ', ';\n'],
      )),
    Nd,
    Ed[4],
  );
function Td(e) {
  var t = e.children,
    r = e.level,
    o = y(e, ['children', 'level']);
  switch (Math.max(1, Math.min(r, 5))) {
    case 2:
      return n.createElement(Sd, g({}, o), t);
    case 3:
      return n.createElement(Od, g({}, o), t);
    case 4:
      return n.createElement(kd, g({}, o), t);
    case 5:
      return n.createElement(Id, g({}, o), t);
  }
  return n.createElement(Pd, g({}, o), t);
}
(Pd.defaultProps = { theme: J }),
  (Sd.defaultProps = { theme: J }),
  (Od.defaultProps = { theme: J }),
  (kd.defaultProps = { theme: J }),
  (Id.defaultProps = { theme: J }),
  (Td.defaultProps = { level: 1 });
var Ad,
  Rd = u.p(
    Ad ||
      (Ad = x(
        [
          '\n  color: ',
          ';\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n  letter-spacing: 0.25px;\n  line-height: 1.5rem;\n\n  margin: 0.5rem 0 1.5rem 0;\n\n  @media only screen and (min-width: 1024px) {\n    line-height: 1.75rem;\n  }\n\n  @media only screen and (min-width: 1280px) {\n    line-height: 2rem;\n  }\n',
        ],
        [
          '\n  color: ',
          ';\n\n  font-family: ',
          ';\n  font-size: ',
          ';\n  letter-spacing: 0.25px;\n  line-height: 1.5rem;\n\n  margin: 0.5rem 0 1.5rem 0;\n\n  @media only screen and (min-width: 1024px) {\n    line-height: 1.75rem;\n  }\n\n  @media only screen and (min-width: 1280px) {\n    line-height: 2rem;\n  }\n',
        ],
      )),
    function (n) {
      return n.theme.fontColour;
    },
    function (n) {
      return n.theme.fontBody;
    },
    function (n) {
      return n.theme.fontSizeBase;
    },
  );
Rd.defaultProps = { theme: J };
var Bd = function (e) {
  var t = e.children,
    r = y(e, ['children']);
  return n.createElement(fd, g({}, r), t);
};
(Bd.EditText = gd),
  (Bd.Header = Td),
  (Bd.Paragraph = function (e) {
    var t = e.children,
      r = y(e, ['children']);
    return n.createElement(Rd, g({}, r), t);
  });
export {
  an as Alert,
  En as Button,
  Fn as Container,
  zn as ErrorMessage,
  At as Form,
  _i as Loader,
  dr as Menu,
  xr as Modal,
  Gi as PhoneInput,
  Xi as Steps,
  ud as Table,
  cd as Themes,
  Bd as Typography,
};

//# sourceMappingURL=index.modern.js.map
